<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <detalhespedido v-bind:idpedido="vidpedidodet" v-bind:rotinacorte="false"></detalhespedido>
            <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">PAINEL DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div> 
	                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
	                                <label for="sbsituacao">Situação:</label>
	                                <select name="sbsituacao" class="form-control form-control-sm" id="sbsituacao" v-model="psituacaopesq" @change="mtdlimpar_listagem()">
	                                    <option value="99">Todas</option>
	                                    <option value="6">Pendentes (digitação e enviada)</option>
	                                    <option value="0">Em digitação</option>
	                                    <option value="1">Enviadas</option>
	                                    <option value="2">Autorizadas</option>
	                                    <option value="3">Canceladas</option>
	                                    <option value="4">Denegadas</option>
	                                    <option value="5">Inutilizadas</option>
	                                </select>
	                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="ednnfpesq">Número da NF:</label>
                                <input id="ednnfpesq" type="text" v-mask="'########'" class="form-control form-control-sm" v-model="pnnf" @keyup="mtdlimpar_listagem()">
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbtpdestinatariopesq">Tp. Destinatário:</label>
                                <select name="cbtpdestinatario" class="form-control form-control-sm" id="cbtpdestinatariopesq" v-model="ptpdestinatario" @change="mtddefselect2destinatariopesq()">
                                    <option value="0">Cliente</option>
                                    <option value="1">Fornecedor</option>
                                </select>
                            </div>                            
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Destinatário:</span>
								<select id="cbdestinatariopesq" data-placeholder="Selecione um destinatário" v-model="piddestinatario" data-allow-clear="true" style="width:100%;">
								</select>
							</div> 
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Modelo:</label>
                                <select name="cbmodelopesq" class="form-control form-control-sm" id="cbmodelopesq" v-model="pmodelo" @change="mtdlimpar_listagem()">
                                    <option value="55">55 - NF-e</option>
                                    <option value="65">65 - NFC-e</option>
                                    <option value="99">Todos</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">Natureza de operação:</span>
                                <select id="cbnatoppesq" data-placeholder="Selecione um registro" v-model="pidnatop" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                             
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edseriepesq">Série:</label>
                                <input id="edseriepesq" type="text" v-mask="'###'" class="form-control form-control-sm" v-model="pserie" @keyup="mtdlimpar_listagem()">
                            </div>                                                                                 
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbtpemispesq">Tp. emissão:</label>
                                <select name="cbtpemispesq" class="form-control form-control-sm" id="cbtpemispesq" v-model="ptpemis" @change="mtdlimpar_listagem()">
                                    <option value="0">Normal</option>
                                    <option value="1">Contingência</option>
                                    <option value="2">Todas</option>
                                    
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Itens exibidos:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Consultar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table  ref="reflstnotasfiscais"
                                        :rows="lstnotasfiscais"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="slot_nnf" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.nnf, 8) }}
                                    </template>
                                    <template slot="slot_situacaonota" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacaonota) === 0" class="badge badge-primary bdg-digitacao">Em digitação</span>
                                        <span v-else-if="parseInt(item.row.situacaonota) === 1" class="badge badge-primary bdg-enviada">Enviada</span>
                                        <span v-else-if="parseInt(item.row.situacaonota) === 2" class="badge badge-primary bdg-autorizada">Autorizada</span>
                                        <span v-else-if="parseInt(item.row.situacaonota) === 3" class="badge badge-primary bdg-cancelada">Cancelada</span>
                                        <span v-else class="badge badge-primary bdg-denegada">Denegada</span>
                                    </template>                                                                        
                                    <template slot="slot_serie" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.serie, 3) }}
                                    </template> 
                                    <template slot="slot_dthremissao" slot-scope="item">
                                        {{ item.row.dthremissao }}
                                    </template> 
                                    <template slot="slot_valor" slot-scope="item">
                                        {{ mtdformatavalordecimal(parseFloat(item.row.vnf), 2) }}
                                    </template>
                                    <template slot="slot_xmotivo" slot-scope="item">
                                        {{ item.row.xmotivo }}
                                    </template>
                                    <template slot="slot_infohist" slot-scope="item">
                                        <i class="fa fa-clock-o" style="cursor: pointer;" @click.prevent="mostrarhistoricoenvio(item.row)" title="Histórico de retorno sefaz"></i>
                                    </template>
                                    <template slot="slot_chave" slot-scope="item">
                                        <span style="font-size: 12px; color: #6c757d; font-weight: bold;">{{ item.row.chave }}</span>
                                    </template>                                                                                                                                                                                
                                    <template slot="opcoes" slot-scope="item">
										<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>                                        
                                    </template>
                                    <template slot="slot_infocont" slot-scope="item">
                                        <i v-if="parseInt(item.row.contigenciaoffline) === 1" class="fa fa-bullseye" title="emitida em contingência"></i>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        <span>Totalizadores <span class="badge badge-info badge-pill">{{lstnotasfiscais.length}}</span></span>
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="background-color: #5A956A;">{{mtdformatavalordecimal(parseFloat(ptotalnotas), 2)}}</span>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="lstinutilizacoes.length > 0" class="col-lg-12" style="margin-top: 10px;">
                                <div class="table-responsive">
                                    <table id="tblistainut" class="table table-bordered table-striped table-sm table-hover">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th width="50px" style="text-align: center;">Id.:</th>
                                            <th>Filial:</th>                                                            
                                            <th>Emissão:</th>                                                            
                                            <th>Modelo:</th>
                                            <th>Série:</th>
                                            <th>Faixa de inutilização:</th>
                                            <th>Motivo:</th>
                                        </tr>
                                        </thead>
                                        <tbody id="lstinut">
                                            <tr v-for="(inutilizacao, index) in lstinutilizacoes" v-bind:key="index">
                                                <td style="text-align: center;">{{ mtdformatarzeros(inutilizacao.id, 4) }}</td> 
                                                <td>{{ inutilizacao.fantasia }}</td>
                                                <td>{{ inutilizacao.dthremissao }}</td>
                                                <td v-if="parseInt(inutilizacao.nmodelo) === 55">55 NF-e</td>
                                                <td v-else>65 NFC-e</td>
                                                <td>{{ inutilizacao.nserie }}</td>
                                                <td>{{ mtdformatarzeros(inutilizacao.nini, 8) }} - {{ mtdformatarzeros(inutilizacao.nfim, 8) }}</td>
                                                <td>{{ inutilizacao.xjust }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-if="lstinutilizacoes.length > 0" class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Quantidade de inutilizações
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="background-color: #f82b54;">{{lstinutilizacoes.length}}</span>
                                    </li>
                                </ul>
                            </div>   
                            
                            <div v-if="lstdemonstrativoscfop.length > 0" class="col-md-12">
                                <div class="row justify-content-center" style="margin-top: 10px;">
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <ul class="list-group">
                                            <a class="list-group-item text-center tit-list-group-item font-weight-bold text-black-50" style="color: #cccccc!important; background-color: #343a40; padding: 5px;">DEMONSTRATIVO CFOP'S</a>
                                            <a v-for="(cfop, indice) in lstdemonstrativoscfop" class="list-group-item ">{{ cfop.idcfop }} 
                                                <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(cfop.vltotal) }}</span>
                                            </a>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-4 col-sm-4 col-md-8 col-lg-8" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <div class="dropdown">
                                <button type="button" class="btn btn-info btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                    <i class="fa fa-navicon"></i> Outras
                                </button> 
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="#" @click.prevent="mtdconsultarstatus()"><i class="fa fa-flash"></i> Status da SEFAZ</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdinutilizacao()"><i class="fa fa-minus-circle"></i> Inutilização</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdexportarlista(1)"><i class="fa fa-print"></i> Imprimir</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdexportarlista(0)"><i class="fa fa-file-excel-o"></i> Exportar</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdagruparpedidosnf()"><i class="fa fa-object-group"></i> Agrupar pedidos</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdexportxml()"><i class="fa fa-download"></i> Salva xmls</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdenviaremlote()"><i class="fa fa-paper-plane"></i> Enviar em lote</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdconsultaemlote()"><i class="fa fa-bolt"></i> Consultar em lote</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdsetarcampositens()"><i class="fa fa-leanpub"></i> Setar NCM em massa</a>
                                    <!-- <a class="dropdown-item" href="#" @click.prevent="mtddeclaracaoimportaimp()"><i class="fa fa-leanpub"></i> Importar DI (declaração de importação)</a> -->
                                </div>
                                </div>                                
                            </div>                             
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Criar</button>
                            </div>                           
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilial" data-placeholder="Selecione uma filial" v-model="vidfilial" v-bind:disabled="parseInt(opcrud) !== 1" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbcrt">Regime tributário:</label>
                                <select name="cbmod" class="form-control form-control-sm" id="cbcrt" v-model="vcrt">
                                    <option value="1">Simples Nacional</option>
                                    <option value="2">Simples Nacional - excesso de sublimite de receita bruta</option>
                                    <option value="3">Regime Normal</option>
                                </select>
                            </div>                                   
                            <template v-if="verificapermis('020Z.020Z.060Z') || parseInt(opcrud)!==2 || parseInt(vencontingencia) !== 1">
                                <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                    <label for="cbmodelo">Modelo:</label>
                                    <select name="cbmodelo" class="form-control form-control-sm" id="cbmodelo" v-model="vmodelo" v-bind:disabled="ativadesativa || parseInt(vencontingencia) === 1" @change.prevent="mtdverificamudancamodelo()">
                                        <option value="55">55 - NFe</option>
                                        <option value="65">65 - NFCe</option>
                                    </select>
                                </div> 
                                <div class="col-12 col-sm-12 col-md-1 col-lg-1">
                                    <label for="edserie">Série:</label>
                                    <input id="edserie" type="text" v-mask="'###'" class="form-control form-control-sm" v-model="vserie" v-bind:disabled="parseInt(opcrud) !== 2 || parseInt(vencontingencia) === 1">
                                </div> 
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="ednnf">Nr. Nota Fiscal:</label>
                                    <input type="text" class="form-control form-control-sm" id="ednnf" v-model="vnnf"
                                        maxlength="20" v-bind:disabled="parseInt(opcrud)!==2 || parseInt(vencontingencia) === 1"/>
                                </div>
                            </template> 
                            <template v-else>
                                <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                    <label for="cbmodelo">Modelo:</label>
                                    <select name="cbmodelo" class="form-control form-control-sm" id="cbmodelo" v-model="vmodelo" disabled >
                                        <option value="55">55 - NFe</option>
                                        <option value="65">65 - NFCe</option>
                                    </select>
                                </div> 
                                <div class="col-12 col-sm-12 col-md-1 col-lg-1">
                                    <label for="edserie">Série:</label>
                                    <input id="edserie" type="text" v-mask="'###'" class="form-control form-control-sm" v-model="vserie" disabled>
                                </div> 
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="ednnf">Nr. Nota Fiscal:</label>
                                    <input type="text" class="form-control form-control-sm" id="ednnf" v-model="vnnf"
                                        maxlength="20" disabled/>
                                </div>
                            </template> 
                          
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="eddthremissao">Data Emissão:</label>
								<div class="input-group">
									<date-picker id="eddthremissao" v-model="vdthremissao" :config="options"
										class="form-control form-control-sm" v-bind:disabled="parseInt(opcrud) === 3||parseInt(vencontingencia) === 1"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                            
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <label for="cbtpnf">Tipo:</label>
                                <select name="cbtpnf" class="form-control form-control-sm" id="cbtpnf" v-model="vtpnf" v-bind:disabled="ativadesativa">
                                    <option value="0">0 - Entrada</option>
                                    <option value="1">1 - Saída</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <label for="cbtpdestinatario">Tp. Dest:</label>
                                <select name="cbtpdestinatario" class="form-control form-control-sm" id="cbtpdestinatario" v-model="vtpdestinatario" v-bind:disabled="ativadesativa" @change="mtddefselect2destinatario()">
                                    <option value="0">Cliente</option>
                                    <option value="1">Fornecedor</option>
                                </select>
                            </div>                            
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">*Destinatário:</span>
								<select id="cbdestinatario" data-placeholder="Selecione um destinatário" v-model="viddestinatario" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div> 
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbindicadorp">Indicador de presença do consumidor:</label>
                                <select name="cbindicadorp" class="form-control form-control-sm" id="cbindicadorp" v-model="vindpres" v-bind:disabled="ativadesativa">
                                    <option value="0">0 - Não se aplica (por exemplo, Nota Fiscal complementar ou de ajuste)</option>
                                    <option value="1">1 - Operação presencial</option>
                                    <option value="2">2 - Operação não presencial, pela Internet</option>
                                    <option value="3">3 - Operação não presencial, Tele atendimento</option>
                                    <option value="4">4 - NFC-e em operação com entrega a domicílio</option>
                                    <option value="5">5 - Operação presencial, fora do estabelecimento</option>
                                    <option value="9">9 - Operação não presencial, outros</option>
                                </select>
                            </div> 
                            <div  class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbdest">Tipo de consumidor:</label>
                                <select name="cbtpcon" class="form-control form-control-sm" id="cbtpcon" v-model="vindfinal" v-bind:disabled="ativadesativa">
                                    <option value="0">0 - Normal</option>
                                    <option value="1">1 - Final</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">*Natureza de operação:</span>
                                <select id="cbnatop" data-placeholder="Selecione um registro" v-model="vidnatop" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbfinnfe">Finalidade da emissão:</label>
                                <select name="cbfinnfe" class="form-control form-control-sm" id="cbfinnfe" v-model="vfinnfe" v-bind:disabled="ativadesativa">
                                    <option value="1">1 - Normal</option>
                                    <option value="2">2 - Complementar</option>
                                    <option value="3">3 - De ajuste</option>
                                    <option value="4">4 - Devolução</option>
                                    <option value="5">5 - Nota de crédito</option>
                                    <option value="6">6 - Nota de débito</option>
                                </select>
                            </div> 
                            <div v-show="vfinnfe == 6" class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbtpnfedeb">Tipo de NF-e - Débito:</label>
                                <select name="cbtpnfedeb" class="form-control form-control-sm" id="cbtpnfedeb" v-model="vtpnfedebito" v-bind:disabled="ativadesativa">
                                    <option value="0">Selecione...</option>
                                    <option value="01">01 - Transferência de créditos para Cooperativas</option>
                                    <option value="02">02 - Anulação de Crédito por Saídas Imunes/Isentas</option>
                                    <option value="03">03 - Débitos de notas fiscais não processadas na apuração</option>
                                    <option value="04">04 - Multa e juros</option>
                                    <option value="05">05 - Transferência de crédito de sucessão</option>
                                    <option value="06">06 - Pagamento antecipado</option>
                                    <option value="07">07 - Perda em estoque</option>
                                </select>
                            </div> 
                            <div v-show="vfinnfe == 5" class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbtpnfedeb">Tipo de NF-e - Crédito:</label>
                                <select name="cbtpnfecred" class="form-control form-control-sm" id="cbtpnfecred" v-model="vtpnfecredito" v-bind:disabled="ativadesativa">
                                    <option value="0">Selecione...</option>
                                    <option value="01">01 - Multa e juros</option>
                                    <option value="02">02 - Apropriação de crédito presumido de IBS sobre o saldo devedor na ZFM (art. 450, § 1º, LC 214/25)</option>
                                </select>
                            </div> 
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edcnpjinter">CNPJ intermediador:</label>
                                <input id="edcnpjinter" type="text" v-mask="'##.###.###/####-##'" class="form-control form-control-sm" v-model="vcnpjinter" v-bind:disabled="ativadesativa">
                            </div>  
                            <div class="col-12 col-sm-12 col-md-1 col-lg-1">
                                    <label for="ednomeinter">Nome:</label>
                                    <input id="ednomeinter" type="text" maxlength="60"  class="form-control form-control-sm" v-model="vnomeinter" v-bind:disabled="ativadesativa">
                            </div>  
                            <div  class="col-6 col-sm-6 col-md-2 col-lg-2" style="margin-left: auto;">
                                <label for="cbcalctrib">Calcular Ibpt:</label>
                                <select name="cbcalctrib" class="form-control form-control-sm" id="cbcalctrib" v-model="vcalctrib" v-bind:disabled="ativadesativa">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>                               
                            <div  class="col-6 col-sm-6 col-md-2 col-lg-2" style="margin-left: auto;">
                                <label for="cbdest">Destino da operação:</label>
                                <select name="cbdest" class="form-control form-control-sm" id="cbdest" v-model="viddest" v-bind:disabled="ativadesativa">
                                    <option value="1">1 - Interna</option>
                                    <option value="2">2 - Interestadual</option>
                                    <option value="3">3 - Exterior</option>
                                </select>
                            </div>                               
                        </div>
                        <div class="row" style="margin-top: 15px;">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvitens">Itens</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvnotasreferenciadas">Notas referênciadas</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvformapagamento">Forma de pagamento</a>
                                    </li>                                    									
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvcobranca">Cobrança</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvfrete">Frete</a>
                                    </li>                                      
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvinformacoescomplementares">Informações complementares</a>
                                    </li>																		
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvitens" class="container-fluid tab-pane active">
										<div class="row">
                                            <template v-if="parseInt(opcrud) < 3">
                                                <div class="col-md-4">
                                                    <div class="custom-control custom-switch" style="position: absolute; left: 16px;">
                                                        <input type="checkbox" class="custom-control-input" id="swcimprimereferenciaitens" name="swcimprimereferenciaitens" v-model="vimprimereferenciaitens" v-bind:disabled="ativadesativa">
                                                        <label class="custom-control-label" for="swcimprimereferenciaitens">Imprimir referência como código dos itens quando houver</label>
                                                    </div>                                                    
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="custom-control custom-switch" style="position: absolute; left: 16px;">
                                                        <input type="checkbox" class="custom-control-input" id="swcvisualizarqtrib" name="swcvisualizarqtrib" v-model="vvisualizarqtrib" v-bind:disabled="ativadesativa">
                                                        <label class="custom-control-label" for="swcvisualizarqtrib">Visualizar Qtd. tributária</label>
                                                    </div>                                                    
                                                </div>                                                
                                                <div class="col-md-2">
                                                    <button v-show="mtdvisualizabtn('020Z.020Z.050Z')" type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdfatorarnota()"><i class="fa fa-strikethrough"></i> Fatorar</button>
                                                </div>
                                                <div class="col-md-2">
                                                    <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdadcionaritem()"><i class="fa fa-plus"></i> Adicionar</button>
                                                </div>
                                                <div class="col-md-2">
                                                    <input
                                                        type="file" 
                                                        id="ipselecionararquivo"
                                                        accept=".xml" 
                                                        @change="mtdselecionararquivoxml" 
                                                        style="display: none;"
                                                        ref="if_selecionarquivo"
                                                    >  
                                                    <button type="button" class="btn btn-green btn-sm btn-block dropdown-toggle"  data-toggle="dropdown">
                                                        <i class="fa fa-navicon"></i> Outras
                                                    </button>
                                                    <div class="dropdown-menu">                                    
                                                        <a class="dropdown-item" href="#" @click="mtdimportardi()"><i class="fa fa-file-code-o"></i> Importar arquivo DI</a>
                                                        <a class="dropdown-item" href="#" @click.prevent="mtdcfopparatodos()"><i class="fa fa-flag-o"></i> CFOP p/ todos</a>
                                                        <a class="dropdown-item" href="#" @click.prevent="mtdatribuircampos()"><i class="fa fa-stream"></i> Atribuir campos</a>
                                                    </div> 
                                                </div>                                             
                                            </template>
                                            <div class="col-md-12" style="margin-top: 10px;">
												<vue-bootstrap4-table ref="refitensnota"
                                                        
														:rows="lstitensnf"
														:columns="columnsitensnf"
														:config="config"
														:classes="classes">
													<template slot="empty-results">
														<div class="col-md-12 text-center">Sem dados para visualização</div>
													</template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                                    
                                                    <template slot="opcoes_item" slot-scope="item">
                                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalteraritem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-edit"></i></button>
                                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                    <template slot="slot_item" slot-scope="item">
                                                        {{ mtdformatarzeros(item.row.item, 3) }}
                                                    </template>
                                                    <template slot="slot_coddig" slot-scope="item">
                                                        {{ item.row.coddig }}
                                                    </template>
                                                    <template slot="slot_descproduto" slot-scope="item">
                                                        {{ item.row.descproduto }}
                                                    </template>
                                                    <template slot="slot_ncm" slot-scope="item">
                                                        {{ mtdformatarzeros(item.row.idncm, 8) }}
                                                    </template>
                                                    <template slot="slot_cst" slot-scope="item">
                                                        {{ item.row.cst }}
                                                    </template>
                                                    <template slot="slot_cfop" slot-scope="item">
                                                        {{ item.row.idcfop }}
                                                    </template>                                                                                                        
                                                    <template slot="slot_und" slot-scope="item">
                                                        {{ item.row.und }}
                                                    </template>
                                                    <template slot="slot_qtditem" slot-scope="item">
                                                        {{ mtdformatavalordecimal(item.row.qtditem, 4) }}
                                                    </template>
                                                    <template slot="slot_utrib" slot-scope="item">
                                                        {{ item.row.utrib }}
                                                    </template>                                                    
                                                    <template slot="slot_qtrib" slot-scope="item">
                                                        {{ mtdformatavalordecimal(item.row.qtrib, 4) }}
                                                    </template>                                                    
                                                    <template slot="slot_vlunitario" slot-scope="item">
                                                        {{ mtdformatavalordecimal(item.row.vlunitario, 4) }}
                                                    </template>
                                                    <template slot="slot_vltotal" slot-scope="item">
                                                        {{ mtdformatavalordecimal(item.row.vltotal, 2) }}
                                                    </template>
                                                    <template slot="slot_vldesconto" slot-scope="item">
                                                        {{ mtdformatavalordecimal(item.row.vldesconto, 2) }}
                                                    </template>                                                                                                                                                                                        
												</vue-bootstrap4-table>                                                
                                            </div>                                                                                                                                   
										</div>
                                        <div class="row">
                                        </div>
                                    </div>
									<div id="dvnotasreferenciadas" class="container-fluid tab-pane">
										<div class="row">
                                            <template v-if="parseInt(opcrud) < 3">
                                                <div class="col-md-10">
                                                </div>
                                                <div class="col-md-2">
                                                    <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdnotasref()"><i class="fa fa-plus"></i> Adicionar</button>
                                                </div>
                                            </template>
                                            <div v-if="lstnotasref.length > 0" class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistanotasref" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-dark">
                                                        <tr>
                                                            <th width="100">Tipo:</th>
                                                            <th width="100">Chave de acesso:</th>
                                                            <th v-show="parseInt(opcrud) < 3" width="35px" style="text-align: center;">Exc:</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody id="lstlocalizacaopro">
                                                            <tr v-for="(nota, index) in lstnotasref" v-bind:key="index">
                                                                <td v-if="parseInt(nota.tipo) === 0" width="100px">NF-e</td>
                                                                <td v-else width="100px">CT-e</td>
                                                                <td width="100px">{{ nota.chave }}</td>
                                                                <td v-show="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                    v-bind:disabled="ativadesativa"
                                                                    @click.prevent="mtddeletarnotaref(index)"><i class="fa fa-trash"></i>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>                                                                                        
										</div>
									</div>
									<div id="dvformapagamento" class="container-fluid tab-pane">
										<div class="row">
                                            <template v-if="parseInt(opcrud) < 3">
                                                <div class="col-md-10">
                                                </div>
                                                <div class="col-md-2">
                                                    <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdincluirformadepagamento()"><i class="fa fa-plus"></i> Adicionar</button>
                                                </div>
                                            </template>
                                            <template v-if="lstformaspagamento.length > 0">
                                                <div class="col-lg-12">
                                                    <div class="table-responsive">
                                                        <table id="tblistaformaspagamento" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                            <thead class="thead-dark">
                                                            <tr>
                                                                <th width="30px">Id.:</th>
                                                                <th >Nome de referência:</th>
                                                                <th width="100px">Valor:</th>
                                                                <th width="150px">Nr. Aut:</th>
                                                                <th v-show="parseInt(opcrud) < 3" width="35px" style="text-align: center;">Exc:</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody id="lstlistaformas">
                                                                <tr v-for="(forma, index) in lstformaspagamento" v-bind:key="index">
                                                                    <td width="30px">{{ mtdformatarzeros(forma.idforma, 2) }}</td>
                                                                    <td>{{ forma.descforma }}</td>
                                                                    <td width="100px" style="text-align: right; color: #666666; font-weight: bold;">{{ mtdformatavalordecimal(forma.vpag, 2) }}</td>
                                                                    <td width="150px">{{ forma.caut }}</td>
                                                                    <td v-show="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                        <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                        v-bind:disabled="ativadesativa"
                                                                        @click.prevent="mtddeletarforma(index)"><i class="fa fa-trash"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <ul class="list-group">
                                                        <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                                            <span style="color: #666666; font-weight: bold;">Soma das formas de pagamento</span>
                                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #727cf5;">{{mtdformatavalordecimal(parseFloat(vtotalformas), 2)}}</span>
                                                        </li>
                                                    </ul>
                                                </div>                                                
                                            </template>                                                     
										</div>
									</div>                                     
									<div id="dvcobranca" class="container-fluid tab-pane">
										<div class="row">
                                            <template v-if="parseInt(opcrud) < 3">
                                                <div class="col-md-10">
                                                </div>
                                                <div class="col-md-2">
                                                    <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdincluirparcelacobranca()"><i class="fa fa-plus"></i> Adicionar</button>
                                                </div>
                                            </template>
                                            <template v-if="lstcobranca.length > 0">
                                                <div class="col-lg-12">
                                                    <div class="table-responsive">
                                                        <table id="tblistanotasref" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                            <thead class="thead-dark">
                                                            <tr>
                                                                <th width="100">Nr. Dup:</th>
                                                                <th width="100">Data Vencimento:</th>
                                                                <th width="100">Valor:</th>
                                                                <th v-show="parseInt(opcrud) < 3" width="35px" style="text-align: center;">Exc:</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody id="lstlistacobranca">
                                                                <tr v-for="(parcela, index) in lstcobranca" v-bind:key="index">
                                                                    <td width="100px">{{ mtdformatarzeros(parcela.ndup, 3) }}</td>
                                                                    <td width="100px">{{ parcela.dvenc }}</td>
                                                                    <td width="100px" style="text-align: right; color: #666666; font-weight: bold;">{{ mtdformatavalordecimal(parcela.vdup, 2) }}</td>
                                                                    <td v-show="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                        <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                        v-bind:disabled="ativadesativa"
                                                                        @click.prevent="mtddeletarparcela(index)"><i class="fa fa-trash"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <ul class="list-group">
                                                        <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                                            <span style="color: #666666; font-weight: bold;">Soma das parcelas</span>
                                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #727cf5;">{{mtdformatavalordecimal(parseFloat(vtotalcobranca), 2)}}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </template>
										</div>
									</div>
									<div id="dvfrete" class="container-fluid tab-pane">
										<div class="row">
                                            <div class="col-sm-12 col-md-7 col-lg-7">
                                                <label for="cbmodfrete">Modalidade do frete:</label>
                                                <select class="form-control form-control-sm" id="cbmodfrete" v-model="vmodfrete"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">0 - Contratação do Frete por conta do Remetente (CIF)</option>
                                                    <option value="1">1 - Contratação do Frete por conta do Destinatário (FOB)</option>
                                                    <option value="2">2 - Contratação do Frete por conta de Terceiros</option>
                                                    <option value="3">3 - Transporte Próprio por conta do Remetente</option>
                                                    <option value="4">4 - Transporte Próprio por conta do Destinatário</option>
                                                    <option value="9">9 - Sem Ocorrência de Transporte</option>
                                                </select>
                                            </div>
                                                <div v-show="parseInt(vmodfrete) < 9" class="col-sm-12 col-md-5 col-lg-5">
                                                    <span class="lblselect2">Transportadora:</span>
                                                    <select id="cbtransportadora" data-placeholder="Selecione uma transportadora" v-model="vidtransportadora" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                    </select>
                                                </div>                                                
                                                <div v-show="parseInt(vmodfrete) < 9" class="col-md-12" style="margin-top: 15px;">
                                                    <ul class="nav nav-tabs" role="tablist">
                                                        <li class="nav-item">
                                                            <a class="nav-link active" data-toggle="tab" href="#dvtransporte">Tipo de transporte</a>
                                                        </li>                                    
                                                        <li class="nav-item">
                                                            <a class="nav-link" data-toggle="tab" href="#dvvolumes">Volumes</a>
                                                        </li>
                                                    </ul>
                                                    <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                                        <div id="dvtransporte" class="container-fluid tab-pane active">
                                                            <div class="row">
                                                                <div class="col-sm-12 col-md-2 col-lg-2">
                                                                    <label for="cbtipotransporte">Tipo:</label>
                                                                    <select class="form-control form-control-sm" id="cbtipotransporte" v-model="vtipotransporte"
                                                                            v-bind:disabled="ativadesativa">
                                                                        <option value="0">Veículo</option>
                                                                        <option value="1">Reboque</option>
                                                                        <option value="2">Balsa</option>
                                                                        <option value="3">Vagão</option>
                                                                        <option value="4">Nenhum</option>
                                                                    </select>
                                                                </div>
                                                                <div v-show="parseInt(vtipotransporte) === 2" class="col-sm-12 col-md-3 col-lg-3">
                                                                    <label for="edtransp_balsa">Identificação da balsa:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edtransp_balsa" v-model="vtransp_balsa"
                                                                        maxlength="20" v-bind:disabled="ativadesativa"/>
                                                                </div>                                                                
                                                                <div v-show="parseInt(vtipotransporte) === 3" class="col-sm-12 col-md-3 col-lg-3">
                                                                    <label for="edtransp_vagao">Identificação do vagão:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edtransp_vagao" v-model="vtransp_vagao"
                                                                        maxlength="20" v-bind:disabled="ativadesativa"/>
                                                                </div>

                                                                <div v-show="parseInt(vtipotransporte) === 0" class="col-sm-12 col-md-2 col-lg-2">
                                                                    <label for="edveic_transp_placa">Placa:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edveic_transp_placa" v-model="vveic_transp_placa"
                                                                        maxlength="8" v-bind:disabled="ativadesativa"/>
                                                                </div>
                                                                <div v-show="parseInt(vtipotransporte) === 0" class="col-sm-2 col-md-1 col-lg-1">
                                                                    <label for="edveic_transp_uf">UF:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edveic_transp_uf" v-model="vveic_transp_uf"
                                                                        maxlength="2" v-bind:disabled="ativadesativa" style="text-center"/>
                                                                </div>
                                                                <div v-show="parseInt(vtipotransporte) === 0" class="col-sm-12 col-md-4 col-lg-4">
                                                                    <label for="edveic_transp_rntc">RNTC:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edveic_transp_rntc" v-model="vveic_transp_rntc"
                                                                        maxlength="20" v-bind:disabled="ativadesativa"/>
                                                                </div>

                                                                <div v-show="parseInt(vtipotransporte) === 1" class="col-sm-12 col-md-2 col-lg-2">
                                                                    <label for="edreboque_transp_placa">Placa:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edreboque_transp_placa" v-model="vreboque_transp_placa"
                                                                        maxlength="8" v-bind:disabled="ativadesativa"/>
                                                                </div>
                                                                <div v-show="parseInt(vtipotransporte) === 1" class="col-sm-2 col-md-1 col-lg-1">
                                                                    <label for="edreboque_transp_uf">UF:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edreboque_transp_uf" v-model="vreboque_transp_uf"
                                                                        maxlength="2" v-bind:disabled="ativadesativa" style="text-center"/>
                                                                </div>
                                                                <div v-show="parseInt(vtipotransporte) === 1" class="col-sm-12 col-md-4 col-lg-4">
                                                                    <label for="edreboque_transp_rntc">RNTC:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edreboque_transp_rntc" v-model="vreboque_transp_rntc"
                                                                        maxlength="20" v-bind:disabled="ativadesativa"/>
                                                                </div>                                                                                                                                
                                                            </div>
                                                        </div>
                                                        <div id="dvvolumes" class="container-fluid tab-pane">
                                                            <div class="row">
                                                                <template v-if="parseInt(opcrud) < 3">
                                                                    <div class="col-md-10">
                                                                    </div>
                                                                    <div class="col-md-2">
                                                                        <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdincluirvolumefrete()"><i class="fa fa-plus"></i> Adicionar</button>
                                                                    </div>
                                                                </template>
                                                                <div v-if="lstvolumes.length > 0" class="col-lg-12">
                                                                    <div class="table-responsive">
                                                                        <table id="tblistavolumes" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                            <thead class="thead-dark">
                                                                            <tr>
                                                                                <th width="20px">Item:</th>
                                                                                <th width="100">Qtd. Vol:</th>
                                                                                <th width="100">Espécie:</th>
                                                                                <th width="100">Marca:</th>
                                                                                <th width="100">Peso Líquido:</th>
                                                                                <th width="100">Peso Bruto:</th>
                                                                                <th width="100">Lacres:</th>
                                                                                <th v-show="parseInt(opcrud) < 3" width="35px" style="text-align: center;">Exc:</th>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody id="lstlistavolumes">
                                                                                <tr v-for="(volume, index) in lstvolumes" v-bind:key="index">
                                                                                    <td width="20px" style="text-align: center;">{{ mtdformatarzeros(volume.item, 3) }}</td>
                                                                                    <td width="100px">{{ volume.qvol }}</td>
                                                                                    <td width="100px">{{ volume.esp }}</td>
                                                                                    <td width="100px">{{ volume.marca }}</td>
                                                                                    <td width="100px">{{ volume.pesol }}</td>
                                                                                    <td width="100px">{{ volume.pesob }}</td>
                                                                                    <td width="100px">
                                                                                        <ul class="list-group">
                                                                                            <li v-for="(lacre, index) in volume.lacres" v-bind:key="index" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
                                                                                                <span class="lbllacre">{{lacre.nlacre}}</span>
                                                                                            </li>
                                                                                        </ul>																			
                                                                                    </td>
                                                                                    <td v-show="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                                        <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                        v-bind:disabled="ativadesativa"
                                                                                        @click.prevent="mtddeletarvolume(index)"><i class="fa fa-trash"></i>
                                                                                        </a>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>                                                                
                                                            </div>
                                                        </div>                                                                                             
                                                    </div>    
                                                </div>
										</div>
									</div>                                                                                                                 
									<div id="dvinformacoescomplementares" class="container-fluid tab-pane">
										<div class="row">
                                            <div v-show="parseInt(opcrud) < 3" class="col-sm-12 col-md-8 col-lg-8">
                                                <span class="lblselect2">Informação complementar:</span>
                                                <select id="cbinfcpl" data-placeholder="Selecione uma opção" v-model="vidinfcpl"
                                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>              
                                            <div v-show="parseInt(opcrud) < 3" class="col-md-2">
                                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdadicionarinfcpl()" style="margin-top: 22px;"><i class="fa fa-plus"></i> Adicionar</button>
                                            </div>
                                            <div v-show="parseInt(opcrud) < 3" class="col-md-2">
                                                <button type="button" class="btn btn-danger btn-sm btn-block" @click.prevent="vinfcpl = '';" style="margin-top: 22px;"><i class="fa fa-eraser"></i> Limpar</button>
                                            </div>                                         
                                            <div class="col-sm-12" style="margin-top: 15px;">
                                                <textarea class="form-control center" rows="5" id="txtinfcpl" v-model="vinfcpl" v-bind:disabled="ativadesativa" maxlength="5000"></textarea>
                                            </div>                                            
										</div>
									</div>                                    
                                </div>
                            </div>
                            <div class="col-sm-12" style="margin-top: 15px;">
                                <div class="card" id="dvtotalizadores">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12" style="margin-bottom: 10px;">
                                                <div class="card">
                                                    <div class="card-body text-center" style="padding: 5px;">
                                                        <h6 id="tittotalizadores">TOTAIS DA NOTA</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total produtos <span class="badge badge-primary bdg-totais">{{ mtdformatavalordecimal(tprod, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdettot">Total BC ICMS<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tbc, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total ICMS <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ticms, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total ICMS Des.<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ticmsdeson, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total FCP <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tfcp, 2) }}</span></a> 
                                                    <!-- <a class="list-group-item lstdettot">Total CBS <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(totcbs, 2) }}</span></a>                                                     -->
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total BC ICMS ST<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tbcst, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total ICMS ST <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tst, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total FCP ST <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tfcpst, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total FCP ST RET<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tfcpstret, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdettot">Total frete <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tfrete, 2) }}</span></a>
                                                    <!-- <a class="list-group-item lstdettot">Total IBS Mun. <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(totibsmun, 2) }}</span></a>  -->
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total seguro <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tseg, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total desconto <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tdesc, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total II<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tii, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total IPI <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tipi, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total IPI DEVOL <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tipidevol, 2) }}</span></a>
                                                    <!-- <a class="list-group-item lstdettot">Total IBS UF.<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(totibsuf, 2) }}</span></a>  -->
                                                </ul>
                                            </div>
                                            
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total PIS <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tpis, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total COFINS<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tcofins, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total OUTROS<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(toutro, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdettot">Total Aprox. Tributos<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ttottrib, 2) }}</span></a>
                                                    <!-- <a class="list-group-item lstdettot">Total IS <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(totis, 2) }}</span></a>  -->
                                                    <a class="list-group-item lstdettot">Total da Nota<span class="badge badge-info bdg-totais" style="background-color: #5A956A;">{{ mtdformatavalordecimal(tnf, 2) }}</span></a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos obrigatórios são sinalizados com \*</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Salvar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Editar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Remover
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal do menu da nf -->
		<div class="modal fade" id="mdmenunf">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(nfmenu.nnf, 8) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(nfmenu)"><i class="fa fa-edit"></i> EDITAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(nfmenu)"><i class="fa fa-trash"></i> REMOVER</li>                                
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdclonar(nfmenu)" data-dismiss="modal"><i class="fa fa-clone"></i> CLONAR</li>                                
                                <li v-if="parseInt(nfmenu.situacaonota) < 2" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdenviar(nfmenu)"><i class="fa fa-send"></i> ENVIAR</li>                                
                                <li v-if="nfmenu.chave !== '' && nfmenu.chave !== null" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdconsultarnf(nfmenu)"><i class="fa fa-refresh"></i> CONSULTAR NF</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdimprimir(nfmenu)"><i class="fa fa-print"></i> VISUALIZAR DANFE</li>
                                <li v-if="parseInt(nfmenu.situacaonota) === 2" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdsalvarxmlindividual(nfmenu.id)"><i class="fa fa-download"></i> SALVAR XML/PDF</li>
                                <li v-if="parseInt(nfmenu.situacaonota) === 2 && parseInt(nfmenu.modelo) === 55" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdcartacorrecao(nfmenu.id)"><i class="fa fa-envelope-o"></i> CARTA DE CORREÇÃO</li>                                
                                <li v-if="parseInt(nfmenu.situacaonota) === 2" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdinfemailcliente(nfmenu)"><i class="fa fa-envelope"></i> ENVIAR P/ E-MAIL</li>                                

                                <li v-if="parseInt(nfmenu.situacaonota) >= 1" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdrotinacorrecaonf(nfmenu)"><i class="fa fa-edit"></i> CORRIGIR NF</li>
                                <li v-if="parseInt(nfmenu.situacaonota) >= 1" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdrotinacolsultarprocessamento(nfmenu)"><i class="fa fa-edit"></i> CONSULTAR RECIBO PROCESSAMENTO</li>

								<li v-show="parseInt(nfmenu.situacaonota) === 2 && mtdPermiteUsuario('020Z.020Z.101Z')" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;">
									<div class="row">
										<div class="col-md-12" @click="mtdmostraropcaocancelamento()">
											<i class="fa fa-remove"></i> FECHAR NOTA FISCAL
										</div>
										<div id="dvdefnf" class="col-md-12" style="margin-top: 15px;">
											<div class="card" style="margin-left: -15px; margin-right: -15px;">
												<div class="card-body" style="padding: 15px;">
													<div class="row">
														<div class="col-md-12">
                                                            <label for="txtcancelanf">Motivo do cancelamento:</label>
                                                            <textarea class="form-control center" rows="5" id="txtcancelanf" v-model="vjustcancelamento" maxlength="255"></textarea>
														</div>
														<div class="col-md-12" style="margin-top: 15px;">
															<button type="button" class="btn btn-sm btn-danger btn-block" @click.prevent="mtdconfirmacaocancelamento(nfmenu)"><i class="fa fa-check"></i> Confirmar</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</li>                                
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>        
		<!-- Modal de edição do ítem -->
		<div class="modal fade" id="mdedicaoitem">
			<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 v-if="parseInt(vopitem) === 1" class="modal-title"><i class="fa fa-edit"></i> Edição do ítem(Inclusão)</h4>
						<h4 v-else class="modal-title"><i class="fa fa-edit"></i> Edição do ítem(Alteração)</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edidproduto">*Item:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="edidproduto" v-bind:disabled="parseInt(vopitem) === 2" v-model="vcoddig" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddig)" v-on:keyup.13="mtdlocalizarproduto(vcoddig)" style="text-transform: uppercase;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-md-8 col-lg-7">
								<label for="eddescproduto">Descrição do produto:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="eddescproduto" v-model="vdescproduto" maxlength="120" style="font-weight: bold;">
								</div>									
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edund">Und:</label>
								<input type="text" class="form-control form-control-sm" id="edund" v-model="vund" data-bv-group=".group" maxlength="2" style="font-weight: bold;"/>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edqtditem">*Quantidade:</label>
								<money type="text" class="form-control form-control-sm" id="edqtditem" v-model="vqtditem" @blur.native="mtdcalculatotalitem()" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edvlunitario">*Valor Unitário:</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitario" v-model="vvlunitario" v-bind="moneyprecision" @blur.native="mtdcalculatotalitem()" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edvldesconto">Vl. Desconto</label>
								<money type="text" class="form-control form-control-sm" id="edvldesconto" v-model="vvldesconto" v-bind="money" @blur.native="mtdcalculatotalitem()" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edvlfrete">Vl. Frete</label>
								<money type="text" class="form-control form-control-sm" id="edvlfrete" v-model="vvfrete" v-bind="money" @blur.native="mtdcalculatotalitem()" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>                                                        							
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edvlseguro">Vl. Seguro</label>
								<money type="text" class="form-control form-control-sm" id="edvlseguro" v-model="vvseg" v-bind="money" @blur.native="mtdcalculatotalitem()" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edvloutro">Vl. Outros</label>
								<money type="text" class="form-control form-control-sm" id="edvloutro" v-model="vvoutro" v-bind="money" @blur.native="mtdcalculatotalitem()" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>                                                                                                                              
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edvltotal">Total:</label>
								<money type="text" class="form-control form-control-sm" id="edvltotal" v-model="vvltotal" v-bind="money" readonly style="font-weight: bold; text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edxped">Ped. Compra:</label>
								<input type="text" class="form-control form-control-sm" id="edxped" v-model="vxped" data-bv-group=".group" maxlength="15" style="font-weight: bold;" title="Número do pedido de compra (Não é obrigatório)"/>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="ednitemped">Nr. Item:</label>
								<input type="text" class="form-control form-control-sm" id="ednitemped" v-model="vnitemped" data-bv-group=".group" maxlength="6" style="font-weight: bold;" title="Número do item no pedido de compra (Não é obrigatório)"/>
							</div>   
							<div class="col-sm-12 col-md-1 col-lg-1">
								<label v-show="vvisualizarqtrib" for="edutrib">U. trib:</label>
								<input v-show="vvisualizarqtrib" type="text" class="form-control form-control-sm" id="edutrib" v-model="vutrib" data-bv-group=".group" maxlength="2" style="font-weight: bold; background: beige;" title="Utilizar somente em casos específicos"/>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label v-show="vvisualizarqtrib" for="edqtrib">Qtd. trib:</label>
								<money v-show="vvisualizarqtrib" type="text" class="form-control form-control-sm" id="edqtrib" v-model="vqtrib" data-bv-group=".group" maxlength="20" style="text-align:right; background: beige;" title="Utilizar somente em casos específicos"></money>
							</div>                                                     
                            <div class="col-md-2">
                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdselecionarclasse()" style="margin-top: 20px;" title="Define a classe do produto"><i class="fa fa-folder-open"></i> Classe</button>
                            </div>
						</div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">*NCM({{ vidncm }}):</span>
                                <select id="cbncm" data-placeholder="Selecione uma opção" v-model="vidncm"
                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">CEST({{ vidcest }}):</span>
                                <select id="cbcest" data-placeholder="Selecione uma opção" v-model="vidcest"
                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-8 col-lg-6">
                                <label for="cborigemproduto">Origem:</label>
                                <select class="form-control form-control-sm" id="cborigemproduto"
                                    v-model="vorig" v-bind:disabled="ativadesativa">
                                    <option value="0">0 - NACIONAL, EXCETO AS INDICADAS NOS CODIGOS 3 A 5</option>
                                    <option value="1">1 - ESTRANGEIRA - IMPORTACAO DIRETA, EXCETO A INDICADA NO CODIGO 6</option>
                                    <option value="2">2 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, EXCETO A INDICADA NO CODIGO 7</option>
                                    <option value="3">3 - NACIONAL, MERCADORIA OU BEM COM CONTEUDO DE IMPORTACAO SUPERIOR A 40% (QUARENTA POR CENTO)</option>
                                    <option value="4">4 - NACIONAL, CUJA PRODUCAO TENHA SIDO FEITA EM CONFORMIDADE
                                        COM OS PROCESSOS PRODUTIVOS BASICOS DE QUE TRATAM O DECRETO-LEI Nº 288/67 E
                                        AS LEIS N°S 8.248/91, 8.387/91,10.176/01 e 11.484/07
                                    </option>
                                    <option value="5">5 - NACIONAL, MERCADORIA OU BEM COM CONTEUDO DE IMPORTACAO
                                        INFERIOR OU IGUAL A 40% (QUARENTA POR CENTO)
                                    </option>
                                    <option value="6">6 - ESTRANGEIRA - IMPORTACAO DIRETA, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUCAO CAMEX</option>
                                    <option value="7">7 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUCAO CAMEX</option>
                                </select>
                            </div>                             
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">CFOP({{ vidcfop }}):</span>
                                <select id="cbcfop" data-placeholder="Selecione uma opção" v-model="vidcfop"
                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                                                                                                               
                        </div>
                        <div class="row" style="margin-top: 15px;">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvicms">ICMS</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvpiscofins">PIS/COFINS</a>
                                    </li>                                    
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvipi">IPI</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvicmsopinter">ICMS em op. interest.</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvcombustivel">Combustível</a>
                                    </li> 
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvimportacao">Importação</a>
                                    </li>                                    
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvinfadpro">Informações adicionais</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link " data-toggle="tab" href="#dvibscbs">IBS/CBS</a>           
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvis">IS</a>
                                    </li>                                    
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvicms" class="container-fluid tab-pane active">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="cbregime">Regime tributário:</label>
                                                <select class="form-control form-control-sm" id="cbregime" v-model="vregime" v-bind:disabled="ativadesativa" @change="mtdalteraregime()">
                                                    <option value="0">Tributação Normal</option>
                                                    <option value="1">Simples Nacional</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                <label v-if="parseInt(vregime) === 0" for="cbregime">Código da situação tributária:</label>
                                                <label v-else for="cbcst">CSOSN:</label>
                                                <select class="form-control form-control-sm" id="cbcst" v-model="vcst" v-bind:disabled="ativadesativa" @change="mtdselecionarcamposgrupofiscal()">
                                                    <option v-for="(item, indice) in lstcst" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>
                                            </div>
                                            <div v-show="lstcamposicms.length > 0" class="col-md-12" style="margin-top: 15px;">
                                                <div class="card">
                                                    <div v-if="parseInt(vregime) === 0" class="card-header card-in text-center" style="padding: 5px;">CAMPOS CST {{ vcst }}</div>
                                                    <div v-else class="card-header card-in text-center" style="padding: 5px;">CAMPOS CSOSN {{ vcst }}</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <ul class="list-group">
                                                                    <li v-for="(item, indice) in lstcamposicms" v-bind:key="indice" class="list-group-item list-group-item-action lst-campos">
                                                                        <div class="row">
                                                                            <div v-if="item.listajson.length > 0" class="col-md-8">
                                                                                {{ item.descricao }}
                                                                            </div>
                                                                            <div v-else class="col-md-8">
                                                                                {{ item.descricao }}
                                                                            </div>                                                                                
                                                                            <div v-if="item.listajson.length > 0" class="col-md-4">
                                                                                <select class="form-control form-control-sm" id="cbregime" v-model="item.valor" v-bind:disabled="ativadesativa">
                                                                                    <option v-for="(opcao, indice) in item.listajson" v-bind:key="indice" v-bind:value="opcao.id">{{opcao.descricao}}</option>
                                                                                </select>                                                                                    
                                                                            </div>
                                                                            <template v-else>
                                                                                <div class="col-md-2">
                                                                                </div>
                                                                                <div class="col-md-2">
                                                                                    <money type="text" class="form-control form-control-sm" v-bind:id="'ed'+item.idcampo"
                                                                                        v-model="item.valor" v-bind="moneyprecision" @blur.native="mtdcalculatotalitem()"
                                                                                        data-bv-group=".group" style="text-align:right;">
                                                                                    </money>                                                                                    
                                                                                    <!-- <money type="text" class="form-control form-control-sm"
                                                                                        v-model="item.valor" v-bind="[calculatotalitem, money]"
                                                                                        data-bv-group=".group" style="text-align:right;" v-bind:disabled="item.habilitarcadastro === 0 ? true : false">
                                                                                    </money>                                                                                          -->
                                                                                </div>
                                                                            </template>                                                                                
                                                                        </div>
                                                                    </li>  
                                                                </ul>                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                            </div>
                                        </div>                                                        
                                    </div>
                                    <div id="dvpiscofins" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <label for="cbcstpiscofins">Código da situação tributária:</label>
                                                <select class="form-control form-control-sm" id="cbcstpiscofins" v-model="vcstpiscofins">
                                                    <option v-for="(item, indice) in cstpiscofins" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>                                                
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edppis">Alíquota PIS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edppis"
                                                        v-model="vppis" v-bind="money" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvpis">Valor do PIS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvpis"
                                                        v-model="vvpis" v-bind="money"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                                                                         
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edppisst">Alíquota PIS ST:</label>
                                                <money type="text" class="form-control form-control-sm" id="edppisst"
                                                        v-model="vppisst" v-bind="money"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvpisst">Valor do PIS ST:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvpisst"
                                                        v-model="vvpisst" v-bind="money"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                            
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edpcofins">Alíquota COFINS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpcofins"
                                                        v-model="vpcofins" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvcofins">Valor do COFINS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvcofins"
                                                        v-model="vvcofins" v-bind="money" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                                                               
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edpcofinsst">Alíquota COFINS ST:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpcofinsst"
                                                        v-model="vpcofinsst" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvcofinsst">Valor do COFINS ST:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvcofinsst"
                                                        v-model="vvcofinsst" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                            
                                        </div>
                                    </div>
                                    <div id="dvipi" class="container-fluid tab-pane">
                                        <div class="row">                                            
                                            <div class="col-md-12">
                                                <label for="cbcstipi">Código da situação tributária:</label>
                                                <select class="form-control form-control-sm" id="cbcstpipi" v-model="vcstipi" v-bind:disabled="ativadesativa">
                                                    <option v-for="(item, indice) in cstipi" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>                                                
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edpipi">Alíquota IPI:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpipi"
                                                        v-model="vpipi" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvipi">Valor do IPI:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvipi"
                                                        v-model="vvipi" v-bind="money" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                            
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edcenq">Código de enquadramento:</label>
                                                <input type="text" class="form-control form-control-sm" id="edcenq"
                                                    v-model="vcenq" v-bind:disabled="ativadesativa"
                                                    data-bv-group=".group" maxlength="3">
                                            </div>                                                                                         
                                        </div>
                                    </div>
                                    <div id="dvicmsopinter" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-5 col-lg-5">
                                                <label for="edvpfcpufdedt">Percentual ICMS relativo ao FCP na UF do destino:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvpfcpufdedt"
                                                        v-model="vpfcpufdedt" @blur.native="calcularICMSinter()" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edvbcufdest">Valor da base de cálculo na UF do destinatário:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvbcufdest"
                                                        v-model="vbcufdest" @blur.native="calcularICMSinter()" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvpicmsufdest">Aliq. interna da UF do destinatário:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvpicmsufdest"
                                                        v-model="vpicmsufdest" @blur.native="calcularICMSinter()" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-md-12">
                                                <label for="cbvpicmsinter">Aliq. interestadual:</label>
                                                <select class="form-control form-control-sm" id="cbvpicmsinter" @blur.native="calcularICMSinter()" v-model="vpicmsinter" v-bind:disabled="ativadesativa">
                                                    <option value="0"></option>
                                                    <option value="1">4% aliquota interestadual para produtos importados</option>
                                                    <option value="2">7% para estados do sul e sudeste (exceto ES), destinados para estados do norte e nordeste ou ES</option>
                                                    <option value="3">12% para os demais casos</option>
                                                </select>                                                
                                            </div>
                                            <div class="col-md-12">
                                                <label for="cbvpimsinterpart">Percentual provisório de partilha:</label>
                                                <select class="form-control form-control-sm" id="cbvpimsinterpart" @blur.native="calcularICMSinter()"  v-model="vpimsinterpart" v-bind:disabled="ativadesativa">
                                                    <option value="0"></option>
                                                    <option value="1">40% em 2016</option>
                                                    <option value="2">60% em 2017</option>
                                                    <option value="3">80% em 2018</option>
                                                    <option value="4">100% a partir de 2019</option>
                                                </select>                                                
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edvicmsufdest">Valor do ICMS de partilha para UF do destinatário:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvicmsufdest"
                                                        v-model="vicmsufdest" v-bind="money" @blur.native="calcularICMSinter()" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div> 
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edvicmsufremet">Valor do ICMS de partilha para UF do remetente:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvicmsufremet"
                                                        v-model="vicmsufremet" @blur.native="calcularICMSinter()" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>  
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edvfcpufdest">Valor do ICMS relativo ao FCP da UF de destino:</label>
                                                <money @blur.native="calcularICMSinter()" type="text" class="form-control form-control-sm" id="edvfcpufdest"
                                                        v-model="vfcpufdest" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                                                          
                                        </div>
                                    </div>  
                                    <div id="dvimportacao" class="container-fluid tab-pane">
                                        <div v-show="lstdeclaracaoimp.length ===0" class="row">
                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                <label for="ednrvi">*Numero declaração(DI):</label>
                                                <input type="text" v-model="vnrdeclaracao"
                                                        class="form-control form-control-sm" id="ednrvi" maxlength="60">
                                            </div>   
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="eddecla">*Data declaração:</label>
                                                <div class="input-group">
                                                    <date-picker id="eddecla" v-model="vdtdeclaracao" :config="options"
                                                        class="form-control form-control-sm"></date-picker>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                    </div>										
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                <label for="ednrvi">*Local de desenbarque:</label>
                                                <input type="text" v-model="vlocaldesenbarque"
                                                        class="form-control form-control-sm" id="ednrvi" maxlength="60">
                                            </div> 
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="ednrvi">*UF de desenbarque:</label>
                                                <input type="text" v-model="vufdesenbarque"
                                                        class="form-control form-control-sm" style="text-transform: uppercase;" id="ednrvi" maxlength="2">
                                            </div>   
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="ednrvi">*Código exportador:</label>
                                                <input type="text" v-model="vcexportador"
                                                        class="form-control form-control-sm" id="ednrvi" maxlength="60">
                                            </div>  
                
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="eddecla">*Data desenbaraço:</label>
                                                <div class="input-group">
                                                    <date-picker id="eddecla" v-model="vdtdesenbarque" :config="options"
                                                        class="form-control form-control-sm"></date-picker>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                    </div>										
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="cbtiponfref">Tipo transporte:</label>
                                                <select class="form-control form-control-sm" id="cbtiponfref" v-model="vtptransporte">
                                                    <option value="1">Maritima</option>
                                                    <option value="2">Fluvial</option>
                                                    <option value="3">Lacustre</option>
                                                    <option value="4">Aérea</option>
                                                    <option value="5">Postal</option>
                                                    <option value="6">Ferroviária</option>
                                                    <option value="7">Rodoviária</option>
                                                    <option value="8">Conduto / Rede transmição</option>
                                                    <option value="9">Meios propios</option>
                                                    <option value="10">Entrada / Saída ficta</option>
                                                    <option value="11">Courier</option>
                                                    <option value="12">Em mãos</option>
                                                    <option value="13">Por reboque</option>
                                                </select>
                                            </div>

                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                <label for="ednrvi">Marca/fabricante:</label>
                                                <input type="text" v-model="vmarcafabricante"
                                                        class="form-control form-control-sm" id="ednrvi" maxlength="60">
                                            </div>

                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edqtditemprod">Desconto adição:</label>
                                                <money type="text" v-bind="money" class="form-control form-control-sm" id="edqtditemprod" v-model="vdescontodi" data-bv-group=".group" maxlength="20" style="text-align:right;" ></money>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="ednrvi">Numero do Draw:</label>
                                                <input type="text" v-model="vnrdraw"
                                                        class="form-control form-control-sm" id="ednrvi" maxlength="60">
                                            </div>


                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="cbtiponfref">Tipo de intermédio:</label>
                                                <select class="form-control form-control-sm" id="cbtiponfref" v-model="vtpintermedio">
                                                    <option value="1">Importação por conta própria</option>
                                                    <option value="2">Importação por conta e ordem</option>
                                                    <option value="3">Importação por encomenda</option>
                                             
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edqtditemprod">Valor da AFRNN:</label>
                                                <money type="text" v-bind="money" class="form-control form-control-sm" id="edqtditemprod" v-model="vvafrmm" data-bv-group=".group" maxlength="20" style="text-align:right;" ></money>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edcnpj">CNPJ:</label>
                                                <input type="text" v-model="vcnpjimportador" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edcnpj" 
                                                    v-mask="'##.###.###/####-##'">
                                            </div> 
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="ednrvi">*UF do intermediador:</label>
                                                <input type="text" v-model="vufterceiro"
                                                        class="form-control form-control-sm" style="text-transform: uppercase;" id="ednrvi" maxlength="2">
                                            </div>    
                                            
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edqtditemprod">Base do II:</label>
                                                <money type="text" v-bind="money" class="form-control form-control-sm" id="edqtditemprod" v-model="vvbc" data-bv-group=".group" maxlength="20" style="text-align:right;" ></money>
                                            </div>

                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edqtditemprod">Despesa aduaneira:</label>
                                                <money type="text" v-bind="money" class="form-control form-control-sm" id="edqtditemprod" v-model="vvdespadu" data-bv-group=".group" maxlength="20" style="text-align:right;" ></money>
                                            </div>

                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edqtditemprod">Valor II:</label>
                                                <money type="text" v-bind="money" class="form-control form-control-sm" id="edqtditemprod" v-model="vviiitem" data-bv-group=".group" maxlength="20" style="text-align:right;" ></money>
                                            </div>

                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edqtditemprod">Valor IOF:</label>
                                                <money type="text" v-bind="money" class="form-control form-control-sm" id="edqtditemprod" v-model="vviof" data-bv-group=".group" maxlength="20" style="text-align:right;" ></money>
                                            </div>
                                        </div>  
										<div style="padding-top: 20px;" class="row">
                                            <template v-if="parseInt(opcrud) < 3 && lstdeclaracaoimp.length ===0">
                                                <div class="col-md-10">
                                                </div>
                                                <div class="col-md-2">
                                                    
                                                     <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdconfirmadecimporta()"><i class="fa fa-plus"></i> Salvar</button>
                                                    <!-- <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtddeclaracaoimporta()"><i class="fa fa-plus"></i> Adicionar</button> -->
                                                </div>
                                            </template>
                                            <div v-if="lstdeclaracaoimp.length > 0" class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistanotasref" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-dark">
                                                        <tr>
                                                            <th>Numero:</th>
                                                            <th v-show="parseInt(opcrud) < 3" width="35px" style="text-align: center;">Alt:</th>
                                                            <th v-show="parseInt(opcrud) < 3" width="35px" style="text-align: center;">Exc:</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody id="lstlocalizacaopro">
                                                            <tr v-for="(declaracao, index) in lstdeclaracaoimp" v-bind:key="index">
                                                                <td>{{ declaracao.nrdeclaracao }}</td>
                                                                <td v-show="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                    <a class="btn btn-info btn-sm btn-opcrud ajt-btn" href="#"
                                                                    v-bind:disabled="ativadesativa"
                                                                    @click.prevent="mtdeditardeclaracao(index)"><i class="fa fa-edit"></i>
                                                                    </a>
                                                                </td>
                                                                <td v-show="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                    v-bind:disabled="ativadesativa"
                                                                    @click.prevent="mtddeletardeclaracao(index)"><i class="fa fa-trash"></i>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>                                                                                        
										</div>
									</div>  
                                    <div id="dvcombustivel" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-3" style="margin-top: 10px;">
                                                <span class="lblselect2">ANP({{vcprodanp}}):</span>
                                                <select id="cbanp" data-placeholder="Selecione uma opção" v-model="vcprodanp"
                                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-md-1" style="margin-top: 10px;">
                                                <label for="cbufcombustivel">UF:</label>
                                                <select class="form-control" id="cbufcombustivel" v-model="vufcons" v-bind:disabled="ativadesativa">
                                                    <option value=""></option>
                                                    <option value="AC">AC</option>
                                                    <option value="AL">AL</option>
                                                    <option value="AP">AP</option>
                                                    <option value="AM">AM</option>
                                                    <option value="BA">BA</option>
                                                    <option value="CE">CE</option>
                                                    <option value="ES">ES</option>
                                                    <option value="GO">GO</option>
                                                    <option value="MA">MA</option>
                                                    <option value="MT">MT</option>
                                                    <option value="MS">MS</option>
                                                    <option value="MG">MG</option>
                                                    <option value="PA">PA</option>
                                                    <option value="PB">PB</option>
                                                    <option value="PR">PR</option>
                                                    <option value="PE">PE</option>
                                                    <option value="PI">PI</option>
                                                    <option value="RJ">RJ</option>								
                                                    <option value="RN">RN</option>
                                                    <option value="RS">RS</option>
                                                    <option value="RO">RO</option>
                                                    <option value="RR">RR</option>
                                                    <option value="SC">SC</option>
                                                    <option value="SP">SP</option>								
                                                    <option value="SE">SE</option>
                                                    <option value="TO">TO</option>
                                                    <option value="DF">DF</option>								
                                                </select>                                            
                                            </div>    
                                            <div class="col-sm-12 col-md-2 col-lg-2" style="margin-top: 10px;">
                                                <label for="percglp">Perc.GLP(%):</label>
                                                <money type="text" class="form-control form-control-sm" id="percglp"
                                                        v-model="vpglp" v-bind="money" v-bind:disabled="ativadesativa"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2" style="margin-top: 10px;">
                                                <label for="edpglp">Perc.GNn(%):</label>
                                                <money type="text" class="form-control form-control-sm" id="edpglp"
                                                        v-model="vpgnn" v-bind="money" v-bind:disabled="ativadesativa"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2" style="margin-top: 10px;">
                                                <label for="edpgni">Perc.GNi(%):</label>
                                                <money type="text" class="form-control form-control-sm" id="edpgni"
                                                        v-model="vpgni" v-bind="money" v-bind:disabled="ativadesativa"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2" style="margin-top: 10px;">
                                                <label for="edvpart">Valor Partida:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvpart"
                                                        v-model="vvpart" v-bind="money" v-bind:disabled="ativadesativa"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div> 
                                                                     
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3" style="margin-top: 10px;">
                                                <label for="cbuforigem">Uf de origem do combustivel:</label>
                                                <select class="form-control" id="cbuforigem" v-model="vcuforig" v-bind:disabled="ativadesativa">
                                                    <option value=""></option>
                                                    <option value="12">AC</option>
                                                    <option value="27">AL</option>
                                                    <option value="16">AP</option>
                                                    <option value="13">AM</option>
                                                    <option value="29">BA</option>
                                                    <option value="23">CE</option>
                                                    <option value="32">ES</option>
                                                    <option value="52">GO</option>
                                                    <option value="21">MA</option>
                                                    <option value="51">MT</option>
                                                    <option value="50">MS</option>
                                                    <option value="31">MG</option>
                                                    <option value="15">PA</option>
                                                    <option value="25">PB</option>
                                                    <option value="41">PR</option>
                                                    <option value="26">PE</option>
                                                    <option value="22">PI</option>
                                                    <option value="33">RJ</option>
                                                    <option value="24">RN</option>
                                                    <option value="43">RS</option>
                                                    <option value="11">RO</option>
                                                    <option value="14">RR</option>
                                                    <option value="42">SC</option>
                                                    <option value="35">SP</option>
                                                    <option value="28">SE</option>
                                                    <option value="17">TO</option>
                                                    <option value="53">DF</option>
                                                                                
                                                </select>                                            
                                            </div> 
                                            
                                            <div class="col-md-3" style="margin-top: 10px;">
                                                <label for="cbindinport">Origem:</label>
                                                <select class="form-control" id="cbindinport" v-model="vindimport" v-bind:disabled="ativadesativa">
                                                    <option value=""></option>
                                                    <option value="0">Nacional</option>
                                                    <option value="1">Importado</option>						
                                                </select>                                            
                                            </div> 
                                            <div class="col-sm-12 col-md-2 col-lg-2" style="margin-top: 10px;">
                                                <label for="edpgni">Perc.UF(%):</label>
                                                <money type="text" class="form-control form-control-sm" id="edpgni"
                                                        v-model="vporig" v-bind="money" v-bind:disabled="ativadesativa"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            
                                        </div> 
                                    </div>                                    
                                    <div id="dvinfadpro" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <textarea class="form-control center" rows="3" id="txtinfadprod" v-model="vinfadprod" maxlength="500"></textarea>
                                            </div>
                                            <div class="col-md-12 text-right">
                                                <span class="text-black-50" style="font-size: 12px; font-weight: 600;">{{ vinfadprod.length }} caracteres de 500</span>
                                            </div>                                            
                                        </div>
                                    </div>     
                                    <!-- Informação Reforma Tributária -->
                                    <div id="dvibscbs" class="container-fluid tab-pane ">
                                        <!-- IBSCS - Selects CST e Classificação Tributária -->
                                        <div class="row">
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label  for="cbcstcbs">Situação Tributária (CST) do IBS e CBS:</label>
                                                <select class="form-control form-control-sm" id="cbcstcbs" v-model="vCstIBSCBS" v-bind:disabled="ativadesativa" @change="SelecionarCamposGrupoFiscalIBSCBS('CST',vCstIBSCBS)">
                                                    <option value="">Selecione...</option>
                                                    <option v-for="(item, idxcst) in lstCstsIBSCBS" v-bind:key="idxcst" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                <label  for="cbclasstrib">Classificação Tributária (cClassTrib):</label>
                                                <select class="form-control form-control-sm" id="cbclasstrib" v-model="vcClassTrib" v-bind:disabled="ativadesativa" @change="SelecionarCamposGrupoFiscalIBSCBS('cClassTrib',vcClassTrib)">
                                                    <option value="">Selecione...</option>
                                                    <option v-for="(item, idxclasstrib) in lstcClassTribs" v-bind:key="idxclasstrib" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!-- IBSCBS - Tributação Padrão -->
                                        <div v-show="camposCstIBSCBS && camposCstIBSCBS.ind_gIBSCBS" class="row mt-3">
                                            <hr>
                                            <!-- Card IBS Estadual -->
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <div class="card container-fluid mb-3" style="background-color: rgb(247 247 247);">
                                                    <div class="col-12 mt-3 mb-3" style="cursor: pointer;">
                                                        <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                                            <input type="checkbox" class="custom-control-input" id="swpadroesntibsuf" @change="DefineValoresPadroesIBSCBS(swValPadroesIBSUF, 'IBSUF')"
                                                                name="swpadroesntibsuf" v-model="swValPadroesIBSUF" v-bind:disabled="ativadesativa">
                                                            <label class="custom-control-label" for="swpadroesntibsuf" style="cursor: pointer; font-size: 14px;" :style="{ color: swValPadroesIBSUF ? '#666666' : '#a6abb3' }">Preencher Valores NT 2025.002 v1.31</label>
                                                        </div>
                                                    </div>
                                                    <hr>
                                                    <div class="col-12 mt-3">
                                                        <label for="edAliqIBSUF">Alíquota IBS Estadual (%)</label>
                                                        <money type="text" class="form-control form-control-sm" id="edAliqIBSUF"
                                                                v-model="vAliqIBSUF" v-bind="money" v-bind:disabled="ativadesativaibsuf" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-12 mt-3">
                                                        <label for="edRedAliqIBSUF">Redução de Alíquota IBS Estadual (%)</label>
                                                        <money type="text" class="form-control form-control-sm" id="edRedAliqIBSUF"
                                                                v-model="vAliqRedIBSUF" v-bind="money" v-bind:disabled="ativadesativaibsuf" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-12 mt-3 mb-4">
                                                        <label for="edRedAliqIBSUF">Diferimento do IBS Estadual (%)</label>
                                                        <money type="text" class="form-control form-control-sm" id="edRedAliqIBSUF"
                                                                v-model="vAliqDifIBSUF" v-bind="money" v-bind:disabled="ativadesativaibsuf" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Card IBS Municipal -->
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <div class="container-fluid card mb-3" style="background-color: rgb(247 247 247);">
                                                    <div class="col-12 mt-3 mb-3" style="cursor: pointer;">
                                                        <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                                            <input type="checkbox" class="custom-control-input" id="swpadroesntibsmun"
                                                            name="swpadroesntibsmun" v-model="swValPadroesIBSMun" v-bind:disabled="ativadesativa" @change="DefineValoresPadroesIBSCBS(swValPadroesIBSMun, 'IBSMUN')">
                                                            <label class="custom-control-label" for="swpadroesntibsmun" style="cursor: pointer; font-size: 14px;" :style="{ color: swValPadroesIBSMun ? '#666666' : '#a6abb3' }">Preencher Valores NT 2025.002 v1.31</label>
                                                        </div>
                                                    </div>
                                                    <hr>
                                                    <div class="col-12 mt-3">
                                                        <label for="edAliqIBSMUN">Alíquota IBS Municipal (%)</label>
                                                        <money type="text" class="form-control form-control-sm" id="edAliqIBSMUN"
                                                                v-model="vAliqIBSMun" v-bind="money" v-bind:disabled="ativadesativaibsmun" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-12 mt-3">
                                                        <label for="edRedAliqIBSMUN">Redução de Alíquota IBS Municipal (%)</label>
                                                        <money type="text" class="form-control form-control-sm" id="edRedAliqIBSMUN"
                                                                v-model="vAliqRedIBSMun" v-bind="money" v-bind:disabled="ativadesativaibsmun" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-12 mt-3 mb-4">
                                                        <label for="edRedAliqIBSMUN">Diferimento do IBS Municipal (%)</label>
                                                        <money type="text" class="form-control form-control-sm" id="edRedAliqIBSMUN"
                                                                v-model="vAliqDifIBSMun" v-bind="money" v-bind:disabled="ativadesativaibsmun" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Card CBS -->
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <div class="card container-fluid mb-3" style="background-color: rgb(247 247 247);">
                                                    <div class="col-12 mt-3 mb-3">
                                                        <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                                            <input type="checkbox" class="custom-control-input" id="swpadroescbs" @change="DefineValoresPadroesIBSCBS(swValPadroesCBS, 'CBS')"
                                                            name="swpadroescbs" v-model="swValPadroesCBS" v-bind:disabled="ativadesativa">
                                                            <label class="custom-control-label" for="swpadroescbs" style="cursor: pointer; font-size: 14px;" :style="{ color: swValPadroesCBS ? '#666666' : '#a6abb3' }">Preencher Valores NT 2025.002 v1.31</label>
                                                        </div>
                                                    </div>
                                                    <hr>
                                                    <div class="col-12 mt-3">
                                                        <label for="edAliqCBS">Alíquota da CBS (%)</label>
                                                        <money type="text" class="form-control form-control-sm" id="edAliqCBS"
                                                                v-model="vAliqCBS" v-bind="money" v-bind:disabled="ativadesativacbs" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-12 mt-3">
                                                        <label for="edRedAliqCBS">Redução de Alíquota da CBS (%)</label>
                                                        <money type="text" class="form-control form-control-sm" id="edRedAliqCBS"
                                                                v-model="vAliqRedCBS" v-bind="money" v-bind:disabled="ativadesativacbs" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-12 mt-3 mb-4">
                                                        <label for="edRedAliqCBS">Diferimento da CBS (%)</label>
                                                        <money type="text" class="form-control form-control-sm" id="edRedAliqCBS"
                                                                v-model="vAliqDifCBS" v-bind="money" v-bind:disabled="ativadesativacbs" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Tributação Regular -->
                                        <div v-show="camposcClassTribIBSCBS && camposcClassTribIBSCBS.ind_gTribRegular" class="row">
                                            <hr>
                                            <div class="col-12 mt-3 mb-1">
                                                <h6><strong>Tributação Regular</strong> <small>cClassTrib {{ vcClassTrib }}</small></h6>
                                            </div>
                                            <!-- CST Regular -->
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label  for="cbcstcbs">Situação Tributária Regular (CST Regular)</label>
                                                <select class="form-control form-control-sm" id="cbcstcbs" v-model="vCstIBSCBSReg" v-bind:disabled="ativadesativa" @change="SelecionarCamposGrupoFiscalIBSCBSReg('CST',vCstIBSCBSReg)">
                                                    <option value="">Selecione...</option>
                                                    <option v-for="(item, idxcst) in lstCstsIBSCBS" v-bind:key="idxcst" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>
                                            </div>
                                            <!-- cClassTrib Regular -->
                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                <label  for="cbclasstrib">Código de Classificação Tributária Regular</label>
                                                <select class="form-control form-control-sm" id="cbclasstrib" v-model="vcClassTribReg" v-bind:disabled="ativadesativa" @change="SelecionarCamposGrupoFiscalIBSCBSReg('cClassTrib',vcClassTribReg)">
                                                    <option value="">Selecione...</option>
                                                    <option v-for="(item, idxclasstrib) in lstcClassTribsReg" v-bind:key="idxclasstrib" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4 mt-4">
                                                <label for="edAliqEfetIBSUFReg">Alíq. Efet. IBS UF </label>
                                                <money type="text" class="form-control form-control-sm" id="edAliqEfetIBSUFReg"
                                                        v-model="pAliqEfetIBSUFReg" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4 mt-4">
                                                <label for="edAliqEfetIBSMunReg">Alíq. Efet. IBS Mun </label>
                                                <money type="text" class="form-control form-control-sm" id="edAliqEfetIBSMunReg"
                                                        v-model="pAliqEfetIBSMunReg" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4 mt-4">
                                                <label for="edAliqEfetCBSReg">Alíq. Efet. CBS </label>
                                                <money type="text" class="form-control form-control-sm" id="edAliqEfetCBSReg"
                                                        v-model="pAliqEfetCBSReg" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                        </div>
                                        <!-- IBSCBS - Tributação Monofásica -->
                                        <div v-show="camposCstIBSCBS && vcClassTrib && camposCstIBSCBS.ind_gIBSCBSMono" class="row mt-3">
                                            <!-- Só mostra os campos de TribMono se vcClassTrib estiver definido -->
                                            <div class="col-12 mb-1">
                                                <h6><strong>Tributação Monofásica</strong> <small>CST {{ vCstIBSCBS }}</small></h6>
                                            </div>
                                            <!-- Card Tributação Normal -->
                                            <div v-show="camposcClassTribIBSCBS && camposcClassTribIBSCBS.ind_gMonoPadrao" class="col-sm-12 col-md-3 col-lg-3">
                                                <div class="card container-fluid mb-3" style="background-color: rgb(247 247 247);">
                                                    <div class="col-12 mt-3">
                                                        <h6 style="margin-bottom: 0; color: grey;"><strong>Tributação Padrão</strong></h6>
                                                    </div>
                                                    <hr>
                                                    <div class="col-12 mt-1">
                                                        <label for="edAliqAdRemIBS">Alíquota ad rem do IBS</label>
                                                        <money type="text" class="form-control form-control-sm" id="edAliqAdRemIBS"
                                                                v-model="vAliqAdRemIBS" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-12 mt-3 mb-4">
                                                        <label for="edAliqAdRemCBS">Alíquota ad rem do CBS</label>
                                                        <money type="text" class="form-control form-control-sm" id="edAliqAdRemCBS"
                                                                v-model="vAliqAdRemCBS" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Card Tributação Sujeita a Retenção -->
                                            <div v-show="camposcClassTribIBSCBS && camposcClassTribIBSCBS.ind_gMonoReten" class="col-sm-12 col-md-3 col-lg-3">
                                                <div class="card container-fluid mb-3" style="background-color: rgb(247 247 247);">
                                                    <div class="col-12 mt-3">
                                                        <h6 style="margin-bottom: 0; color: grey;"><strong>Tributação Sujeita a Retenção</strong></h6>
                                                    </div>
                                                    <hr>
                                                    <div class="col-12 mt-1">
                                                        <label for="edAliqAdRemIBSReten">Alíquota ad rem do IBS sujeito a retenção</label>
                                                        <money type="text" class="form-control form-control-sm" id="edAliqAdRemIBSReten"
                                                                v-model="vAliqAdRemIBSReten" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-12 mt-3 mb-4">
                                                        <label for="edAliqAdRemCBSReten">Alíquota ad rem da CBS sujeita a retenção</label>
                                                        <money type="text" class="form-control form-control-sm" id="edAliqAdRemCBSReten"
                                                                v-model="vAliqAdRemCBSReten" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Card Tributação Retida Anteriormente -->
                                            <div v-show="camposcClassTribIBSCBS && camposcClassTribIBSCBS.ind_gMonoRet" class="col-sm-12 col-md-3 col-lg-3">
                                                <div class="card container-fluid mb-3" style="background-color: rgb(247 247 247);">
                                                    <div class="col-12 mt-3">
                                                        <h6 style="margin-bottom: 0; color: grey;"><strong>Tributação Retida Anteriormente</strong></h6>
                                                    </div>
                                                    <hr>
                                                    <div class="col-12 mt-1">
                                                        <label for="edAliqAdRemIBSRet">Alíquota ad rem do IBS sujeito a retenção</label>
                                                        <money type="text" class="form-control form-control-sm" id="edAliqAdRemIBSRet"
                                                                v-model="vAliqAdRemIBSRet" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-12 mt-3 mb-4">
                                                        <label for="edAliqAdRemCBSRet">Alíquota ad rem da CBS sujeita a retenção</label>
                                                        <money type="text" class="form-control form-control-sm" id="edAliqAdRemCBSRet"
                                                                v-model="vAliqAdRemCBSRet" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Card Diferimento da Tributação -->
                                            <div v-show="camposcClassTribIBSCBS && camposcClassTribIBSCBS.ind_gMonoDif" class="col-sm-12 col-md-3 col-lg-3">
                                                <div class="card container-fluid mb-3" style="background-color: rgb(247 247 247);">
                                                    <div class="col-12 mt-3">
                                                        <h6 style="margin-bottom: 0; color: grey;"><strong>Diferimento da Tributação</strong></h6>
                                                    </div>
                                                    <hr>
                                                    <div class="col-12 mt-1">
                                                        <label for="edAliqDifIBSMono">Percentual do diferimento do imposto monofásico IBS (%)</label>
                                                        <money type="text" class="form-control form-control-sm" id="edAliqDifIBSMono"
                                                                v-model="vAliqDifIBSMono" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-12 mt-3 mb-4">
                                                        <label for="edAliqDifCBSMono">Percentual do diferimento do imposto monofásico CBS (%)</label>
                                                        <money type="text" class="form-control form-control-sm" id="edAliqDifCBSMono"
                                                                v-model="vAliqDifCBSMono" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- IBSCBS - Crédito Presumido da Operação -->
                                        <div v-show="camposcClassTribIBSCBS && camposcClassTribIBSCBS.ind_gCredPresOper" class="row mt-1">
                                            <div class="col-12 mb-1">
                                                <h6><strong>Crédito Presumido</strong></h6>
                                            </div>
                                            <!-- Card Crédito Presumido -->
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <div class="card container-fluid pb-4" style="background-color: rgb(247 247 247);">
                                                    <div class="col-12 mt-3 mb-3" style="cursor: pointer;">
                                                        <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                                            <input type="checkbox" class="custom-control-input" id="edswcredpresumido"
                                                                name="edswcredpresumido" v-model="swCredPresumido" v-bind:disabled="ativadesativa">
                                                            <label class="custom-control-label" for="edswcredpresumido" style="cursor: pointer;" :style="{ color: swCredPresumido ? '#666666' : '#a6abb3' }">Informar crédito presumido</label>
                                                        </div>
                                                    </div>
                                                    <template v-if="swCredPresumido">
                                                        <hr>
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <label for="cbcCredPres">Classificação do Crédito Presumido do IBS e da CBS</label>
                                                                <select class="form-control form-control-sm" id="cbcCredPres" v-model="vcCredPres" v-bind:disabled="ativadesativa">
                                                                    <option value="">Selecione...</option>
                                                                    <option v-for="(item, indice) in lstCstCredPresumido" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                                </select>
                                                            </div>
                                                            <div class="col-12 col-md-6 col-lg-6 mt-3">
                                                                <label for="edPerCredPresIBS">Percentual do Crédito Presumido do IBS (%)</label>
                                                                <money type="text" class="form-control form-control-sm" id="edPerCredPresIBS"
                                                                        v-model="vpCredPresIBS" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                        data-bv-group=".group" style="text-align:right;">
                                                                </money>
                                                            </div>
                                                            <div class="col-12 col-md-6 col-lg-6 mt-3">
                                                                <label for="edPerCredPresCBS">Percentual do Crédito Presumido da CBS (%)</label>
                                                                <money type="text" class="form-control form-control-sm" id="edPerCredPresCBS"
                                                                        v-model="vpCredPresCBS" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                        data-bv-group=".group" style="text-align:right;">
                                                                </money>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Lembrete Transferência de Crédito -->
                                        <div v-show="camposCstIBSCBS && camposCstIBSCBS.ind_gTransfCred" class="row mt-3">
                                            <div class="col-12 col-md-6 col-lg-6 mt-3">
                                                <label for="edvIBSTransfCred">Valor do IBS a ser transferido</label>
                                                <money type="text" class="form-control form-control-sm" id="edvIBSTransfCred"
                                                        v-model="vIBSTransfCred" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-12 col-md-6 col-lg-6 mt-3">
                                                <label for="edvCBSTransfCred">Valor da CBS a ser transferida</label>
                                                <money type="text" class="form-control form-control-sm" id="edvCBSTransfCred"
                                                        v-model="vCBSTransfCred" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                        </div>
                                        <!-- Lembrete Ajuste de Competência -->
                                        <!-- A FAZER -->
                                        <div v-show="camposCstIBSCBS && camposCstIBSCBS.ind_gAjusteCompet" class="row mt-3">
                                            <div class="col-md-12">
                                                <div class="alert alert-info" role="alert">
                                                    <i class="fa fa-exclamation-triangle"></i>
                                                    <strong> Lembrete: </strong>Disponível em breve...
                                                </div>
                                            </div>
                                        </div>
                                        <!-- IBSCBS - Compra Governamental -->
                                        <!-- <div class="row mt-3">
                                            <div class="col-12 mb-1">
                                                <h6><strong>Compra Governamental</strong></h6>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <div class="card container-fluid pb-4" style="background-color: rgb(247 247 247);">
                                                    <div class="col-12 mt-3 mb-3" style="cursor: pointer;">
                                                        <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                                            <input type="checkbox" class="custom-control-input" id="edswcompragov"
                                                                name="edswcompragov" v-model="swCompraGov" v-bind:disabled="ativadesativa">
                                                            <label class="custom-control-label" for="edswcompragov" style="cursor: pointer;" :style="{ color: swCompraGov ? '#666666' : '#a6abb3' }">Informar compra governamental</label>
                                                        </div>
                                                    </div>
                                                    <template v-if="swCompraGov">
                                                        <hr>
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                                <div class="col-12">
                                                                    <label for="cbEnteGov">Ente Governamental</label>
                                                                    <select class="form-control form-control-sm" id="cbEnteGov" v-model="vTpEnteGov" v-bind:disabled="ativadesativa">
                                                                        <option value="">Selecione...</option>
                                                                        <option value="1">1 - União</option>
                                                                        <option value="2">2 - Estados</option>
                                                                        <option value="3">3 - Distrito Federal</option>
                                                                        <option value="4">4 - Municípios</option>
                                                                    </select>
                                                                </div>
                                                                <div class="col-12 mt-3">
                                                                    <label for="edAliqRedutorGov">Percentual Redutor</label>
                                                                    <money type="text" class="form-control form-control-sm" id="edAliqRedutorGov"
                                                                            v-model="vAliqRedutorGov" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                            data-bv-group=".group" style="text-align:right;">
                                                                    </money>
                                                                </div>
                                                                <div class="col-12 mt-3 mb-4">
                                                                    <label for="cbTipoOperacaoGov">Tipo da Operação com Ente Gov.</label>
                                                                    <select class="form-control form-control-sm" id="cbTipoOperacaoGov" v-model="vTpOperGov" v-bind:disabled="ativadesativa">
                                                                        <option value="">Selecione...</option>
                                                                        <option value="1">1 - Fornecimento</option>
                                                                        <option value="2">2 - Recebimento de Pagamento</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                                <div class="col-12">
                                                                    <label for="edAliqAdRemIBSRet">Alíquota IBS UF (%)</label>
                                                                    <money type="text" class="form-control form-control-sm" id="edAliqAdRemIBSRet"
                                                                            v-model="vpAliqIBSUFGov" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                            data-bv-group=".group" style="text-align:right;">
                                                                    </money>
                                                                </div>
                                                                <div class="col-12 mt-3">
                                                                    <label for="edAliqAdRemIBSRet">Alíquota IBS Município (%)</label>
                                                                    <money type="text" class="form-control form-control-sm" id="edAliqAdRemIBSRet"
                                                                            v-model="vpAliqIBSMunGov" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                            data-bv-group=".group" style="text-align:right;">
                                                                    </money>
                                                                </div>
                                                                <div class="col-12 mt-3 mb-4">
                                                                    <label for="edAliqAdRemIBSRet">Alíquota CBS (%)</label>
                                                                    <money type="text" class="form-control form-control-sm" id="edAliqAdRemIBSRet"
                                                                            v-model="vpAliqCBSGov" v-bind="money" v-bind:disabled="ativadesativa" 
                                                                            data-bv-group=".group" style="text-align:right;">
                                                                    </money>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div id="dvis" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <!-- IS aguardando definições Os campos de IS estão aguardando publicação oficial -->
                                                <div class="alert alert-info" role="alert" style="background-color: #fff3b9 !important">
                                                    <i class="fa fa-info-circle"></i>
                                                    <strong> Informativo:</strong> Os campos referentes ao Imposto sobre Serviços (IS) estão aguardando definições oficiais para serem implementados.
                                                </div>
                                            </div>
                                            <!-- até então não saiu a lista da situação tributária (IS) -->

                                            <!-- <div class="col-md-12">
                                                <label for="cbcstipi">Código da situação tributária (IS) :</label>
                                                <select class="form-control form-control-sm" id="cbcstpipi" v-model="vcstis" v-bind:disabled="ativadesativa">
                                                    <option v-for="(item, indice) in cstis" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>                                                
                                            </div> -->
                                            <!-- <div class="col-sm-12 col-md-12">
                                                <label for="edcenq">Código da situação tributária (IS) :</label>
                                                <input type="text" class="form-control form-control-sm" id="edcenq"
                                                    v-model="vcstis" v-bind:disabled="ativadesativa"
                                                    data-bv-group=".group" maxlength="3">
                                            </div> 


                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edpis">Alíquota IS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpis"
                                                        v-model="vpis" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>

                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvis">Valor do IS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvis"
                                                        v-model="vvis" v-bind="moneyprecision" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>

                                            <div class="col-sm-12 col-md-9 col-lg-9">
                                                <label for="edpisep">Alíquota específica por unidade de medida apropriada:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpisep"
                                                        v-model="vpisesp" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div> -->
                                                                                      
                                        </div>
                                    </div>   
                                </div>    
                            </div>
                        </div>                        
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdgravaritem()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal para seleção da classe -->
		<div class="modal fade" id="mdselecionarclasse">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="list-group">								
                                <a v-for="(classe, index) in lstclasses" href="#" v-bind:key="index" class="list-group-item list-group-item-action font-weight-bold" @click.prevent="mtddefineclasse(classe)">{{ mtdformatarzeros(classe.id, 2) }} - {{ classe.descricao }}</a>
							</div>							
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>
        <!-- Modal para seleção do fator de divisão -->
		<div class="modal fade" id="mdselecionafator">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
                            <div class="col-12">
								<label for="edfator">*Fator(%):</label>
								<money type="text" class="form-control form-control-sm" id="edfator" v-model="vfator" v-bind="money" data-bv-group=".group"  style="text-align:right;"></money>
							</div>		
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12">
                                <div class="row justify-content-end">
                                    <button type="button" class="btn btn-primary btn-sm"  @click.prevent="mtdgravafator()" > Confirmar</button>
                                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="margin-left: 20px" ><i class="fa fa-close"></i> Fechar</button>
                                </div>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>
		<!-- Modal de inclusão de nfe/cte referênciadas -->
		<div class="modal fade" id="mdnotaref">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-edit"></i> Inclusão de NF-e/CT-e referenciada</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbtiponfref">Tipo:</label>
                                <select class="form-control form-control-sm" id="cbtiponfref" v-model="vtiponfref">
                                    <option value="0">NF-e</option>
                                    <option value="1">CT-e</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edchavenfref">*Chave de acesso:</label>
                                <input type="text" v-model="vchavenfref"
                                        class="form-control form-control-sm" id="edchavenfref" maxlength="60">
                            </div>                                                 						
						</div>                                               
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdadicionarnotaref()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
					</div>        
				</div>
			</div>
		</div>


		<!-- Modal de cobrança -->
		<div class="modal fade" id="mdcobranca">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-edit"></i> Inclusão de parcela da cobrança</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-6 col-lg-6">
								<label for="eddvenc">*Data Vencimento:</label>
								<div class="input-group">
									<date-picker id="eddvenc" v-model="vdvenc" :config="options"
										class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
								<label for="edvdup">*Valor:</label>
								<money type="text" class="form-control form-control-sm" id="edvdup" v-model="vvdup" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
							</div>
						</div>                       
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdgravarparcela()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal de formas de pagamento -->
		<div class="modal fade" id="mdformapagamento">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-edit"></i> Inclusão de forma de pagamento</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div  class="col-sm-12 col-md-8 col-lg-8">
                                <span class="lblselect2">*Forma de pagamento:</span>
                                <select id="cbformapagamento" data-placeholder="Selecione uma forma" v-model="vidforma" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edvpag">*Valor:</label>
								<money type="text" class="form-control form-control-sm" id="edvpag" v-model="vvpag" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
							</div>
                            <div v-if="visualizacaut" class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edcaut">Nr. Autorização:</label>
                                <input type="text" v-model="vcaut"
                                        class="form-control form-control-sm" id="edcaut" maxlength="20">
                            </div>                                                                                     
						</div>                       
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdgravarformapagamento()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal de volumes de frete -->
		<div class="modal fade" id="mdvolumefrete">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-edit"></i> Inclusão de volume</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edqvol">Qtd. Volumes:</label>
                                <money type="text" class="form-control form-control-sm" id="edqvol" v-bind="money"
                                        v-model="vqvol" v-bind:disabled="ativadesativa"></money>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edesp">Espécie:</label>
                                <input type="text" v-model="vesp" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="edesp" maxlength="60">
                            </div>                                                       						
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edmarca">Marca:</label>
                                <input type="text" v-model="vmarca" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="edmarca" maxlength="60">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="ednvol">Num. volumes:</label>
                                <input type="text" v-model="vnvol" v-bind:disabled="ativadesativa" title="Numeração dos volumes"
                                        class="form-control form-control-sm" id="ednvol" maxlength="60">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edpesol">Peso líquido:</label>
                                <money type="text" class="form-control form-control-sm" id="edpesol" v-bind="peso"
                                        v-model="vpesol" v-bind:disabled="ativadesativa"></money>
                            </div>                            
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edpesob">Peso bruto:</label>
                                <money type="text" class="form-control form-control-sm" id="edpesob" v-bind="peso"
                                        v-model="vpesob" v-bind:disabled="ativadesativa"></money>
                            </div>
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center" style="padding: 5px;">LACRES</div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="ednlacre">Nr. Lacre:</label>
                                                <input type="text" class="form-control form-control-sm" id="ednlacre"
                                                        v-model="vnlacre" data-bv-group=".group" maxlength="60">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <button type="button" id="btinclacre" class="btn btn-info btn-sm"
                                                        @click.prevent="mtdincluirlacre()"
                                                        style="width:100%; margin-top: 22px; margin-bottom: 10px;">
                                                    <i class="fa fa-plus-circle"></i> Incluir</button>
                                            </div>
                                            <div v-if="lstlacres.length > 0" class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistalacres" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-dark">
                                                        <tr>
                                                            <th>Nr. Lacre:</th>
                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody id="lstlacresvolume">
                                                            <tr v-for="(lacre, index) in lstlacres" v-bind:key="index">
                                                                <td>{{ lacre.nlacre }}</td>
                                                                <td width="35px" class="center" style="text-align: center;">
                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                    v-bind:disabled="ativadesativa"
                                                                    @click.prevent="mtddeletarlacre(index)"><i class="fa fa-trash"></i></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                                        
                            </div>
						</div>                       
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdgravarvolumefrete()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal de cartas de correção -->
		<div class="modal fade" id="mdcartacorrecao">
			<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-envelope-o"></i> Cartas de correção</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div id="dvlistacartas" class="row">
                            <div class="col-md-4 col-lg-4 col-xl-2">
                                <label>NF. Número:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.nnf" disabled style="font-weight: bold; text-align: right;">
                            </div>
                            <div class="col-md-4 col-lg-4 col-xl-2">
                                <label>Série:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.serie" disabled style="font-weight: bold; text-align: right;">
                            </div>
                            <div class="col-md-4 col-lg-4 col-xl-2">
                                <label>Modelo:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.modelo" disabled style="font-weight: bold; text-align: right;">
                            </div>                            
                            <div class="col-md-12 col-lg-12 col-xl-6">
                                <label>Chave de acesso:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.chave" disabled style="font-weight: bold; text-align: center;">
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <label>Filial:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.fantasiafil" disabled style="font-weight: bold;">
                            </div>                             
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <label>Destinatário:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.nomedestinatario" disabled style="font-weight: bold;">
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-2">
                                <label>Emissão:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.dthremissao" disabled style="font-weight: bold; text-align: right;">
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-2">
                                <label>Total da Nota:</label>
                                <money type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.totalnota" v-bind="money" style="font-weight: bold; text-align:right;" disabled></money>
                            </div>
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center" style="padding: 5px;">CARTAS DE CORREÇÕES EXISTENTES PARA A NF-e</div>
                                    <div class="card-body" style="padding-top: 15px; padding-bottom: 5px;">
                                        <div class="row">
                                            <div class="col-md-8 col-lg-10 col-xl-10">
                                            </div>
                                            <div class="col-md-4 col-lg-2 col-xl-2">
                                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdincluircarta()">
                                                    <i class="fa fa-plus-circle"></i> Incluir
                                                </button>
                                            </div>
                                            <div v-if="lstcartas.length > 0" class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistacartas" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-dark">
                                                        <tr>
                                                            <th width="80px" style="text-align: center;">Nr. Carta:</th>
                                                            <th width="100px" style="text-align: center;">Situação:</th>                                                            
                                                            <th>Texto da carta de correção:</th>                                                            
                                                            <th>Retorno sefaz:</th>
                                                            <th width="130px" style="text-align: center;">Opções:</th>                                                            
                                                        </tr>
                                                        </thead>
                                                        <tbody id="lstcartas">
                                                            <tr v-for="(carta, index) in lstcartas" v-bind:key="index">
                                                                <td style="text-align: center;">{{ mtdformatarzeros(carta.nseqevento, 2) }}</td>
                                                                <td v-if="parseInt(carta.situacaocc) === 0" style="text-align: center;">
                                                                    <span class="badge badge-primary bdg-digitacao">Em digitação</span>
                                                                </td>
                                                                <td v-else style="text-align: center;">
                                                                    <span class="badge badge-primary bdg-autorizada">Enviada</span>
                                                                </td>                                                                    
                                                                <td>{{ carta.xcorrecao }}</td>
                                                                <td>{{ carta.xmotivo }}</td>
                                                                <td width="35px" class="center" style="text-align: center;">
                                                                    <a v-if="parseInt(carta.situacaocc) === 0" class="btn btn-info btn-sm btn-opcrud ajt-btn" href="#"
                                                                    @click.prevent="mtdenviarcarta(carta)" title="Enviar"><i class="fa fa-paper-plane"></i></a>                                                                         
                                                                    <a v-if="parseInt(carta.situacaocc) === 0" class="btn btn-primary btn-sm btn-opcrud ajt-btn" href="#"
                                                                    @click.prevent="mtdalterarcarta(carta)" title="Editar"><i class="fa fa-edit"></i></a> 
                                                                    <a v-if="parseInt(carta.situacaocc) === 0" class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                    @click.prevent="mtddeletarcarta(carta)" title="Remover"><i class="fa fa-trash"></i></a>
                                                                    <a v-if="parseInt(carta.situacaocc) === 1" class="btn btn-primary btn-sm btn-opcrud ajt-btn" href="#"
                                                                    @click.prevent="mtdimprimircarta(carta)" title="Imprimir"><i class="fa fa-print"></i></a>                                                                        
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                                        
                            </div>                            
						</div>
                        <div id="dvedicaocarta" class="row">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header card-in text-center" style="padding: 5px;">{{ titcartacorrecao }}</div>
                                    <div class="card-body" style="padding-top: 5px; padding-bottom: 5px;">
                                        <div class="row">
                                            <div class="col-sm-10 col-md-8 col-lg-8 col-xl-10">
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-2">
                                                <label>Data Emissão:</label>
                                                <div class="input-group">
                                                    <date-picker v-model="vdthremissaocarta" :config="options"
                                                        class="form-control form-control-sm" disabled></date-picker>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                    </div>										
                                                </div>
                                            </div>                                            
                                            <div class="col-md-12">
                                                <label>Texto da carta de correção:</label>
                                                <textarea class="form-control center" rows="5" id="txtconteudocarta" v-model="vconteudocarta" maxlength="1000"></textarea>
                                            </div>
                                            <div class="col-md-12">
                                                <label>Condições de uso da carta de correção:</label>
                                                <p id="pcondusucarta">
                                                    A Carta de Correção é disciplinada pelo parágrafo 1º - A do art. 7o do Convênio S/N, de 15 de dezembro de 1970 e pode ser utilizada para regularização de erro ocorrido na 
                                                    emissão de documento fiscal, desde que o erro nao esteja relacionado com: I - as variáveis que determinam o valor do imposto tais como: base de cálculo, alíquota, diferença 
                                                    de preço, quantidade, valor da operação ou da prestacão; II - a correção de dados cadastrais que implique mudanca do remetente ou do destinatário; III - a data de emissão 
                                                    ou de saída.                                                    
                                                </p>
                                            </div>                                            
                                        </div>
                                    </div>
                                    <div class="card-footer">
                                        <div class="row" style="padding-bottom: 10px;">
                                            <div class="col-12 col-sm-4 col-md-4 col-lg-8 col-xl-8">
                                            </div>
                                            <div class="col-6 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdgravarcartacorrecao()">
                                                    <i class="fa fa-check"></i> Salvar
                                                </button>                                                
                                            </div>
                                            <div class="col-6 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelaredicaocartacorrecao()">
                                                    <i class="fa fa-close"></i> Fechar
                                                </button>                                                                                                
                                            </div>                                                                                        
                                        </div>
                                    </div>                                    
                                </div>                                                        
                            </div>
                        </div>
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 130px;"><i class="fa fa-sign-out"></i> Sair</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal de inutilização -->
		<div class="modal fade" id="mdinutilizacao">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-minus-circle"></i> Inutilização</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-12 col-lg-12">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialinutilizacao" data-placeholder="Selecione uma filial" v-model="iidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
                            <div class="col-4 col-sm-4 col-md-4 col-lg-4">
                                <label>Modelo:</label>
                                <select name="cbmodeloinutilizacao" class="form-control form-control-sm" id="cbmodeloinutilizacao" v-model="inmodelo">
                                    <option value="55">55 - NF-e</option>
                                    <option value="65">65 - NFC-e</option>
                                </select>
                            </div>
                            <div class="col-4 col-sm-4 col-md-4 col-lg-4">
                                <label>Série:</label>
                                <input id="edserieinutilizacao" type="number" v-mask="'###'" class="form-control form-control-sm" v-model="inserie">
                            </div>
                            <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                                <label>Nr. Inicial:</label>
                                <input id="ednini" type="text" v-mask="'########'" class="form-control form-control-sm" v-model="inini">
                            </div>
                            <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                                <label>Nr. Final:</label>
                                <input id="ednfim" type="text" v-mask="'########'" class="form-control form-control-sm" v-model="infim">
                            </div>
                            <div class="col-sm-12">
                                <label>Motivo da inutilização:</label>
                                <textarea class="form-control center" rows="5" id="txtmotivoinutilizacao" v-model="ixjust" maxlength="255"></textarea>
                            </div>                                                                                                
						</div>                       
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmarinutilizacao()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
					</div>        
				</div>
			</div>
		</div>
        <!-- Modal Atribuir cfop para todos os itens --> 
        <div class="modal fade" id="mdatribuircfop" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir Classe de imposto à produtos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">                
                            <div class="col-md-12">
                                <span class="lblselect2">CFOP:</span>
                                <select id="cbcfoptodos" data-placeholder="Selecione uma opção"
                                    v-model="vidcfoptodos"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuircfop()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div> 


         <!-- Modal Atribuir dados aos itens --> 
         <div class="modal fade" id="mdalteradadositem" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir campos aos produtos selecionados</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">    
                            
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuircfop" v-model="vatribuircfop">
                                    <label class="custom-control-label" for="cbatribuircfop"></label>
                                </div>
                            </div>
                            <div class="col-md-11">
                                <span class="lblselect2">CFOP:</span>
                                <select id="cbcfopatrop" data-placeholder="Selecione uma opção"
                                    v-model="vidcfopdados" v-bind:disabled="!vatribuircfop"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirregime" v-model="vatribuirregime">
                                    <label class="custom-control-label" for="cbatribuirregime"></label>
                                </div>
                            </div>
                            <div class="col-11">
                                <label for="cbmes">Regime:</label>
                                <select name="cbregimeop" v-bind:disabled="!vatribuirregime" class="form-control form-control-sm" id="cbregimeop" @change="mtdmudarcstlt()"  v-model="vregimeop">
                                    <option value="1">Simples Nacional</option>
                                    <option value="2">Simples Nacional - excesso de sublimite de receita bruta</option>
                                    <option value="3">Regime Normal</option>
                                </select>
                            </div>  -->
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirorigem" v-model="vatribuirorigem">
                                    <label class="custom-control-label" for="cbatribuirorigem"></label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-11 col-lg-11">
                                <label for="cborigemop">Origem:</label>
                                <select v-bind:disabled="!vatribuirorigem" class="form-control form-control-sm" id="cborigemop"
                                    v-model="vorigemop" >
                                    <option value="0">0 - NACIONAL, EXCETO AS INDICADAS NOS CODIGOS 3 A 5</option>
                                    <option value="1">1 - ESTRANGEIRA - IMPORTACAO DIRETA, EXCETO A INDICADA NO CODIGO 6</option>
                                    <option value="2">2 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, EXCETO A INDICADA NO CODIGO 7</option>
                                    <option value="3">3 - NACIONAL, MERCADORIA OU BEM COM CONTEUDO DE IMPORTACAO SUPERIOR A 40% (QUARENTA POR CENTO)</option>
                                    <option value="4">4 - NACIONAL, CUJA PRODUCAO TENHA SIDO FEITA EM CONFORMIDADE
                                        COM OS PROCESSOS PRODUTIVOS BASICOS DE QUE TRATAM O DECRETO-LEI Nº 288/67 E
                                        AS LEIS N°S 8.248/91, 8.387/91,10.176/01 e 11.484/07
                                    </option>
                                    <option value="5">5 - NACIONAL, MERCADORIA OU BEM COM CONTEUDO DE IMPORTACAO
                                        INFERIOR OU IGUAL A 40% (QUARENTA POR CENTO)
                                    </option>
                                    <option value="6">6 - ESTRANGEIRA - IMPORTACAO DIRETA, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUCAO CAMEX</option>
                                    <option value="7">7 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUCAO CAMEX</option>
                                </select>
                            </div> 

                            <!-- <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuircst" v-model="vatribuicst">
                                    <label class="custom-control-label" for="cbatribuircst"></label>
                                </div>
                            </div>
                            <div class="col-11">
                                <label v-if="parseInt(vregimeop) === 3" for="cbregime">Código da situação tributária:</label>
                                <label v-else for="cbcst">CSOSN:</label>
                                <select class="form-control form-control-sm" id="cbcst" v-model="vcstop" v-bind:disabled="!vatribuicst" >
                                    <option v-for="(item, indice) in lstcstop" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                </select>
                            </div> -->

                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiricms" v-model="vatribuiicms">
                                    <label class="custom-control-label" for="cbatribuiricms"></label>
                                </div>
                            </div>
                            <div class="col-sm-11 col-md-11 col-lg-11">
								<label for="edvlunitario">A. ICMS(%):</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitario" v-model="vpicmsop" v-bind="moneyprecision" :disabled="!vatribuiicms"  data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>

                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuircstpis" v-model="vatribuicstpis">
                                    <label class="custom-control-label" for="cbatribuircstpis"></label>
                                </div>
                            </div>
                            <div class="col-md-11">
                                <label for="cbcstipi">CST PIS/COFiNS:</label>
                                <select class="form-control form-control-sm" id="cbcstpipiop" v-model="vcstpiscofinsop" v-bind:disabled="!vatribuicstpis">
                                    <option v-for="(item, indice) in cstpiscofins" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                </select>                                                
                            </div>

                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirpiscfins" v-model="vatribuialpiscofins">
                                    <label class="custom-control-label" for="cbatribuirpiscfins"></label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-11 col-lg-11">
								<label for="edvlunitario">A. PIS/COFiNS(%):</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitario" v-model="vpiscofinsop" v-bind="moneyprecision" :disabled="!vatribuialpiscofins"  data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>

                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuircstipi" v-model="vatribuircstipi">
                                    <label class="custom-control-label" for="cbatribuircstipi"></label>
                                </div>
                            </div>
                            <div class="col-md-11">
                                <label for="cbcstipi">CST IPI:</label>
                                <select class="form-control form-control-sm" id="cbcstpipiop" v-model="vcstipiop" v-bind:disabled="!vatribuircstipi">
                                    <option v-for="(item, indice) in cstipi" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                </select>                                                
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiralipi" v-model="vatribuialipi">
                                    <label class="custom-control-label" for="cbatribuiralipi"></label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-11 col-lg-11">
								<label for="edvlunitario">A. IPI(%):</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitario" v-model="vpipiop" v-bind="moneyprecision" :disabled="!vatribuialipi" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuirdados()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div> 

        <!-- Informa o e-amil do cliente para enviar xml e danfe --> 
        <div class="modal fade" id="mdinfemailcliente" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-envelope" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Enviar Xml e Danfe por e-mail</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">  
                            <div class="col-12">
                                <label for="edinfemailcliente">Informe o e-mail do cliente:</label>
                                <input type="edinfemailcliente" v-model="emailenviar"
                                    class="form-control form-control-sm" id="edinfemailcliente" maxlength="100"
                                    style="text-transform: lowercase;">
                            </div>                                          
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdenviardocsnfcliente()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>
        <!-- Rotina para correção da chave e xml da nfe --> 
        <div class="modal fade" id="mdcorrecaonf" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-qrcode" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Correção NF: {{mtdformatarzeros(cnfcorrecao.nnf, 8)}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body" style="padding-bottom: 0px;">
                        <div class="row">  
                            <div class="col-12">
                                <label for="edcchavenf">Informe a chave NF:</label>
                                <input type="text" v-model="cchavenf"
                                    class="form-control form-control-sm" id="edcchavenf" maxlength="150">
                            </div>
                            <div class="col-12" style="margin-top: 15px;">
                                <label for="txclayoutxml">Layout XML:</label>
                                <textarea class="form-control center" rows="5" id="txclayoutxml" v-model="clayoutxml"></textarea>
                            </div> 
                            <div class="col-12" style="margin-top: 15px;">
                                <div class="alert alert-danger">
                                    <strong>*Caso não tenha conhecimento desta rotina, não realize, entre em contato com nosso suporte técnico.</strong><br>
                                    <strong>*Após fazer a correção da NF, favor realizar uma consulta da mesma para atualização do seu status.</strong>
                                </div>                                
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdconfirmacorrecaonf()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div> 
        <!-- Rotina para agrupamento dos pedidos --> 
        <div class="modal fade" id="mdagruparpedidos" tabindex="-1">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-object-group" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Agrupamento de pedidos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialagr" data-placeholder="Selecione uma filial" v-model="aidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                                                      
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">Parceiro cliente:</span>
								<select id="cbclienteagr" data-placeholder="Selecione um cliente" v-model="aidcliente" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbporagr">Por:</label>
                                <select class="form-control form-control-sm" id="cbporagr" v-model="adtpor" >
                                    <option value="0">Emissão</option>
                                    <option value="1">Fatura</option>
                                </select>
                            </div> 
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtiniagr">De:</label>
								<div class="input-group">
									<date-picker id="eddtiniagr" v-model="adtini" :config="options" class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfimagr">até:</label>
								<div class="input-group">
									<date-picker id="eddtfimagr" v-model="adtfim" :config="options" class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>														
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <button type="button" id="btlistaragr" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdpesquisarpedidosagr()" style="margin-top: 20px;"><i class="fa fa-search"></i> Consultar</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th @click.prevent="mtdmarcartodos()"><i class="fa fa-plus-square-o" style="cursor: pointer; font-size: 16px; position: absolute; top: 20px; left: 25px;"></i></th>
                                            <th>Nr. Pedido:</th>
                                            <th></th>
                                            <th>Parceiro cliente:</th>
                                            <th>Data fatura:</th>
                                            <th>Total:</th>
                                            <th>Plano:</th>
                                            <th>Rota:</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(pedido, index) in lstpedidosagrupar" v-bind:key="index" style="font-size: 12px;">
                                                <td style="cursor: pointer; width: 30px; font-weight: bold; text-align: center; font-size: 18px;" @click.prevent="mtdhabilita(index)">
                                                    <i v-if="parseInt(pedido.selecionado) === 1" class="fa fa-check-square"></i>
                                                    <i v-else class="fa fa-square-o"></i>
                                                </td>
                                                <td style="width: 90px; font-weight: bold;">{{mtdformatarzeros(pedido.id, 8)}}</td>
                                                <td style="width: 30px; text-align: center;"><i @click.prevent="mtddetalhespedido(pedido.id)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido"></i></td>
                                                <td>{{pedido.nomecliente}}</td>
                                                <td style="width: 140px;">{{pedido.dtfatura}}</td>
                                                <td style="width: 120px; text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(pedido.totalgeral), 2)}}</td>
                                                <td style="width: 180px;">{{pedido.descplano}}</td>
                                                <td style="width: 180px;">{{pedido.descrota}}</td>
                                            </tr>
                                        </tbody>                                        
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div v-show="lstpedidosagrupar.length > 0" class="row">
                            <div class="col-12 col-sm-8 col-md-10 col-lg-10">
                                <span class="lblselect2">*Filial:</span>
                                <select id="cbfilialnf" data-placeholder="Selecione uma filial" v-model="aidfilialnf" data-allow-clear="true" style="width:100%;" v-bind:disabled="!alterafilialnf">
							    </select>
						    </div> 
                            <div class="col-12 col-sm-4 col-md-2 col-lg-2">
                                <label for="cbmodeloagr">Modelo:</label>
                                <select name="cbmodeloagr" class="form-control form-control-sm" id="cbmodelo" v-model="amodelo">
                                    <option value="55">55 - NFe</option>
                                    <option value="65">65 - NFCe</option>
                                </select>
                            </div>                                                       
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdconfirmaagrupamento()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>  
        <!-- Modal para configurar exportação xml --> 
        <div class="modal fade" id="mdexportxml" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-file-archive-o" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Exportar xml por período</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialexport" data-placeholder="Selecione uma filial" v-model="vidfilialexport" data-allow-clear="true" style="width:100%;">
								</select>
							</div> 
                        </div>
                        <div style="padding-top: 20px;" class="row">  
                            <div class="col-3">
                                <div class="custom-control custom-switch" style="padding-top: 20px;">
                                    <input type="checkbox" class="custom-control-input" id="swcespecificarperiodo" name="swcespecificarperiodo" v-model="vespecificarperiodo">
                                    <label class="custom-control-label" for="swcespecificarperiodo">Especificar?</label>
                                </div> 
                            </div>
                            <div v-if="!vespecificarperiodo" class="col-9 d-flex">
                                <div class="col-6 ml-3" v-if="!vespecificarperiodo">
                                    <label for="cbmes">Período:</label>
                                    <select name="cbmes" class="form-control form-control-sm" id="cbmes" v-model="messelect" >

                                        <option value="0">Janeiro</option>
                                        <option value="1">Fevereiro</option>
                                        <option value="2">Março</option>
                                        <option value="3">Abril</option>
                                        <option value="4">Maio</option>
                                        <option value="5">Junho</option>
                                        <option value="6">Julho</option>
                                        <option value="7">Agosto</option>
                                        <option value="8">Setembro</option>
                                        <option value="9">Outubro</option>
                                        <option value="10">Novembro</option>
                                        <option value="11">Dezembro</option>

                                    </select>
                                </div>

                                <div class="col-6" v-if="!vespecificarperiodo">
                                    <label for="cbano">Ano:</label>
                                    <select name="cbano" class="form-control form-control-sm" id="cbano" v-model="anoselect" >
                                        <option v-for="(ano, index) in anoslista" :key="index" :value="ano">{{ ano }}</option>
                                    </select>
                                </div> 
                            </div>

                            <div v-show="vespecificarperiodo" class="col-9 d-flex">
                                <div class="col-6 " v-if="vespecificarperiodo">
                                    <label for="eddtini">De:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtini" v-model="pdtinixml" :config="options" class="form-control form-control-sm" ></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>								
                                    </div>
                                </div>

                                <div class="col-6" v-if="vespecificarperiodo">
                                    <label for="eddtfim">até:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtfim" v-model="pdtfimxml" :config="options" class="form-control form-control-sm" ></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>																			
                                    </div>
                                </div>     
                            </div>
                        </div>
                        <div style="padding-top: 20px;" class="row">  
                            <div class="col-5">
                                <div class="custom-control custom-switch" style="padding-top: 20px;">
                                    <input type="checkbox" class="custom-control-input" id="swcenviaemail" name="swcenviaemail" v-model="venviaemail">
                                    <label class="custom-control-label" for="swcenviaemail">Enviar por email?</label>
                                </div> 
                            </div> 
                            <div v-show="venviaemail" class="col-12">
                                <div class="col-12 mt-2">
                                    <input type="email" v-model="vemailxml" 
                                        class="form-control form-control-sm" id="edemail" maxlength="100"
                                        style="text-transform: lowercase;" placeholder="Digite o email destinatario">
                                </div>     
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdsalvarxmls()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>
        <!-- Modal Substituir NCM dos itens da nota --> 
        <div class="modal fade" id="mdsetarmassancm" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Substituir NCMs das notas selecionadas</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">                
                            <div class="col-md-12">
                                <span class="lblselect2">Atribuir:</span>
                                <select id="cbncmsetar" data-placeholder="Selecione uma opção"
                                    v-model="vidncmsetar"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>

                            <div class="col-md-12">
                                <span class="lblselect2">Aos que tiverem:</span>
                                <select id="cbncmssubstituir" data-placeholder="Selecione uma opção"
                                    v-model="lstncmssubstitur"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdconfirmasubstituicaoncm()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div> 

        <!-- Modal Dados padrões para DI --> 
        <div class="modal fade" id="mddadospadraodi" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Dados padrão para DI</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">                
                            <div class="col-md-12">
                                <span class="lblselect2">CFOP:</span>
                                <select id="cbcfopimpdi" data-placeholder="Selecione uma opção"
                                    v-model="vidcfopimpdi"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>

                            <div class="col-4">
                                <label for="cbmes">Regime:</label>
                                <select name="cbregimedi" class="form-control form-control-sm" id="cbregimedi" @change="mtdmudarcstdi()"  v-model="vregimedi">
                                    <option value="1">Simples Nacional</option>
                                    <option value="2">Simples Nacional - excesso de sublimite de receita bruta</option>
                                    <option value="3">Regime Normal</option>
                                </select>
                            </div> 
                     

                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <label for="cborigemdi">Origem:</label>
                                <select class="form-control form-control-sm" id="cborigemdi"
                                    v-model="vorigemdi" >
                                    <option value="0">0 - NACIONAL, EXCETO AS INDICADAS NOS CODIGOS 3 A 5</option>
                                    <option value="1">1 - ESTRANGEIRA - IMPORTACAO DIRETA, EXCETO A INDICADA NO CODIGO 6</option>
                                    <option value="2">2 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, EXCETO A INDICADA NO CODIGO 7</option>
                                    <option value="3">3 - NACIONAL, MERCADORIA OU BEM COM CONTEUDO DE IMPORTACAO SUPERIOR A 40% (QUARENTA POR CENTO)</option>
                                    <option value="4">4 - NACIONAL, CUJA PRODUCAO TENHA SIDO FEITA EM CONFORMIDADE
                                        COM OS PROCESSOS PRODUTIVOS BASICOS DE QUE TRATAM O DECRETO-LEI Nº 288/67 E
                                        AS LEIS N°S 8.248/91, 8.387/91,10.176/01 e 11.484/07
                                    </option>
                                    <option value="5">5 - NACIONAL, MERCADORIA OU BEM COM CONTEUDO DE IMPORTACAO
                                        INFERIOR OU IGUAL A 40% (QUARENTA POR CENTO)
                                    </option>
                                    <option value="6">6 - ESTRANGEIRA - IMPORTACAO DIRETA, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUCAO CAMEX</option>
                                    <option value="7">7 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUCAO CAMEX</option>
                                </select>
                            </div> 

                            <div class="col-9">
                                <label v-if="parseInt(vregimedi) === 3" for="cbregime">Código da situação tributária:</label>
                                <label v-else for="cbcst">CSOSN:</label>
                                <select class="form-control form-control-sm" id="cbcst" v-model="vcstdi" v-bind:disabled="ativadesativa" >
                                    <option v-for="(item, indice) in lstcstdi" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                </select>
                            </div>

                            <div class="col-sm-12 col-md-3 col-lg-3">
								<label for="edvlunitario">A. ICMS(%):</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitario" v-model="vpicmsdi" v-bind="moneyprecision"  data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
                            
                            <div class="col-sm-12 col-md-3 col-lg-3">
								<label for="edvlunitario">C. monetária(%):</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitario" v-model="vconversaodi" v-bind="moneyprecision"  data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
                            
                            <div class="col-sm-12 col-md-3 col-lg-3">
								<label for="edvlunitario">Taxa vafrm(%):</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitario" v-model="vtaxavafrmdi" v-bind="moneyprecision"  data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>

                            <div class="col-sm-12 col-md-3 col-lg-3">
								<label for="edvlunitario">T. siscomex(%):</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitario" v-model="vtaxasiscomex" v-bind="moneyprecision"  data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>

                            <div class="col-sm-12 col-md-3 col-lg-3">
								<label for="edvlunitario">T. adicional(%):</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitario" v-model="vtaxadi" v-bind="moneyprecision"  data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>

                            <div class="col-sm-12 col-md-3 col-lg-3">
								<label for="edvlunitario">IOF(%):</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitario" v-model="viofdi" v-bind="moneyprecision"  data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>

                            <div class="col-5">
                                <label for="eddesnbarquedi">Local de desenbarque:</label>
                                <input type="text" v-model="vdesenbarquedi"
                                    class="form-control form-control-sm" id="eddesnbarquedi" maxlength="50">
                            </div>


                            <div class="col-2">
                                <label for="vufdesenbarquedi">UF desenb.:</label>
                                <input type="text" v-model="vufdesenbarquedi"
                                    class="form-control form-control-sm" id="vufdesenbarquedi" maxlength="50">
                            </div>

                            <div class="col-2">
                                <label for="vufterceirodi">UF do terceiro:</label>
                                <input type="text" v-model="vufterceirodi"
                                    class="form-control form-control-sm" id="vufterceirodi" maxlength="50">
                            </div>

                            <div class="col-12">
                                <label for="vtpintermediodi">Tipo de intermédio:</label>
                                <select class="form-control form-control-sm" id="vtpintermediodi" v-model="vtpintermediodi">
                                    <option value="1">Importação por conta própria</option>
                                    <option value="2">Importação por conta e ordem</option>
                                    <option value="3">Importação por encomenda</option>
                                </select>
                            </div>

                            
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdconfirmaentradadi()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div> 

        <!-- Modal de historico de envios -->
		<div class="modal fade" id="mdhistoricoenvios">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-clock-o"></i> Histórico de envios nota : {{ dethistoricoenvio.nnf }}</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>Data/Hora</th>
                                            <th>Usuário</th>
                                            <th>St</th>
                                            <th>Mensagem</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(evento, index) in dethistoricoenvio.historicoenvios" :key="index" style="font-size: 12px;">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ evento.datahoraevento }}</td>
                                            <td>{{ evento.nomeusu }}</td>
                                            <td>
                                                <span v-if="parseInt(evento.sterro) === 1">
                                                    <i class="fa fa-times-circle text-danger" title="Houve erro"></i>
                                                </span>
                                                <span v-else>
                                                    <i class="fa fa-check-circle text-success" title="Sem erro"></i>
                                                </span>
                                            </td>
                                            <td>{{ evento.msgerro }}</td>
                                        </tr>
                                        </tbody>                                        
                                    </table>
                                </div>
                            </div>                                      						
						</div>                                               
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
					</div>        
				</div>
			</div>
		</div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import util from '../utilitarios/util.js'
    import DetalhesPedido from '../components/cmpdetalhespedido.vue'

    export default {
        name: 'cadnotasfiscais',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb,
            'consultaprodutos'  : ConsultarProdutos,
            'detalhespedido'  	: DetalhesPedido,
        },
        data: function() {
            return {
                utodasfiliais        : this.$store.state.usuario.todasfiliais,
                nfmenu               : [],
                
                //variável para visualização do detalhe do pedido
                vidpedidodet         : '',

                tipopropesquisa      : '',

                utodasfiliais 		 : this.$store.state.usuario.todasfiliais,
                lstnotasfiscais      : [],
                lstinutilizacoes     : [],
                lstdemonstrativoscfop: [], 
                lstitensnf           : [],
                lstnotasref          : [],
                lstcobranca          : [],
                lstformaspagamento   : [],
                lstvolumes           : [],
                pmodelo              : 99,
                pserie               : '',
                pnnf                 : '',
                pidfilial            : null,
                pidnatop             : null,
                ptpdestinatario      : 0,
                piddestinatario      : null,
				pfiltroperiodo       : 1,
				pdtini       		 : util.DataAtual(true),
				pdtfim       		 : util.DataAtual(true),	                
                pqtdregistros        : 10,
                pqtd_paginas         : 1,
                pagina_atual         : 1,
                pqtd_total_registros : 0,
	                ptotalnotas          : 0,
	                ptpemis              : 2,
	                psituacaopesq        : 99,
	                valoresselecionados  : [],

                //contingencia      
                vencontingencia     : 0,



                //variaveis nova exportação xml
                anoslista           : [],
                anoAtual            : 0,
                anoselect           : 0,
                vespecificarperiodo : false,
                messelect           : 0,  
                vidfilialexport     : null,
                // email xml 
                vemailxml           : '',
                venviaemail         : false,
                
                pdtinixml       	: util.DataAtual(true),
				pdtfimxml           : util.DataAtual(true),	 

                //filtro inutilizadas
                pfiltroinutilizadas : '',

                //variáveis do crud
                opcrud              :  0,
                vvisualizarqtrib    : false,
                vid                 : '',
                vidfilial           : null,
                vcrt                : '1',
                viduffilial         : '',
                vmodelo             : '',
                vserie              : '',
                vnnf                : '',
                vtpnf               : '1',
                vtpdestinatario     : '0',
                vindpres            : '1',
                vindfinal           : '0',
                vcalctrib           :  1,
                viddest             : '1',
                vidnatop            : null,
                vdthremissao        : util.DataAtual(true),
                vfinnfe             : '1',
                vtpnfecredito       : '0',
                vtpnfedebito        : '0',
                viddestinatario     : null,
                vidinfcpl           : null,
                vinfcpl             : '',
                vimprimereferenciaitens : false,
                vmodfrete           : 9,
                vidtransportadora   : null,
                vtipotransporte     : 4,
                vveic_transp_placa  : '',
                vveic_transp_uf     : '',
                vveic_transp_rntc   : '',
                vreboque_transp_placa : '',
                vreboque_transp_uf    : '',
                vreboque_transp_rntc  : '',
                vtransp_vagao       : '',
                vtransp_balsa       : '',
                vnomeinter          : '',
                vcnpjinter          : '',

                //variáveis para comparação na alteração da nf
                vidfilial_old       : null,
                vmodelo_old         : '',

                vtotalcobranca      : 0,
                vtotalformas        : 0,

                //totalizadores
                tbc 			    : 0,
                ticms 		        : 0,
                ticmsdeson 	        : 0,
                tfcp 			    : 0,
                tbcst 		        : 0,
                tst 			    : 0,
                tfcpst 		        : 0,
                tfcpstret 	        : 0,
                tprod 		        : 0,
                tfrete 		        : 0,
                tseg 			    : 0,
                tdesc 		        : 0,
                tii 			    : 0,
                tipi 			    : 0,
                tipidevol 	        : 0,
                tpis 			    : 0,
                tcofins 		    : 0,
                toutro 		        : 0,
                tnf 			    : 0,
                ttottrib 		    : 0,
                // ttottrib_calculado 	: 0,

                totcbs              : 0,
                totibs              : 0,
                totibsmun           : 0,
                totibsuf            : 0,
                totis               : 0, 

                
                
                //variaveis atribuircampositens 

                vatribuircfop      : false,
                vatribuirregime    : false,
                vatribuirorigem    : false,
                vatribuicst        : false,
                vatribuiicms       : false, 
                vatribuicstpis     : false,
                vatribuialpiscofins: false,
                vatribuircstipi    : false,
                vatribuialipi      : false,

                vidcfopdados       : 0,
                vregimeop          : 0,
                vorigemop          : 0,
                vcstop             : '00',
                vpicmsop           : 0,
                vcstpiscofinsop    : 0,
                vpiscofinsop       : 0,
                vcstipiop          : 0,
                vpipiop            : 0,


                //variáveis da consulta de produtos
                vidtabela           : null,
                vshowprtabela       : false,

                //variável para habilitação dos campos
                ativadesativa       : true,
                ativadesativaibsuf  : false,
                ativadesativaibsmun : false,
                ativadesativacbs    : false,

                //variavel do icms automatico
                vanulacalcicms      : false,

                lstcst              : [],

                cstnormal   : [
                    {codigo : '00', descricao : 'Tributada integralmente'},
                    {codigo : '02', descricao : 'Tributação Monofásica própria sobre Combustíveis'},
                    {codigo : '10', descricao : 'Tributada e com cobrança do ICMS por substituição tributária'},
                    {codigo : '15', descricao : 'Tributação Monofásica própria e com responsabilidade pela retenção sobre Combustíveis'},
                    {codigo : '20', descricao : 'Com redução de base de cálculo'},
                    {codigo : '30', descricao : 'Isenta ou não tributada e com cobrança do ICMS por substituição tributária'},
                    {codigo : '40', descricao : 'Isenta'},
                    {codigo : '41', descricao : 'Não tributada'},
                    {codigo : '50', descricao : 'Suspensão'},
                    {codigo : '51', descricao : 'Diferimento'},
                    {codigo : '53', descricao : 'Tributação Monofásica sobre Combustíveis com recolhimento diferido'},
                    {codigo : '60', descricao : 'ICMS cobrado anteriormente por substituição tributária'},
                    {codigo : '61', descricao : 'Tributação Monofásica sobre Combustíveis cobrada anteriormente'},
                    {codigo : '70', descricao : 'Com redução de base de cálculo e cobrança do ICMS por substituição tributária'},
                    {codigo : '90', descricao : 'Outros'}
                ],
                cstsimples  : [
                    {codigo : '101', descricao : 'Tributada pelo Simples Nacional com permissão de crédito'},
                    {codigo : '102', descricao : 'Tributada pelo Simples Nacional sem permissão de crédito'},
                    {codigo : '103', descricao : 'Isenção do ICMS no Simples Nacional para faixa de receita bruta'},
                    {codigo : '201', descricao : 'Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária'},
                    {codigo : '202', descricao : 'Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária'},
                    {codigo : '203', descricao : 'Isenção do ICMS no Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária'},
                    {codigo : '300', descricao : 'Imune'},
                    {codigo : '400', descricao : 'Não tributada pelo Simples Nacional'},
                    {codigo : '500', descricao : 'ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação'},
                    {codigo : '900', descricao : 'Outros'}
                ],
                cstpiscofins : [
                    {codigo : '01', descricao : 'Operação Tributável com Alíquota Básica'},
                    {codigo : '02', descricao : 'Operação Tributável com Alíquota Diferenciada'},
                    {codigo : '03', descricao : 'Operação Tributável com Alíquota por Unidade de Medida de Produto'},
                    {codigo : '04', descricao : 'Operação Tributável Monofásica - Revenda a Alíquota Zero'},
                    {codigo : '05', descricao : 'Operação Tributável por Substituição Tributária'},
                    {codigo : '06', descricao : 'Operação Tributável a Alíquota Zero'},
                    {codigo : '07', descricao : 'Operação Isenta da Contribuição'},
                    {codigo : '08', descricao : 'Operação sem Incidência da Contribuição'},
                    {codigo : '09', descricao : 'Operação com Suspensão da Contribuição'},
                    {codigo : '49', descricao : 'Outras Operações de Saída'},
                    {codigo : '50', descricao : 'Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno'},
                    {codigo : '51', descricao : 'Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno'},
                    {codigo : '52', descricao : 'Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação'},
                    {codigo : '53', descricao : 'Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno'},
                    {codigo : '54', descricao : 'Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno'},
                    {codigo : '55', descricao : 'Operação com Direito a Crédito - Vinculada a Receitas Não Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '56', descricao : 'Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '60', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno'},
                    {codigo : '61', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno'},
                    {codigo : '62', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação'},
                    {codigo : '63', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno'},
                    {codigo : '64', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '65', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '66', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '67', descricao : 'Crédito Presumido - Outras Operações'},
                    {codigo : '70', descricao : 'Operação de Aquisição sem Direito a Crédito'},
                    {codigo : '71', descricao : 'Operação de Aquisição com Isenção'},
                    {codigo : '72', descricao : 'Operação de Aquisição com Suspensão'},
                    {codigo : '73', descricao : 'Operação de Aquisição a Alíquota Zero'},
                    {codigo : '74', descricao : 'Operação de Aquisição sem Incidência da Contribuição'},
                    {codigo : '75', descricao : 'Operação de Aquisição por Substituição Tributária'},
                    {codigo : '98', descricao : 'Outras Operações de Entrada'},
                    {codigo : '99', descricao : 'Outras Operações'}
                ],
                cstipi       : [
                    {codigo : '00', descricao : 'Entrada com Recuperação de Crédito'},
                    {codigo : '01', descricao : 'Entrada Tributada com Alíquota Zero'},
                    {codigo : '02', descricao : 'Entrada Isenta'},
                    {codigo : '03', descricao : 'Entrada Não Tributada'},
                    {codigo : '04', descricao : 'Entrada Imune'},
                    {codigo : '05', descricao : 'Entrada com Suspensão'},
                    {codigo : '49', descricao : 'Outras Entradas'},
                    {codigo : '50', descricao : 'Saída Tributada'},
                    {codigo : '51', descricao : 'Saída Tributável com Alíquota Zero'},
                    {codigo : '52', descricao : 'Saída Isenta'},
                    {codigo : '53', descricao : 'Saída Não Tributada'},
                    {codigo : '54', descricao : 'Saída Imune'},
                    {codigo : '55', descricao : 'Saída com Suspensão'},
                    {codigo : '99', descricao : 'Outras Saídas'}
                ],

                // Campos da regorma tibutária 2026
                lstcamposcbs        : [],  
                lstcamposcbsalt     : [], 
                
                // lista de campos para CBSIBS
                lstcstcbs: [],

                vclasstrib   : '',
                vcstcbs      : '',
                vcstcbsold   : '',
                vclasstribold: '',
                lstclasstrib : [],

                // campos tributação Regular

                lstclasstribreg    : [],
                vcstreg            : '',
                vclasstribreg      : '',
                pAliqEfetIBSUFReg  : 0,
                pAliqEfetIBSMunReg : 0,
                pAliqEfetCBSReg    : 0,


                // campos crédito presumido 
                lstcstcredpresumido    : [
                    {codigo : '01', descricao : 'Crédito presumido da aquisição de bens e serviços de produtor rural e produtor rural integrado não contribuinte, observado o art. 168 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '02', descricao : 'Crédito presumido da aquisição de serviço de transportador autônomo de carga pessoa física não contribuinte, observado o art. 169 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '03', descricao : 'Crédito presumido da aquisição de resíduos e demais materiais destinados à reciclagem, reutilização ou logística reversa adquiridos de pessoa física, cooperativa ou outra forma de organização popular, observado o art. 170 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '04', descricao : 'Crédito presumido da aquisição de bens móveis usados de pessoa física não contribuinte para revenda, observado o art. 171 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '05', descricao : 'Crédito presumido no regime automotivo, observado o art. 310 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '06', descricao : 'Crédito presumido no regime automotivo, observado o art. 311 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '07', descricao : 'Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 444 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '08', descricao : 'Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 447 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '09', descricao : 'Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 447 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '10', descricao : 'Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 450 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '11', descricao : 'Crédito presumido na aquisição por contribuinte na Área de Livre Comércio, observado o art. 462 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '12', descricao : 'Crédito presumido na aquisição por contribuinte na Área de Livre Comércio, observado o art. 465 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '13', descricao : 'Crédito presumido na aquisição pela indústria na Área de Livre Comércio, observado o art. 467 da Lei Complementar nº 214, de 2025.'},                
                ],

                // IBS

                vcstcredpresumidoIBS  : '00',
                vpCredPresIBS            : 0,
                vvCredPresIBS            : 0,
                vCredPresCondSuspIBS     : 0,

                // CBS

                vcstcredpresumidoCBS  : '00',
                vpCredPresCBS            : 0,
                vvCredPresCBS            : 0,
                vCredPresCondSuspCBS     : 0,

                // Transf Crédito
                vIBSTransfCred           : 0,
                vCBSTransfCred           : 0,
            
                // Compra Governamental

                vpAliqIBSUFGov  : 0,
                vTribIBSUFGov   : 0,
                vpAliqIBSMunGov : 0,
                vTribIBSMunGov  : 0,
                vpAliqCBS       : 0,
                vTribCBS        : 0,

                //////////////////////////////////////////////////////////////////////////
                // Campos da reforma tibutária 2026 >> Refatorado 15-12-25 Rodrigo
                ////////////////////////////////////////////////////////////////////////////

                // listas de CSTs IBS e CBS - OK
                lstCstsIBSCBS           : [],
                vCstIBSCBS              : '',
                vCstIBSCBSold           : '',

                lstcClassTribs          : [],
                lstcClassTribCompleta   : [],
                vcClassTrib             : '',
                vcClassTribold          : '',

                vBCIBSUF                : 0,

                // Tributação Padrão
                    // IBSUF
                swValPadroesIBSUF   : false,
                vAliqIBSUF          : 0,
                vAliqRedIBSUF       : 0,
                vAliqDifIBSUF       : 0,
                    // IBSMun
                swValPadroesIBSMun  : false,
                vAliqIBSMun         : 0,
                vAliqRedIBSMun      : 0,
                vAliqDifIBSMun      : 0,
                    // CBS
                swValPadroesCBS         : false,
                vAliqCBS                : 0,
                vAliqRedCBS             : 0,
                vAliqDifCBS             : 0,

                // Tributação Regular
                lstcClassTribsReg           : [],
                lstcClassTribsRegCompleta   : [],
                vCstIBSCBSReg               : '',
                vcClassTribReg              : '',
                pAliqEfetIBSUFReg           : 0,
                pAliqEfetIBSMunReg          : 0,
                pAliqEfetCBSReg             : 0,

                // Trib Monofásica
                    // Normal
                vAliqAdRemIBS           : 0,
                vAliqAdRemCBS           : 0, 
                    // Sujeita a retenção
                vAliqAdRemIBSReten      : 0, 
                vAliqAdRemCBSReten      : 0,
                    // Retida anteriormente
                vAliqAdRemIBSRet        : 0, 
                vAliqAdRemCBSRet        : 0,
                    // Diferimento
                vAliqDifIBSMono         : 0, 
                vAliqDifCBSMono         : 0,

                // IBSCBS - crédito presumido 
                lstCstCredPresumido    : [
                    {codigo : '01', descricao : 'Crédito presumido da aquisição de bens e serviços de produtor rural e produtor rural integrado não contribuinte, observado o art. 168 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '02', descricao : 'Crédito presumido da aquisição de serviço de transportador autônomo de carga pessoa física não contribuinte, observado o art. 169 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '03', descricao : 'Crédito presumido da aquisição de resíduos e demais materiais destinados à reciclagem, reutilização ou logística reversa adquiridos de pessoa física, cooperativa ou outra forma de organização popular, observado o art. 170 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '04', descricao : 'Crédito presumido da aquisição de bens móveis usados de pessoa física não contribuinte para revenda, observado o art. 171 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '05', descricao : 'Crédito presumido no regime automotivo, observado o art. 310 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '06', descricao : 'Crédito presumido no regime automotivo, observado o art. 311 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '07', descricao : 'Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 444 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '08', descricao : 'Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 447 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '09', descricao : 'Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 447 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '10', descricao : 'Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 450 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '11', descricao : 'Crédito presumido na aquisição por contribuinte na Área de Livre Comércio, observado o art. 462 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '12', descricao : 'Crédito presumido na aquisição por contribuinte na Área de Livre Comércio, observado o art. 465 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '13', descricao : 'Crédito presumido na aquisição pela indústria na Área de Livre Comércio, observado o art. 467 da Lei Complementar nº 214, de 2025.'},                
                ],
                swCredPresumido          : false,
                vcCredPres               : '',
                vpCredPresIBS            : 0,
                vpCredPresCBS            : 0,

                // Transf Crédito
                vIBSTransfCred           : 0,
                vCBSTransfCred           : 0,

                // IBSCBS - Compra governamental
                swCompraGov             : false,
                vTpEnteGov              : '',
                vAliqRedutorGov         : 0,
                vTpOperGov              : '',
                vpAliqIBSUFGov          : 0,
                vpAliqIBSMunGov         : 0,
                vpAliqCBSGov            : 0,

                // ZFM 
                tpCredPresIBSZFM  : '',

                // FIM CAMPOS REFORMA - RODRIGO
                ///////////////////////////////////////////////////////////


                vcstis          : '000',
                vpis            : 0,
                vpisesp         : 0,
                vvis            : 0,


                //variáveis de edição do item
                vopitem             : 0,
                vitem               : 0,
                vitemalt            : 0,//item para alteração
                vcoddig             : '',
                vidproduto          : '',
                vdescproduto        : '',
                vund                : '',
                vqtditem            : 1,
                vvlunitario         : 0,
                vvldesconto         : 0,
                vvltotal            : 0,
                vvfrete             : 0,
                vvseg               : 0,
                vvoutro             : 0,
                vidncm              : null,
                vidcest             : null,
                vidcfop             : null,
                vorig               : '0',
                valiquotaibpt       : 0,
                vregime             : 0,
                vcst                : '', 
                vcstpiscofins       : '01',
                vcstipi             : '99',                              
                vppis               : 0,
                vvpis               : 0,
                vppisst             : 0,
                vvpisst             : 0,
                vpcofins            : 0,
                vvcofins            : 0,
                vpcofinsst          : 0,
                vvcofinsst          : 0,
                vpipi               : 0,
                vvipi               : 0,
                vcenq               : '999',
                vinfadprod          : '',
                vxped               : '',
                vnitemped           : '',
                vutrib              : '',
                vqtrib              : 1,
                lstcamposicms       : [], 

                
                // PARTILHA DE ICMS
                vbcufdest           : 0,
                vpfcpufdedt         : 0,
                vpicmsufdest        : 0,
                vpicmsinter         : 0,
                vpimsinterpart      : 0,
                vfcpufdest          : 0,
                vicmsufdest         : 0,
                vicmsufremet        : 0,
                ////////////////////////

                //combustível
                vcprodanp           : '', 
                vufcons             : '', 
                vpglp               : 0, 
                vpgnn               : 0, 
                vpgni               : 0, 
                vvpart              : 0,
                vcuforig            : '', 
                vindimport          : '',
                vporig              : 0,
                /////////////////////////

                //notas referenciadas
                vtiponfref          : 0,
                vchavenfref         : '',

                //cobrança
                vdvenc              : util.DataAtual(true),
                vvdup               : 0,

                //forma de pagamento
                formaselecionada    : [],
                visualizacaut       : false,
                vidforma            : null,
                vvpag               : 0,
                vcaut               : '',

                //frete
                vqvol               : 0,
                vesp                : '',
                vmarca              : '',
                vnvol               : '',
                vpesol              : 0,
                vpesob              : 0,
                lstlacres           : [],
                vnlacre             : '',  
                
                //variável com o motivo para o cancelamento nf
                vjustcancelamento   : '',


                //variaveis da carta de correção
                opcarta             : 0,
                titcartacorrecao    : '',
                nfcartacorrecao     : [],
                lstcartas           : [],

                vnseqevento         : '',
                vdthremissaocarta   : util.DataAtual(true),
                vconteudocarta      : '',


                //variaveis de atribuir setar ncms
                lstncmssubstitur    : null,
                vidncmsetar         : null,


                //variáveis para inutilização
                iidfilial           : null,
                idthremissao        : util.DataAtual(true),
                inmodelo            : '55',
                inserie             : '',
                inini               : '',
                infim               : '',
                ixjust              : '',

                //lista das classes para seleção do usuário
                lstclasses          : [],

                //atribuir cfop para todos os itens
                vidcfoptodos        : null,

                //variáveis para envio do e-email
                idnfemailenviar     : 0,
                emailenviar         : '',
                
                //variáveis para correção da NF
                cnfcorrecao         : [],
                cchavenf            : '',
                clayoutxml          : '',

                //variáveis para fatorar nota
                vfator              : 0,

                //variáveis para agrupamento dos pedidos
				alterafilialnf		: false,//carrega do perfil do usuário                
                aidfilial           : null,
                aidcliente          : null,
                adtpor              : 0,
				adtini       		: util.DataAtual(true),
				adtfim       		: util.DataAtual(true),
                lstpedidosagrupar   : [], 
                aidfilialnf         : null,
                amodelo             : 55,  
                
                //declaracao de importacao
                vnrdeclaracao     : '',
                vcexportador      : '',
                vdtdeclaracao     : util.DataAtual(false, false),
                vlocaldesenbarque : '',
                vufdesenbarque    : '',
                vufterceiro       : '',
                vdtdesenbarque    : util.DataAtual(false, false),
                vtptransporte     : 1,
                vtpintermedio     : 1,
                vvafrmm           : 0,
                vcnpjimportador   : '',
                vmarcafabricante  : '',
                vdescontodi       : 0,
                vnrdraw           : '',

                //ii
                
                vvbc             : 0, 
                vvdespadu        : 0,
                vviiitem         : 0, 
                vviof            : 0,

                lstdeclaracaoimp  : [],


                dethistoricoenvio : [],


                //importação da di
                vcstdi            : '00',
                lstcstdi          : [],
                vdesenbarquedi    : '', 
                vufdesenbarquedi  : '',
                vufterceirodi     : '', 
                vtpintermediodi   : 1,
                vidcfopimpdi      : null,

                vorigemdi         : 1,
                vregimedi         : 1,


                vpicmsdi          : 0,

                vconversaodi      : 0,
                vtaxavafrmdi      : 0,
                vtaxasiscomex     : 0,  
                vtaxadi           : 0,
                viofdi            : 0,


                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },				
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                moneyprecision	    : {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 3,
                    masked          : false
                },
				peso				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',
                    precision       : 3,
                    masked          : false
                },                
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'NOTAS FISCAIS DE SAÍDA',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-nf",
                        sort: false
                    },
                    {
                        label: "Filial",
                        name: "fantasiafil",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Nr. Nota",
                        name: "nnf",
                        sort: true,
                        slot_name: "slot_nnf",
                        row_classes: "def-col-nnf",
                    },
                    {
                        label: "Situação",
                        name: "situacaonota",
                        sort: true,
                        slot_name: "slot_situacaonota",
                        row_classes: "def-col-situacaonota",
                    },                    
                    {
                        label: "Modelo",
                        name: "modelo",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-modelo"
                    },
                    {
                        label: "Série",
                        name: "serie",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "slot_serie",
                        row_classes: "def-col-serie"
                    },
                    {
                        label: "Emissão",
                        name: "dthremissao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_dthremissao",
                        row_classes: "def-col-dthremissao"
                    },                    
                    {
                        label: "Destinatário",
                        name: "nomedestinatario",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Natureza operação",
                        name: "descnatop",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Valor",
                        name: "totalnota",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_valor",
                        row_classes: "def-col-valor"
                    },
                    {
                        label: "Retorno sefaz",
                        name: "xmotivo",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_xmotivo",
                        row_classes: "def-col-xmotivo"
                    },
                    {
                        label: "",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "slot_infohist"
                    },
                    {
                        label: "Chave",
                        name: "chave",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_chave",
                        row_classes: "def-col-chave"
                    },
                    {
                        label: "",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "slot_infocont"
                    }
                ],
                columnsitensnf: [
                    {
                        label: 'Opções',
                        name : 'opcoes_item',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-item",
                        sort: false
                    },
                    {
                        label: "Item",
                        name: "item",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_item",
                    },
                    {
                        label: "Código",
                        name: "coddig",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_coddig",
                    },
                    {
                        label: "Descrição do item",
                        name: "descproduto",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_descproduto",
                    },
                    {
                        label: "NCM",
                        name: "idncm",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_ncm",
                    },
                    {
                        label: "CST/CSOSN",
                        name: "cst",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_cst",
                    },
                    {
                        label: "CFOP",
                        name: "idcfop",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_cfop",
                    },
                    {
                        label: "P/C",
                        name: "cstpiscofins",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_cst_piscofins",
                    },
                    {
                        label: "IPI",
                        name: "cstipi",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_cst_ipi",
                    },                    
                    {
                        label: "Und",
                        name: "und",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_und",
                    },
                    {
                        label: "Qtd",
                        name: "qtditem",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_qtditem",
                    },                
                    {
                        label: "U.Trib",
                        name: "utrib",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_utrib",
                        visibility				: false
                    },
                    {
                        label: "Q.Trib",
                        name: "qtrib",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_qtrib",
                        visibility				: false
                    },                    
                    {
                        label: "Vl. Unitário",
                        name: "vlunitario",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_vlunitario",
                    },
                    {
                        label: "Vl. Total",
                        name: "vltotal",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_vltotal",
                    },
                    {
                        label: "Vl. Desconto",
                        name: "vldesconto",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_vldesconto",
                    }                                                                                                                                  
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    checkbox_rows: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            calcularICMSinter() {
                // Convertendo valores para número
                let baseDest = parseFloat(this.vbcufdest) || 0;
                let aliquotaDest = parseFloat(this.vpicmsufdest) || 0;
                let aliquotaInter = parseFloat(
                    this.vpicmsinter == 1 ? 4 :
                    this.vpicmsinter == 2 ? 7 :
                    this.vpicmsinter == 3 ? 12 : 0
                );
                let percPartilha = parseFloat(
                    this.vpimsinterpart == 1 ? 0.4 :
                    this.vpimsinterpart == 2 ? 0.6 :
                    this.vpimsinterpart == 3 ? 0.8 :
                    this.vpimsinterpart == 4 ? 1 : 0
                );
                let fcp = parseFloat(this.vpfcpufdedt) || 0;

                // ICMS total na UF do destinatário (ICMS interno)
                let icmsTotal = baseDest * (aliquotaDest / 100);

                // ICMS interestadual
                let icmsInter = baseDest * (aliquotaInter / 100);

                // Diferencial de Alíquota (DIFAL)
                // O erro 'ReferenceError: icmsDest is not defined' foi corrigido aqui,
                // garantindo que a variável seja declarada com 'let'.
                let icmsDest = icmsTotal - icmsInter;

                // Partilha do ICMS (DIFAL)
                // ICMS para a UF do destinatário
                this.vicmsufdest = (icmsDest * percPartilha);
                
                // ICMS para a UF do remetente
                // Uso parseFloat(this.vicmsufdest) para garantir que a subtração use o valor numérico
                // e não a string formatada anteriormente.
                this.vicmsufremet = (icmsDest - parseFloat(this.vicmsufdest));

                // Fundo de Combate à Pobreza (FCP)
                this.vfcpufdest = (baseDest * (fcp / 100));
            },
            mtdmudaclasstribreg(idgrupo, resetaclasstrib = true){
                let ind = util.getArrayIndexForKey(this.lstcstcbs, 'codigo', idgrupo);
                this.lstclasstribreg  = this.lstcstcbs[ind].classtrib;
                if (resetaclasstrib){
                    this.vclasstribreg    = this.lstclasstribreg[0].codigo  
                };         
        
            },
            mtdPermiteUsuario(op){
                return util.opcaousuario(op, this.$store.state.perfilusuario);         
            },  
            mostrarhistoricoenvio(nota){
                this.dethistoricoenvio = [];
                this.dethistoricoenvio = nota;
                $("#mdhistoricoenvios").modal("show");
            },
            mtdatribuirdados(){
                let vself = this;

                if (this.vatribuircfop === true && this.vidcfopdados === null) {
                    this.$toastr.w('Campo "CFOP" foi selecionado, portanto, deve ser informado!', 'Atenção!');
                    $('#cbcfopatrop').focus();
                    return;
                }

                if (this.vatribuirregime === true && this.vregimeop === 0) {
                    this.$toastr.w('Campo "Regime" foi selecionado, portanto, deve ser informado!', 'Atenção!');
                    $('#cbregimeop').focus();
                    return;
                }

                if (this.vatribuirorigem === true && this.vorigemop === 0) {
                    this.$toastr.w('Campo "Origem" foi selecionado, portanto, deve ser informado!', 'Atenção!');
                    $('#cborigemop').focus();
                    return;
                }

                // if (this.vatribuicst === true && this.vcstop === '00') {
                //     this.$toastr.w('Campo "CST" foi selecionado, portanto, deve ser informado!', 'Atenção!');
                //     $('#cbcstop').focus();
                //     return;
                // }

                if (this.vatribuiicms === true && this.vpicmsop === 0) {
                    this.$toastr.w('Campo "ICMS" foi selecionado, portanto, deve ser informado!', 'Atenção!');
                    $('#cbpicmsop').focus();
                    return;
                }

                if (this.vatribuicstpis === true && this.vcstpiscofinsop === 0) {
                    this.$toastr.w('Campo "CST PIS" foi selecionado, portanto, deve ser informado!', 'Atenção!');
                    $('#cbcstpiscofinsop').focus();
                    return;
                }

                if (this.vatribuialpiscofins === true && this.vpiscofinsop === 0) {
                    this.$toastr.w('Campo "PIS/COFINS" foi selecionado, portanto, deve ser informado!', 'Atenção!');
                    $('#cbpiscofinsop').focus();
                    return;
                }

                if (this.vatribuircstipi === true && this.vcstipiop === 0) {
                    this.$toastr.w('Campo "CST IPI" foi selecionado, portanto, deve ser informado!', 'Atenção!');
                    $('#cbcstipiop').focus();
                    return;
                }

                if (this.vatribuialipi === true && this.vpipiop === 0) {
                    this.$toastr.w('Campo "IPI" foi selecionado, portanto, deve ser informado!', 'Atenção!');
                    $('#cbpipiop').focus();
                    return;
                }

                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma substitur os campos selecionados nos itens da nota?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                for (let index = 0; index < vself.$refs.refitensnota.selected_items.length; index++) {
                                    let i 		    = util.getArrayIndexForKey(vself.lstitensnf, 'item', vself.$refs.refitensnota.selected_items[index].item);
                                    if (vself.vatribuircfop) {
                                        vself.lstitensnf[i].idcfop   = vself.vidcfopdados
                                        vself.lstitensnf[i].desccfop = $('#cbcfopatrop').select2('data')[0]['text'];      
                                    }
                                    if (vself.vatribuirregime) {
                                        vself.lstitensnf[i].regime = vself.vregimeop;
                                    }
                                    if (vself.vatribuirorigem) {
                                        vself.lstitensnf[i].orig   = vself.vorigemop
                                    }
                                    // if (vself.vatribuicst) {
                                    //     vself.lstitensnf[i].cst    = vself.vcstop
                                    // }
                                    if (vself.vatribuiicms) {
                                        let lstcamposicms = JSON.parse(JSON.stringify( vself.lstitensnf[i].campos));
                                        if (lstcamposicms[i].idcampo === 'pICMS'){
                                            lstcamposicms[i].valor = vself.vpicmsop;
                                        }
                                        if (lstcamposicms[i].idcampo === 'vICMS'){
                                            let vlicms   	= function() {
                                                let vbc = 0;
                                               for (let j = 0; j < lstcamposicms.length; j++) {
                                                    if(lstcamposicms[j].idcampo === 'vBC'){
                                                        vbc = lstcamposicms[j].valor;
                                                        break;
                                                    }
                                               }
                                               return parseFloat(vbc) * parseFloat(vself.vpicmsop) /100
                                            };
                                            lstcamposicms[i].valor = vlicms;
                                        }      
                                        vself.lstitensnf[i].campos = lstcamposicms;
                                    }
                                    if (vself.vatribuicstpis) {
                                        vself.lstitensnf[i].cstpiscofins = vself.vcstpiscofinsop
                                    }
                                    if (vself.vatribuialpiscofins) {
                                        vself.lstitensnf[i].ppis =  vself.vpiscofinsop
                                        vself.lstitensnf[i].vpis =  parseFloat(vself.lstitensnf[i].vltotal) * parseFloat(vself.vpiscofinsop) / 100;

                                        //adicionar aqui cofins
                                        vself.lstitensnf[i].pcofins = vself.vpiscofinsop
                                        vself.lstitensnf[i].vcofins = parseFloat(vself.lstitensnf[i].vltotal) * parseFloat(vself.vpiscofinsop) / 100;
                                    }
                                    if (vself.vatribuircstipi) {
                                        vself.lstitensnf[i].cstipi = vself.vcstipiop
                                    }
                                    if (vself.vatribuialipi) {
                                        vself.lstitensnf[i].pipi = vself.vpipiop
                                        vself.lstitensnf[i].vipi = parseFloat(vself.lstitensnf[i].vltotal) * parseFloat(vself.vpipiop) / 100;
                                    }
                                }
                                this.$toastr.s('Campos atribuidos!', 'Sucesso!');  
                                vself.$refs.refitensnota.selected_items = [];
                                vself.mtdtotalizarnota();
                                $('#mdalteradadositem').modal('hide');
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                
                            }
                        }
                    }
                });
            },
            mtdatribuircampos(){
                this.vatribuircfop       = false;
                this.vatribuirregime     = false;
                this.vatribuirorigem     = false;
                this.vatribuicst         = false;
                this.vatribuiicms        = false;
                this.vatribuicstpis      = false;
                this.vatribuialpiscofins = false;
                this.vatribuircstipi     = false;
                this.vatribuialipi       = false;

                this.vidcfopdados        = null;
                this.vregimeop           = 0;
                this.vorigemop           = 0;
                this.vcstop              = '00';
                this.vpicmsop            = 0;
                this.vcstpiscofinsop     = 0;
                this.vpiscofinsop        = 0;
                this.vcstipiop           = 0;
                this.vpipiop             = 0;

                $('#mdalteradadositem').modal('show');
            },
            mtdmudarcstlt(){
                if (parseInt(this.vregimedi) === 1){
                    this.lstcstop = this.cstnormal;
                    this.vcstop   = '00';
                }else{
                    this.lstcstop = this.cstsimples;
                    this.vcstop   = '101';
                }
            },
            mtdconfirmaentradadi(){
                if(this.vidcfopimpdi === null){
                    this.$toastr.w('CFOP deve ser informado!', 'Atenção!');     
                    return;
                }
                if(this.vufterceirodi === ''){
                    this.$toastr.w('UF de terceiro deve ser informado!', 'Atenção!');     
                    return;
                }
                if(this.vufdesenbarquedi === ''){
                    this.$toastr.w('UF de desenbarque deve ser informado!', 'Atenção!');     
                    return;
                }
                if(this.vdesenbarquedi === ''){
                    this.$toastr.w('Local de desenbarque deve ser informado!', 'Atenção!');     
                    return;
                }
                this.$refs.if_selecionarquivo.click()
            },
            mtdmudarcstdi(){
                if (parseInt(this.vregimedi) === 1){
                    this.lstcstdi = this.cstnormal;
                    this.vcstdi   = '00';
                }else{
                    this.lstcstdi = this.cstsimples;
                    this.vcstdi   = '101';
                }
            },
            mtdimportardi(){
                this.vcstdi            = '00';
                this.lstcstdi          = [];
                this.vdesenbarquedi    = ''; 
                this.vufdesenbarquedi  = '';
                this.vufterceirodi     = ''; 
                this.vtpintermediodi   = 1;
                this.vidcfopimpdi      = null;
                $('#cbcfopimpdi').val(null).trigger('change');

                this.vorigemdi         = 1;
                this.vregimedi         = 1;

                this.lstcstdi          = this.cstsimples;

                this.vpicmsdi          = 0;

                this.vconversaodi      = 0;
                this.vtaxavafrmdi      = 0;
                this.vtaxasiscomex     = 0;  
                this.vtaxadi           = 0;
                this.viofdi            = 0;
                $('#mddadospadraodi').modal('show');
            },
            mtdentradapeloxml(arquivoxml){
                let vself            = this;
                let loader           = vself.$loading.show();
        
                let campos = {
                    'idcfop'             :  vself.vidcfopimpdi,
                    'desccfop'           :  $('#cbcfopimpdi').select2('data')[0]['text'],
                    'origem'             :  vself.vorigemdi,
                    'regime'             :  vself.vregimedi,
                    'cst'                :  vself.vcstdi,
                    'vafrmmtaxa'         :  vself.vtaxavafrmdi,
                    'taxasiscomex'       :  vself.vtaxasiscomex,
                    'fatorconversao'     :  vself.vconversaodi,
                    'valoradicional'     :  vself.vtaxadi,
                    'localdesenbarque'   :  vself.vdesenbarquedi,
                    'ufdesenbarque'      :  vself.vufdesenbarquedi,
                    'ufterceiro'         :  vself.vufterceirodi,
                    'tpintermedio'       :  vself.vtpintermediodi,
                    'aliqicms'           :  vself.vpicmsdi,
                    'viof'               :  vself.viofdi,
                };
                    
                var parametros      = [
                    {parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor : 'carregardadosxmlentrada'},
                    {parametro: 'arquivoxml',           valor : arquivoxml},
                    {parametro: 'campos',               valor : JSON.stringify(campos)}
                ];                        
                
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){        
                        
                        //eventualmente trazer o cabeçalho
                        vself.lstitensnf = response.data.itens;                        
               
                        $('#ipselecionararquivo').val('');
                        $('#mddadospadraodi').modal('hide');
                        vself.mtdtotalizarnota();
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        if (tpret === 'E'){
                            vself.$toastr.e(response.data.substring(4), 'Erro!');
                        }else{
                            vself.$toastr.i(response.data.substring(4), 'Informação!');
                        }
                    }                
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdselecionararquivoxml(event){                
                let vself            = this;                 
                vself.arqselecionado = event.target.files[0];

                let extarq  = vself.arqselecionado.name.substring(vself.arqselecionado.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XML'){
                    vself.arqselecionado = null;
                    vself.$toastr.w('O arquivo selecionado não possui um formato válido', 'Atenção!');
                    return;
                }

                let loader      = vself.$loading.show();
                let localsalvar = 'controller/xmldiimportacaotmp';

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){        

                        vself.mtdentradapeloxml(vself.arqselecionado.name);                        
                    }else{
                        vself.arqselecionado = null;
                        $('#ipselecionararquivo').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.arqselecionado = null;
                    $('#ipselecionararquivo').val('');
                });                
            },
            mtddeclaracaoimportaimp(){

            },
            mtdeditardeclaracao(index){

                this.vtptransporte     = this.lstdeclaracaoimp[index].tpintermedio;
                this.vvafrmm           = this.lstdeclaracaoimp[index].vafrmm;
                this.vcnpjimportador   = this.lstdeclaracaoimp[index].cnpjimportador;


                this.vmarcafabricante   = this.lstdeclaracaoimp[index].marcafabricante;
                this.vdescontodi        = this.lstdeclaracaoimp[index].descontodi;
                this.vnrdraw            = this.lstdeclaracaoimp[index].nrdraw;


                this.vvbc               = this.lstdeclaracaoimp[index].vbc;
                this.vvdespadu          = this.lstdeclaracaoimp[index].vdespadu;
                this.vviiitem           = this.lstdeclaracaoimp[index].vii;
                this.vviof              = this.lstdeclaracaoimp[index].viof;

                this.vtipo             = this.lstdeclaracaoimp[index].tipo;
                this.vnrdeclaracao     = this.lstdeclaracaoimp[index].nrdeclaracao;
                this.vcexportador      = this.lstdeclaracaoimp[index].cexportador;
                this.vdtdeclaracao     = util.formatarDataView(this.lstdeclaracaoimp[index].dtdeclaracao);
                this.vlocaldesenbarque = this.lstdeclaracaoimp[index].localdesenbarque;
                this.vufdesenbarque    = this.lstdeclaracaoimp[index].ufdesenbarque;
                this.vufterceiro       = this.lstdeclaracaoimp[index].ufterceiro;
                this.vdtdesenbarque    = util.formatarDataView(this.lstdeclaracaoimp[index].dtdesenbarque);
                this.vtptransporte     = this.lstdeclaracaoimp[index].tptransporte;

                //$('#mddeclaracaoimporta').modal('show'); 

                this.lstdeclaracaoimp = [];

            },
            mtdconfirmadecimporta(){
                              
                let declaracao = {
                   'nrdeclaracao'       : this.vnrdeclaracao,
                   'cexportador'        : this.vcexportador,
                   'dtdeclaracao'       : util.InverterData(this.vdtdeclaracao),
                   'localdesenbarque'   : this.vlocaldesenbarque,
                   'ufdesenbarque'      : this.vufdesenbarque,
                   'ufterceiro'         : this.vufterceiro,
                   'dtdesenbarque'      : util.InverterData(this.vdtdesenbarque),
                   'tptransporte'       : this.vtptransporte,
                   'tpintermedio'       : this.vtpintermedio,
                   'vafrmm'             : this.vvafrmm,
                   'cnpjimportador' 	: this.vcnpjimportador.replace(/[^0-9]/g,''),

                   'marcafabricante' 	: this.vmarcafabricante,
                   'descontodi' 	    : this.vdescontodi,
                   'nrdraw' 	        : this.vnrdraw,
                   'vbc' 	            : this.vvbc,
                   'vdespadu' 	        : this.vvdespadu,
                   'vii' 	            : this.vviiitem,
                   'viof' 	            : this.vviof,
                };
                this.lstdeclaracaoimp.push(declaracao);
                //$('#mddeclaracaoimporta').modal('hide'); 
                
            },
            mtddeclaracaoimporta(){
                this.vnrdeclaracao     = '';
                this.vcexportador      = '';
                this.vdtdeclaracao     = util.DataAtual(true);
                this.vlocaldesenbarque = '';
                this.vufdesenbarque    = '';
                this.vufterceiro       = '';
                this.vdtdesenbarque    = util.DataAtual(true);
                this.vtptransporte     = 1;
                this.vtpintermedio     = 1;
                this.vvafrmm           = 0;
                this.vcnpjimportador   = '';

                this.vmarcafabricante  = 0;
                this.vdescontodi       = 0;
                this.vnrdraw           = 0;
                this.vvbc              = 0;
                this.vvdespadu         = 0;
                this.vviiitem          = 0;
                this.vviof             = 0;
                

               // $('#mddeclaracaoimporta').modal('show');

            },
            mtddeletardeclaracao(indice){
                this.lstdeclaracaoimp.splice(indice, 1);
            },
            mtdconfirmasubstituicaoncm(){
                let vself = this;
                if((this.lstncmssubstitur === null)||(this.lstncmssubstitur.length ===0)){
                    this.$toastr.w('Selecione o(s) NCM(s) para realizar essa operação!', 'Atenção!');
                    return;
                }
                if(this.vidncmsetar === null){
                    this.$toastr.w('Selecione o NCM a ser atribuido!', 'Atenção!');
                    return;
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma substitur os NCMs selecionados nas notas?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                console.log("dep")
                               
                                let stringncmsubstitur = vself.lstncmssubstitur.join(',');
                      
                                let stringnotas        = '';  
                
                                for (let i = 0; i < vself.$refs.reflstnotasfiscais.selected_items.length; i++) {
                                    stringnotas = stringnotas+', '+vself.$refs.reflstnotasfiscais.selected_items[i].id;
                                }   
                                
                                let stridnotas  = stringnotas.substring(2)

                                let loader      = vself.$loading.show();
                        
                                let parametros  = [
                                    {parametro: 'op',             valor  : 'substituirncmnotas'},
                                    {parametro: 'idclientesac',   valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'ncmsubstituir',  valor  : stringncmsubstitur},
                                    {parametro: 'idfilial',       valor  : vself.$store.state.filialpadrao.codfil},
                                    {parametro: 'idnotas',        valor  : stridnotas},
                                    {parametro: 'idusuario',      valor  : vself.$store.state.usuario.id},
                                    {parametro: 'novoncm',        valor  : vself.vidncmsetar},
                                ];
                                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                                retorno.then(function (response) {
                                    loader.hide();
                                    if(!$.isNumeric(response.data)){
                                        vself.$toastr.w('Erro ao substituir NCMs: '+response.data, 'Informação!'); 
                                        $('#mdsetarmassancm').modal('hide');
                                        vself.$refs.reflstnotasfiscais.unSelectAllItems()
                                        vself.mtdexecutapesquisa(); 
                                    }else{
                                        vself.$toastr.s('NCM(s) alterado(s) com sucesso!', 'Informação!'); 
                                    }
                                }).catch(function (response) {
                                    loader.hide();
                                });
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                
                            }
                        }
                    }
                });
            },
            mtdsetarcampositens(){
                if(!util.opcaousuario('020Z.020Z.070Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Seu perfil de usuário não permite realizar essa operação!', 'Informação!');
                    return;
                }
                if(this.$refs.reflstnotasfiscais.selected_items.length === 0){
                    this.$toastr.w('Selecione a(s) nota(s) para realizar essa operação!', 'Atenção!');
                    return;
                }
                for (let i = 0; i < this.$refs.reflstnotasfiscais.selected_items.length; i++) {
                    if(parseInt(this.$refs.reflstnotasfiscais.selected_items[i].situacaonota)===2){
                        this.$toastr.w('Algumas notas selecionadas estão com status de enviada! Verifique os dados e tente novamente', 'Informação!'); 
                        return
                    }
                }   
                $('#mdsetarmassancm').modal('show');
                
            },
            mtdrotinacolsultarprocessamento(nf){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'consultarecibo'},
                    {parametro: 'idnf',     	valor : nf.id},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
            
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Nota enviada com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.psituacaopesq = 99;
                    vself.pnnf          = nf.nnf;
                    vself.pidfilial     = nf.idfilial;
                    var deffilial       = new Option(nf.fantasiafil, nf.idfilial, true, true);
                    $('#cbfilialpesq').append(deffilial).trigger('change');
                    vself.pqtd_paginas  = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarreganotasfiscais(1, '');                            
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            verificapermis(op){
               return util.opcaousuario(op, this.$store.state.perfilusuario);
            },
            mtdenviaremlote(){
                let vself = this;
            
                if(vself.$refs.reflstnotasfiscais.selected_items.length === 0){
                    vself.$toastr.w('Selecione as notas fiscais para envio em lote!', 'Informação!'); 
                    return
                }
                if(vself.$refs.reflstnotasfiscais.selected_items.length > 10){
                    vself.$toastr.w('É permitido envio em lote de no maximo 10 (dez) NFs!', 'Informação!'); 
                    return
                }
                for (let i = 0; i < vself.$refs.reflstnotasfiscais.selected_items.length; i++) {
                    if(parseInt(vself.$refs.reflstnotasfiscais.selected_items[i].situacaonota)===2){
                        vself.$toastr.w('Algumas notas selecionadas estão com status de enviada! Verifique os dados e tente novamente', 'Informação!'); 
                        return
                    }
                }   
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma o envio em lote das notas ficais?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                let idnotas = [];
                
                                for (let i = 0; i < vself.$refs.reflstnotasfiscais.selected_items.length; i++) {
                                    let ittmp = {
                                        'idnota'   : vself.$refs.reflstnotasfiscais.selected_items[i].id,
                                        'idfilial' : vself.$refs.reflstnotasfiscais.selected_items[i].idfilial
                                    };
                                    idnotas.push(ittmp);
                                }    

                                let loader      = vself.$loading.show();
                        
                                let parametros  = [
                                    {parametro: 'op',           valor : 'enviaremlote'},
                                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'idnotas',      valor  : JSON.stringify(idnotas)},
                                ];
                                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                                retorno.then(function (response) {
                                    loader.hide();
                                    vself.$refs.reflstnotasfiscais.unSelectAllItems()
                                    vself.mtdexecutapesquisa(); 
                                    if(!$.isNumeric(response.data)){
                                        vself.$toastr.w('Algumas notas não foram enviadas devido as rejeições: '+response.data, 'Informação!'); 
                                    }else{
                                        vself.$toastr.s('Notas enviadas com sucesso!', 'Informação!'); 
                                    }
                                }).catch(function (response) {
                                    loader.hide();
                                });
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                
                            }
                        }
                    }
                });
                
            },
            mtdconsultaemlote(){
                let vself = this;
            
                if(vself.$refs.reflstnotasfiscais.selected_items.length === 0){
                    vself.$toastr.w('Selecione as notas fiscais para consulta em lote!', 'Informação!'); 
                    return
                }
                if(vself.$refs.reflstnotasfiscais.selected_items.length > 10){
                    vself.$toastr.w('É permitido consultar em lote de no maximo 10 (dez) NFs!', 'Informação!'); 
                    return
                }

                let idnotas = [];
                
                for (let i = 0; i < vself.$refs.reflstnotasfiscais.selected_items.length; i++) {
                    let ittmp = {
                        'idnota'   : vself.$refs.reflstnotasfiscais.selected_items[i].id,
                        'idfilial' : vself.$refs.reflstnotasfiscais.selected_items[i].idfilial
                    };
                    idnotas.push(ittmp);
                }    

                let loader      = vself.$loading.show();
        
                let parametros  = [
                    {parametro: 'op',           valor : 'consultaremlote'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idnotas',      valor  : JSON.stringify(idnotas)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$refs.reflstnotasfiscais.unSelectAllItems()
                    vself.mtdexecutapesquisa(); 
                    
                    vself.$toastr.i('Notas consultadas! vide seus status', 'Informação!'); 
                }).catch(function (response) {
                    loader.hide();
                });
                
            },
            mtdexportxml(){
                this.vespecificarperiodo = false;
                this.venviaemail = false;
                this.vidfilialexport     = null;
                this.vemailxml = '';
                $('#cbfilialexport').val(null).trigger('change');
                $('#mdexportxml').modal('show');
            },
            mtdfatorarnota(){
                $('#mdselecionafator').modal('show');
            },
            mtdvisualizabtn(op){                
                return util.opcaousuario(op, this.$store.state.perfilusuario);
            },
            mtdgravafator(){
                let vself = this
                if(vself.vfator===0){
                    vself.$toastr.w('Informe o fator correto!', 'Informação!'); 
                }else if(vself.lstitensnf.length === 0){
                    vself.$toastr.w('Não há itens na nota para esta operação!', 'Informação!'); 
                }else if(vself.vfator > 100){
                    vself.$toastr.w('Informe o fator correto!', 'Informação!'); 
                }else{
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma a fatoração dos itens?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    vself.mtdregistrofator();
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $('#edfator').focus();
                                }
                            }
                        }
                    });
                }
            },
            mtdregistrofator(){
                console.log('inicio')
                    let vself = this; 
                    let loader      = this.$loading.show();    
                for (let index = 0; index < this.lstitensnf.length; index++) {
                    vself.vopitem             = 2;
                    vself.vitemalt            = vself.lstitensnf[index].item;
                    vself.vcoddig             = vself.lstitensnf[index].coddig;
                    vself.vidproduto          = vself.lstitensnf[index].idproduto;
                    vself.vdescproduto        = vself.lstitensnf[index].descproduto;
                    vself.vund                = vself.lstitensnf[index].und;
                    vself.vqtditem            = vself.lstitensnf[index].qtditem;
                    vself.vvlunitario         = util.arredondaValores(parseFloat(vself.lstitensnf[index].vlunitario * (this.vfator / 100)), 2, 'round');  // aplicar aqui
                    vself.vvldesconto         = util.arredondaValores(parseFloat(vself.lstitensnf[index].vldesconto * (this.vfator / 100)), 2, 'round');  // aplicar aqui
                    vself.vvltotal            = util.arredondaValores(parseFloat(vself.lstitensnf[index].vltotal  * (this.vfator / 100)), 2, 'round');
                    vself.vvfrete             = vself.lstitensnf[index].vfrete;  
                    vself.vvseg               = util.arredondaValores(parseFloat(vself.lstitensnf[index].vseg * (this.vfator / 100)), 2, 'round');    //aplicar aqui
                    vself.vvoutro             = util.arredondaValores(parseFloat(vself.lstitensnf[index].voutro * (this.vfator / 100)), 2, 'round'); // aplicar aqui
                    vself.vidncm              = vself.lstitensnf[index].idncm;
                    vself.vidcest             = vself.lstitensnf[index].idcest;
                    vself.vidcfop             = vself.lstitensnf[index].idcfop;
                    vself.vorig               = vself.lstitensnf[index].orig;                  
                    vself.vregime             = vself.lstitensnf[index].regime;
                    //// partilha de icms 
                    vself.vbcufdest           = util.arredondaValores(parseFloat(vself.lstitensnf[index].vbcufdest * (this.vfator / 100)), 2, 'round');
                    vself.vpfcpufdedt         = util.arredondaValores(parseFloat(vself.lstitensnf[index].vpfcpufdedt * (this.vfator / 100)), 2, 'round');
                    vself.vpicmsufdest        = vself.lstitensnf[index].vpicmsufdest;
                    vself.vpicmsinter         = vself.lstitensnf[index].vpicmsinter;
                    vself.vpimsinterpart      = vself.lstitensnf[index].vpimsinterpart;
                    vself.vfcpufdest          = util.arredondaValores(parseFloat(vself.lstitensnf[index].vfcpufdest * (this.vfator / 100)), 2, 'round');
                    vself.vicmsufdest         = util.arredondaValores(parseFloat(vself.lstitensnf[index].vicmsufdest * (this.vfator / 100)), 2, 'round');
                    vself.vicmsufremet        = util.arredondaValores(parseFloat(vself.lstitensnf[index].vicmsufremet * (this.vfator / 100)), 2, 'round');
                    ///////////////////////////////////////////////

                    if (parseInt(vself.vregime) === 0){
                        vself.lstcst = vself.cstnormal;
                    }else{
                        vself.lstcst = vself.cstsimples;
                    }                

                    vself.vcst                = vself.lstitensnf[index].cst; 
                    vself.vcstold             = vself.lstitensnf[index].cst;
                    vself.vcstpiscofins       = vself.lstitensnf[index].cstpiscofins;
                    vself.vcstipi             = vself.lstitensnf[index].cstipi;                              
                    vself.vppis               = vself.lstitensnf[index].ppis;
                    vself.vvpis               = vself.lstitensnf[index].vpis;
                    vself.vppisst             = vself.lstitensnf[index].ppisst;
                    vself.vvpisst             = vself.lstitensnf[index].vpisst;
                    vself.vpcofins            = vself.lstitensnf[index].pcofins;
                    vself.vvcofins            = vself.lstitensnf[index].vcofins;
                    vself.vpcofinsst          = vself.lstitensnf[index].pcofinsst;
                    vself.vvcofinsst          = vself.lstitensnf[index].vcofinsst;
                    vself.vpipi               = vself.lstitensnf[index].pipi;
                    vself.vvipi               = vself.lstitensnf[index].vipi;
                    vself.vcenq               = vself.lstitensnf[index].cenq;
                    vself.vinfadprod          = vself.lstitensnf[index].infadprod;
                    vself.vxped               = vself.lstitensnf[index].xped;
                    vself.vnitemped           = vself.lstitensnf[index].nitemped;      
                    vself.vutrib              = vself.lstitensnf[index].utrib;
                    vself.vqtrib              = vself.lstitensnf[index].qtrib;

                    vself.lstcamposicms       = JSON.parse(JSON.stringify( vself.lstitensnf[index].campos));
                    vself.lstcamposicmsold    = JSON.parse(JSON.stringify( vself.lstitensnf[index].campos));

                    vself.mtdcalculatotalitem();



                    vself.lstitensnf[index].item                = vself.vitemalt;
                    vself.lstitensnf[index].coddig              = vself.vcoddig;
                    vself.lstitensnf[index].idproduto           = vself.vidproduto;
                    vself.lstitensnf[index].descproduto         = vself.vdescproduto;
                    vself.lstitensnf[index].item                = vself.vitemalt;
                    vself.lstitensnf[index].coddig              = vself.vcoddig;
                    vself.lstitensnf[index].und                 = vself.vund;
                    vself.lstitensnf[index].qtditem             = vself.vqtditem;
                    vself.lstitensnf[index].vlunitario          = vself.vvlunitario;
                    vself.lstitensnf[index].vldesconto          = vself.vvldesconto;
                    vself.lstitensnf[index].vltotal             = vself.vvltotal;
                    vself.lstitensnf[index].vfrete              = vself.vvfrete;
                    vself.lstitensnf[index].vseg                = vself.vvseg;
                    vself.lstitensnf[index].voutro              = vself.vvoutro;
                    vself.lstitensnf[index].idncm               = vself.vidncm;
                    vself.lstitensnf[index].idcest              = vself.vidcest;
                    vself.lstitensnf[index].idcfop              = vself.vidcfop;
                    vself.lstitensnf[index].orig                = vself.vorig;
                    vself.lstitensnf[index].regime              = vself.vregime;
                    vself.lstitensnf[index].vbcufdest           = vself.vbcufdest;
                    vself.lstitensnf[index].vpfcpufdedt         = vself.vpfcpufdedt;
                    vself.lstitensnf[index].vpicmsufdest        = vself.vpicmsufdest;
                    vself.lstitensnf[index].vpicmsinter         = vself.vpicmsinter;
                    vself.lstitensnf[index].vpimsinterpart      = vself.vpimsinterpart;
                    vself.lstitensnf[index].vfcpufdest          = vself.vfcpufdest;
                    vself.lstitensnf[index].vicmsufdest         = vself.vicmsufdest;
                    vself.lstitensnf[index].vicmsufremet        = vself.vicmsufremet;
                    vself.lstcst                                = parseInt(vself.vregime) === 0 ? vself.cstnormal : vself.cstsimples;
                    vself.lstitensnf[index].cst                 = vself.vcst;
                    vself.lstitensnf[index].cstold              = vself.vcstold;
                    vself.lstitensnf[index].cstpiscofins        = vself.vcstpiscofins;
                    vself.lstitensnf[index].cstipi              = vself.vcstipi;
                    vself.lstitensnf[index].ppis                = vself.vppis;
                    vself.lstitensnf[index].vpis                = vself.vvpis;
                    vself.lstitensnf[index].ppisst              = vself.vppisst;
                    vself.lstitensnf[index].vpisst              = vself.vvpisst;
                    vself.lstitensnf[index].pcofins             = vself.vpcofins;
                    vself.lstitensnf[index].vcofins             = vself.vvcofins;
                    vself.lstitensnf[index].pcofinsst           = vself.vpcofinsst;
                    vself.lstitensnf[index].vcofinsst           = vself.vvcofinsst;
                    vself.lstitensnf[index].pipi                = vself.vpipi;
                    vself.lstitensnf[index].vipi                = vself.vvipi;
                    vself.lstitensnf[index].cenq                = vself.vcenq;
                    vself.lstitensnf[index].infadprod           = vself.vinfadprod;
                    vself.lstitensnf[index].xped                = vself.vxped;
                    vself.lstitensnf[index].nitemped            = vself.vnitemped;   
                    vself.lstitensnf[index].utrib               = vself.vutrib;
                    vself.lstitensnf[index].qtrib               = vself.vqtrib;

                    vself.lstitensnf[index].campos              = vself.lstcamposicms; 
                    //vself.lstcamposicmsold    = vself.lstitensnf[index].campos
                }
                vself.vfator = 0;

                vself.mtdlimparedicaoitem();
                vself.mtdtotalizarnota();                
               
                loader.hide();  
                $('#mdselecionafator').modal('hide');
            },
            mtdexportarlista(excel){
                let vself   = this;              
                let filtro  = vself.mtdfiltropesquisa();
                let dtini   = parseInt(vself.pfiltroperiodo) === 0 ? '2010-01-01' : util.InverterData(vself.pdtini);
                let dtfim   = util.InverterData(vself.pdtfim);
                let filial  = vself.pidfilial === null ? 'TODAS AS FILIAIS' : $('#cbfilialpesq').select2('data')[0]['text'];
                if(excel == 1){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Deseja detalhar impressão?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    window.open(vself.$store.state.configpaths.pathcontrole+'rtcadnotasfiscais.php?idclientesac='+
                                    vself.$store.state.filialpadrao.idcliente+
                                    '&filtro='+filtro+
                                    '&filtroinutilizadas='+vself.pfiltroinutilizadas+
                                    '&dtini='+dtini+
                                    '&excel='+excel+
                                    '&dtfim='+dtfim+
                                    '&filial='+filial+
                                    '&detalhada='+1+
                                    '&usuario='+vself.$store.state.usuario.nome, '_blank');
                                    },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    window.open(vself.$store.state.configpaths.pathcontrole+'rtcadnotasfiscais.php?idclientesac='+
                                    vself.$store.state.filialpadrao.idcliente+
                                    '&filtro='+filtro+
                                    '&filtroinutilizadas='+vself.pfiltroinutilizadas+
                                    '&dtini='+dtini+
                                    '&excel='+excel+
                                    '&dtfim='+dtfim+
                                    '&filial='+filial+
                                    '&detalhada='+0+
                                    '&usuario='+vself.$store.state.usuario.nome, '_blank');
                                }
                            }
                        }
                    });					                                
                }else{
                    window.open(vself.$store.state.configpaths.pathcontrole+'rtcadnotasfiscais.php?idclientesac='+
                                    vself.$store.state.filialpadrao.idcliente+
                                    '&filtro='+filtro+
                                    '&filtroinutilizadas='+vself.pfiltroinutilizadas+
                                    '&dtini='+dtini+
                                    '&excel='+excel+
                                    '&dtfim='+dtfim+
                                    '&filial='+filial+
                                    '&detalhada='+0+
                                    '&usuario='+vself.$store.state.usuario.nome, '_blank');
                }
            },   
            mtdmostrarmenu(nf){				
                this.nfmenu = nf;
                $('#dvdefnf').hide();
				$('#mdmenunf').modal('show');
            },
            mtdmostraropcaocancelamento(){
                this.vjustcancelamento = '';
                $('#dvdefnf').toggle(300);
                let visivel  = $('#dvdefnf').is(':visible');
                if (visivel){
                   $('#txtcancelanf').focus(); 
                }
            },
            mtdconsultarproduto(){
				if (parseInt(this.vopitem) === 1){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
            },
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
            },             
	            mtdvisualizainut(){
	               let sit = parseInt(this.psituacaopesq);
	               return sit === 5 || sit === 99;
	            },        
            mtdfiltropesquisa(){
                let rfiltro = ''; 

                //filtro das inutilizações
                this.pfiltroinutilizadas = '';

                if (parseInt(this.pmodelo) < 99){
                    rfiltro = ' and nf.modelo='+this.pmodelo;
                    this.pfiltroinutilizadas = ' and i.nmodelo='+this.pmodelo;
                }
                if (this.pidfilial !== null){
                    rfiltro = rfiltro + ' and nf.idfilial='+this.pidfilial;
                    this.pfiltroinutilizadas = this.pfiltroinutilizadas + ' and i.idfilial='+this.pidfilial;
				}
                if (this.pidnatop !== null){
                    rfiltro = rfiltro + ' and nf.idnatop='+this.pidnatop;
                    this.pfiltroinutilizadas = this.pfiltroinutilizadas + ' and i.idnatop='+this.pidnatop;
				}                
	                if (parseInt(this.psituacaopesq) === 6){
	                    rfiltro = rfiltro + ' and nf.situacaonota in (0,1)';
	                }else if (parseInt(this.psituacaopesq) < 99){
	                    rfiltro = rfiltro + ' and nf.situacaonota=' + parseInt(this.psituacaopesq);
	                }
                // if (this.pdestinatario !== ''){
                //     rfiltro = rfiltro + ' and upper(nf.nomedestinatario) like upper("'+this.pdestinatario+'%")';
                // }
                if (this.piddestinatario !== null){
                    rfiltro = rfiltro + ' and nf.iddestinatario='+this.piddestinatario;
				}
                if (this.pserie !== ''){
                    rfiltro = rfiltro + ' and nf.serie='+this.pserie;
                    this.pfiltroinutilizadas = this.pfiltroinutilizadas + ' and i.nserie='+this.pserie;
                }
                if (this.pnnf !== ''){
                    rfiltro = rfiltro + ' and nf.nnf='+this.pnnf;
                }
				if(parseInt(this.pfiltroperiodo) === 1){
                    rfiltro = rfiltro + ' and nf.dthremissao between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                    this.pfiltroinutilizadas = this.pfiltroinutilizadas + ' and i.dthremissao between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                }	
                if(parseInt(this.ptpemis)!== 2){
                    rfiltro = rfiltro + ' and nf.contigenciaoffline='+this.ptpemis;
                }			                                
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}                
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor  : 'qtdregistros'},
                    {parametro: 'filtro',               valor  : filtro}                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarreganotasfiscais(1, '');
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarreganotasfiscais(ipagina, filtrocrud){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [];
                this.$refs.reflstnotasfiscais.selected_items = [];
                if (!vself.mtdvisualizainut()){
                    parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagemotimizada'},
                        {parametro: 'filtro',       valor : filtrocrud !== '' ? filtrocrud : filtro},
                        {parametro: 'limit',        valor : vself.pqtdregistros},
                        {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                    ];
                }else{
                    parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagemotimizada'},
                        {parametro: 'filtro',       valor : filtrocrud !== '' ? filtrocrud : filtro},
                        {parametro: 'filtroinutilizadas',   valor  : this.pfiltroinutilizadas},
                        {parametro: 'limit',        valor : vself.pqtdregistros},
                        {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                    ];                        
                }
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    console.log('diashdiuasd', response.data);
                    vself.ptotalnotas           = response.data.totalnotas;  
                    vself.lstnotasfiscais       = response.data.notas;
                    vself.lstinutilizacoes      = response.data.inutilizacoes;
                    let legdemo                 = JSON.parse(JSON.stringify(response.data.demonstrativocfop));
                    if(legdemo.length === 0){
                        vself.lstdemonstrativoscfop = []
                    }else{
                        vself.lstdemonstrativoscfop = legdemo;
                    }
                    
                    loader.hide();
                }).catch(function (response) {
                    vself.ptotalnotas           = 0;
                    vself.lstnotasfiscais       = [];
                    vself.lstinutilizacoes      = [];
                    vself.lstdemonstrativoscfop = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();
                this.vvisualizarqtrib   = false;
                this.lstitensnf         = [];
                this.lstnotasref        = [];
                this.lstcobranca        = [];
                this.lstformaspagamento = [];
                this.lstvolumes         = [];    
                this.lstdeclaracaoimp   = [];                
                this.vid                = '';
                this.vnnf               = '';
                this.vtpnf              = '1';
                this.vmodelo            = '55';
                this.vserie             = '';
                this.vtpdestinatario    = '0';
                this.vindpres           = '1';
                this.vindfinal          = '0';
                this.vidfilial          = null;
                this.vcrt               = 1;
                this.vidnatop           = null;
                this.viduffilial        = '';
                this.vdthremissao       = util.DataAtual(true);
                this.vfinnfe            = '1';
                this.vtpnfecredito      = '0';
                this.vtpnfedebito       = '0';
                this.viddestinatario    = null;
                this.vcalctrib          = 1;
                this.vidinfcpl          = null;
                this.vinfcpl            = '';
                this.vimprimereferenciaitens= false;
                this.vmodfrete              = 9;
                this.vidtransportadora      = null;
                this.vtipotransporte        = 4;
                this.vveic_transp_placa     = '';
                this.vveic_transp_uf        = '';
                this.vveic_transp_rntc      = '';
                this.vreboque_transp_placa  = '';
                this.vreboque_transp_uf     = '';
                this.vreboque_transp_rntc   = '';
                this.vtransp_vagao          = '';
                this.vtransp_balsa          = '';
                
                this.vnomeinter             = '';
                this.vcnpjinter             = '';

                this.vtotalcobranca     = 0;
                this.vtotalformas       = 0;


                this.vencontingencia    = 0;

                //totalizadores
                this.tbc 			    = 0;
                this.ticms 		        = 0;
                this.ticmsdeson 	    = 0;
                this.tfcp 			    = 0;
                this.tbcst 		        = 0;
                this.tst 			    = 0;
                this.tfcpst 		    = 0;
                this.tfcpstret 	        = 0;
                this.tprod 		        = 0;
                this.tfrete 		    = 0;
                this.tseg 			    = 0;
                this.tdesc 		        = 0;
                this.tii 			    = 0;
                this.tipi 			    = 0;
                this.tipidevol 	        = 0;
                this.tpis 			    = 0;
                this.tcofins 		    = 0;
                this.toutro 		    = 0;
                this.tnf 			    = 0;
                this.ttottrib 		    = 0; 
                // this.ttottrib_calculado = 0; 
                
                this.totcbs             = 0;
                this.totibs             = 0;
                this.totis              = 0;
                this.totibsmun          = 0;
                this.totibsuf           = 0;


                $('#cbinfcpl').val(null).trigger('change');
                $('#cbfilial').val(null).trigger('change');
                $('#cbdestinatario').val(null).trigger('change');
                $('#cbnatop').val(null).trigger('change');

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                this.CarregaListaCstClassTribIBSCBS();
                $('#pncadastro').fadeIn(700);
                setTimeout(() => {
                    if (parseInt(this.opcrud) < 3) {
                        $('#cbfilial').select2('open');
                    } else {
                        $('#btgravar').focus();
                    }                    
                }, 300);
            },
            mtddadosfilial(idfilial){
                let vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and f.codfil='+vself.vidfilial;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretoriocertificados', valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.viduffilial = response.data[0].iduf;
                    if (parseInt(vself.opcrud) === 1){
                        vself.vcrt        = response.data[0].crt;
                    }

                    vself.vanulacalcicms = parseInt(response.data[0].calculoicms) === 1 ? true : false;
                    
                    if (vself.vnatope === ''){
                        vself.vnatope = response.data[0].natope;
                    }
                    if (vself.vserie === ''){
                        vself.vserie  = response.data[0].serie55;
                    }
                    if (parseInt(vself.opcrud) === 2){
                        if (parseInt(idfilial) !== vself.vidfilial_old){
                            vself.mtdcarregaultnf();
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdcarregaultnf(){                
                let vself       = this;
                vself.$toastr.i('A troca de filial ocasiona a alteração do Número da NF. Verifique corretamente a numeração!', 'Informação!');                
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'op',           valor : 'pegaultnnf'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial',     valor : vself.vidfilial},
                    {parametro: 'modelo',       valor : vself.vmodelo},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.vnnf  = response.data;
                }).catch(function (response) {
                    vself.vnnf  = '';
                    loader.hide();
                });
            },
            mtddefselect2destinatario(){
                let vself             = this;
                vself.viddestinatario = null;                				
				$("#cbdestinatario").val(null).trigger('change');
				$("#cbdestinatario").select2({
					id: function (e) {return e.id},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q       : params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb      : parseInt(vself.vtpdestinatario) === 0 ? 'tbclientes' : 'tbfornecedores',
								c1	    : 'id',
								c2	    : parseInt(vself.vtpdestinatario) === 0 ? 'nome' : 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.viddestinatario = $("#cbdestinatario").val();
				});
            },
            mtddefselect2destinatariopesq(){
                let vself             = this;
                vself.piddestinatario = null;                				
				$("#cbdestinatariopesq").val(null).trigger('change');
				$("#cbdestinatariopesq").select2({
					id: function (e) {return e.id},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q       : params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb      : parseInt(vself.ptpdestinatario) === 0 ? 'tbclientes' : 'tbfornecedores',
								c1	    : 'id',
								c2	    : parseInt(vself.ptpdestinatario) === 0 ? 'nome' : 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.piddestinatario = $("#cbdestinatariopesq").val();
				});
            },            
            mtdselect2_def(){
                let vself = this;                
                //sql para pegar somente as filiais do usuário
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';
                

                vself.config.checkbox_rows = true;
	                $('#mdsetarmassancm').on('hide.bs.modal', function (e) {
                    vself.vidncmsetar      = null;
                    vself.lstncmssubstitur = null;
                    $('#cbncmsetar').val(null).trigger('change');
                    $('#cbncmssubstituir').val(null).trigger('change');
                });

				$('#mdcartacorrecao').on('show.bs.modal', function (e) {
                    $('#dvedicaocarta').hide();
                    $('#dvlistacartas').show();                                        
                });	
				$('#mdedicaoitem').on('show.bs.modal', function (e) {
                    if (parseInt(vself.vopitem) === 1){
                        vself.mtdlimparedicaoitem();
                        vself.atribuilistacst(vself.mtdselecionarcamposgrupofiscal);
                        vself.mtdselecionarcamposgrupofiscalcbs();
                    }
                });                			
				$('#mdedicaoitem').on('shown.bs.modal', function (e) {
					if (parseInt(vself.vopitem) === 1){
						$('#edidproduto').focus();
					}else{
						$('#edqtditem').focus();
					}
                });
				$('#mdnotaref').on('shown.bs.modal', function (e) {
					$('#cbtiponfref').focus();
                });                
				$('#mdcobranca').on('shown.bs.modal', function (e) {
					$('#eddvenc').focus();
                });                                
				$('#mdformapagamento').on('shown.bs.modal', function (e) {
					$('#cbformapagamento').focus();
                });                 
				$('#mdvolumefrete').on('shown.bs.modal', function (e) {
					$('#edqvol').focus();
                }); 
				$('#mdmenunf').on('show.bs.modal', function (e) {
                });
				$('#mdatribuircfop').on('shown.bs.modal', function (e) {                    
					$('#cfoptodos').select2('open');
                });

				$('#mdinutilizacao').on('shown.bs.modal', function (e) {
					$('#cbfilialinutilizacao').focus();
                }); 
                
				$('#mdinfemailcliente').on('shown.bs.modal', function (e) {
					$('#edinfemailcliente').focus();
                }); 

				$('#mdcorrecaonf').on('shown.bs.modal', function (e) {                    
					$('#edcchavenf').focus();
                });

				$('#mdagruparpedidos').on('shown.bs.modal', function (e) {  
                    vself.lstpedidosagrupar = [];                  
					var deffilial  			= new Option(vself.$store.state.filialpadrao.fantasia, vself.$store.state.filialpadrao.codfil, true, true);
					$('#cbfilialagr').append(deffilial).trigger('change');	                    

                    $('#cbclienteagr').val(null).trigger('change');

					$('#cbfilialagr').select2('open');
                });    

                $('#mdselecionafator').on('shown.bs.modal', function (e) {
					vself.vfator = 0;
                });

                $("#cbncmssubstituir").select2({
                        multiple: true, // Permite múltiplas seleções
                        placeholder: 'Selecione 1 ou mais NCMs',
                        allowClear: true,
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.lstncmssubstitur = $("#cbncmssubstituir").val();
                });
                $("#cbncmsetar").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidncmsetar = $("#cbncmsetar").val();
                });
                
                $("#cbfilialexport").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidfilialexport = $("#cbfilialexport").val();  
                });

				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidfilial = $("#cbfilial").val();
                    vself.mtddadosfilial(vself.vidfilial);                   
                });
                $("#cbnatop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbnaturezasoperacoesnf',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidnatop = $("#cbnatop").val();
                });                                                                                  
                $("#cbncm").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidncm = $("#cbncm").val();
                    if (vself.vidncm !== null){
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',               valor : 'aliquotaibpt'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'idncm',            valor : vself.vidncm},
                            {parametro: 'uf',               valor : vself.viduffilial}
                        ];
                        let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadncms.php');
                        retorno.then(function (response) {
                            vself.valiquotaibpt         = response.data;
                            loader.hide();						
                        }).catch(function (response) {
                            vself.valiquotaibpt = 0;
                            loader.hide();
                        });                        
                        
                    }
                });
                $("#cbcest").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcests',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcest = $("#cbcest").val();
                });
                
                $("#cbanp").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbanps',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {               
                    vself.vcprodanp = $("#cbanp").val();
                });

                $("#cbcfop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcfops',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcfop = $("#cbcfop").val();
                });   
                $("#cbcfopimpdi").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcfops',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcfopimpdi = $("#cbcfopimpdi").val();
                });    
                
                $("#cbcfopatrop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcfops',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcfopdados = $("#cbcfopatrop").val();
                });   


                
                $("#cbinfcpl").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbinformacoescomplementares',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidinfcpl = $("#cbinfcpl").val();
                });

                $("#cbformapagamento").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbformaspagamento',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidforma = $("#cbformapagamento").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and f.id='+vself.vidforma;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformaspagamento.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.formaselecionada  = response.data[0];
                        if (response.data.length > 0){
                            vself.visualizacaut     = parseInt(vself.formaselecionada.tef) === 0 ? false : true;
                        }else{
                            vself.visualizacaut     = false;
                        }
                        vself.vcaut             = '';                        
                    }).catch(function (response) {
                        loader.hide();
                    });                    
                });

				$("#cbtransportadora").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtransportadoras',
                                c1: 'id',
                                c2: 'fantasia'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidtransportadora = $("#cbtransportadora").val();
                });

                vself.mtddefselect2destinatario();                   
                vself.mtddefselect2destinatariopesq();                   

                //selects da consulta
				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
                });
                $("#cbnatoppesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbnaturezasoperacoesnf',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidnatop = $("#cbnatoppesq").val();
                    vself.mtdlimpar_listagem();
                });                                    
                //inutilização
				$("#cbfilialinutilizacao").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.iidfilial = $("#cbfilialinutilizacao").val();
                });
                
                $("#cbcfoptodos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcfops',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcfoptodos = $("#cbcfoptodos").val();
                }); 
                
                //agrupamento de pedidos
				$("#cbfilialagr").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.aidfilial         = $("#cbfilialagr").val();
                    vself.lstpedidosagrupar = [];

					var deffilial  			= new Option($('#cbfilialagr').select2('data')[0]['text'], vself.aidfilial, true, true);
					$('#cbfilialnf').append(deffilial).trigger('change');	                    

				});                
				$("#cbclienteagr").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.aidcliente        = $("#cbclienteagr").val();
                    vself.lstpedidosagrupar = [];
				}); 
				$("#cbfilialnf").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.aidfilialnf = $("#cbfilialnf").val();
				});            
                
                
                //carrega os grupos de tributação do CBS
                let parametros  = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'carregacstcbs'}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                retorno.then(function (response) {
                    vself.lstcstcbs = response.data;
                    
                }).catch(function (response) {
                    vself.lstcstcbs = [];
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvitens"]').tab('show');
                $('.nav-tabs a[href="#dvtransporte"]').tab('show'); 
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('020Z.020Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO - NOTAS FISCAIS DE SAÍDA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstnotasfiscais = [];
                this.lstinutilizacoes= [];
                this.lstdemonstrativoscfop = []; 
                this.ptotalnotas     = 0;
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
                this.$refs.reflstnotasfiscais.selected_items = [];
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) === 2){//rotina para alteração quando o usuário pode alterar o número da nota e/ou série
                    if (vself.vserie === ''){
                        vself.$toastr.w('Número de série deve ser informado!', 'Atenção!');    
                        $('#edserie').focus();
                        return;
                    }
                    if (vself.vnnf === ''){
                        vself.$toastr.w('Número da nota deve ser informado!', 'Atenção!');    
                        $('#ednnf').focus();
                        return;
                    }                    
                }
                if (parseInt(vself.opcrud) < 3){
                    for (let i = 0; i < vself.lstitensnf.length; i++) {
                        if (vself.lstitensnf[i].cstpiscofins === '' || vself.lstitensnf[i].cstpiscofins === null){
                            vself.$toastr.w('CST PIS/COFINS do item: '+vself.lstitensnf[i].item+' não informado. Verifique e tente novamente!', 'Atenção!');                            
                            return;
                        }
                        if (vself.lstitensnf[i].cstipi === '' || vself.lstitensnf[i].cstipi === null){
                            vself.$toastr.w('CST IPI do item: '+vself.lstitensnf[i].item+' não informado. Verifique e tente novamente!', 'Atenção!');                            
                            return;
                        }                        
                    } 
                    if (parseFloat(vself.vtotalformas).toFixed(2) !== parseFloat(vself.tnf).toFixed(2)){
                        if (util.arredondaValores(parseFloat(vself.vtotalformas), 2, 'round') !== util.arredondaValores(parseFloat(vself.tnf), 2, 'round')){
                            vself.$toastr.w('Total das formas de pagamento não confere com o total da nota. Verifique e tente novamente!', 'Atenção!');
                            $('.nav-tabs a[href="#dvformapagamento"]').tab('show');
                            return;
                        }                        
                    }                   
                    // if (vself.lstcobranca.length > 0){
                    //     if (parseFloat(vself.vtotalcobranca) !== parseFloat(vself.tnf) ){
                    //         vself.$toastr.w('Total da cobrança não confere com o total da nota. Verifique e tente novamente!', 'Atenção!');
                    //         $('.nav-tabs a[href="#dvcobranca"]').tab('show');
                    //         return;
                    //     }
                    // }
                    if (parseInt(vself.vmodfrete) > 1 && parseInt(vself.vmodfrete) < 9){//Verificações quanto as informações do frete
                        if (vself.vidtransportadora === null){
                            vself.$toastr.w('Transportadora deve ser informada!', 'Atenção!');    
                            $('.nav-tabs a[href="#dvfrete"]').tab('show');
                            $('#cbtransportadora').focus();
                            return;
                        }
                        if (parseInt(vself.vtipotransporte) === 0 && (vself.vveic_transp_placa === '' || vself.vveic_transp_uf === '' || vself.vveic_transp_rntc === '')){
                            vself.$toastr.w('As informações do veículo de transporte devem ser informadas!', 'Atenção!');    
                            $('.nav-tabs a[href="#dvfrete"]').tab('show');
                            $('.nav-tabs a[href="#dvtransporte"]').tab('show');                                        
                            $('#cbtipotransporte').focus();
                            return;
                        }
                        if (parseInt(vself.vtipotransporte) === 1 && (vself.vreboque_transp_placa === '' || vself.vreboque_transp_uf === '' || vself.vreboque_transp_rntc === '')){
                            vself.$toastr.w('As informações do reboque de transporte devem ser informadas!', 'Atenção!');    
                            $('.nav-tabs a[href="#dvfrete"]').tab('show');
                            $('.nav-tabs a[href="#dvtransporte"]').tab('show');                                        
                            $('#cbtipotransporte').focus();
                            return;
                        }
                        if (parseInt(vself.vtipotransporte) === 2 && vself.vtransp_balsa === ''){
                            vself.$toastr.w('As informações da balsa de transporte devem ser informadas!', 'Atenção!');    
                            $('.nav-tabs a[href="#dvfrete"]').tab('show');
                            $('.nav-tabs a[href="#dvtransporte"]').tab('show');                                        
                            $('#edtransp_balsa').focus();
                            return;
                        }
                        if (parseInt(vself.vtipotransporte) === 3 && vself.vtransp_vagao === ''){
                            vself.$toastr.w('As informações da balsa de transporte devem ser informadas!', 'Atenção!');    
                            $('.nav-tabs a[href="#dvfrete"]').tab('show');
                            $('.nav-tabs a[href="#dvtransporte"]').tab('show');                                        
                            $('#edtransp_vagao').focus();
                            return;
                        }
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id, clone){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and nf.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (!clone){
                        if (parseInt(response.data.notas[0].situacaonota) > 1){
                            vself.$toastr.i('Para EDITAR ou REMOVER a nota, a situação da mesma deve estar em digitação ou somente enviada!', 'Informação!');
                            vself.mtdcancelaredicao();
                            return;
                        }
                        if((response.data.notas[0].xmotivo === '')&&(parseInt(response.data.notas[0].contigenciaoffline) === 1)){
                            vself.$toastr.i('Para EDITAR ou REMOVER uma nota em contingência, você deve tentar envia-la primeiro!', 'Informação!');
                            vself.mtdcancelaredicao();
                            return;
                        }
                    }
                    
                    vself.mtdigualarcampos(response.data.notas[0]);
                    
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                $('#mdmenunf').modal('hide'); 
                if (!util.opcaousuario('020Z.020Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO - NOTAS FISCAIS DE SAÍDA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id, false);
                }
            },
            mtdclonar(item){
                let vself = this;
                if (!util.opcaousuario('020Z.020Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO - NOTAS FISCAIS DE SAÍDA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                    this.mtdlocalizaregistro(item.id, true);
                    setTimeout(() => {                            
                        vself.vid                = '';
                        vself.vnnf               = '';
                        vself.vserie             = '';
                        vself.vidfilial          = null;                            
                        vself.lstnotasref    = [];
                        vself.lstcobranca    = [];
                        var deffilial  = new Option(item.fantasiafil, item.idfilial, true, true);
                        $('#cbfilial').append(deffilial).trigger('change');
                    }, 500); 
                }                
            },
            mtdexcluir(item){
                $('#mdmenunf').modal('hide'); 
                if (!util.opcaousuario('020Z.020Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO - NOTAS FISCAIS DE SAÍDA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id, false);
                }
            },
            mtdigualarcampos(registro){
                console.log('aqui');
                this.vid                    = registro.id;
                this.vnnf                   = registro.nnf;
                this.vtpnf                  = registro.tpnf;
                this.vmodelo                = registro.modelo;
                this.vserie                 = registro.serie;
                this.vtpdestinatario        = registro.tpdestinatario;
                this.vindpres               = registro.indpres;
                this.vindfinal              = registro.indfinal;
                this.vcalctrib              = parseInt(registro.calctrib);
                this.viddest                = parseInt(registro.iddest);
                this.vidfilial              = registro.idfilial;                
                this.vidnatop               = registro.idnatop;
                this.vdthremissao           = parseInt(registro.modelo) === 55 ? registro.dthremissao : util.DataAtual(true);
                this.vfinnfe                = registro.finnfe;
                this.vtpnfecredito          = registro.tpnfecredito;
                this.vtpnfedebito           = registro.tpnfedebito;
                this.viddestinatario        = registro.iddestinatario;
                this.vinfcpl                = registro.infcpl;
                this.vimprimereferenciaitens= parseInt(registro.imprimereferenciaitens) === 0 ? false : true;
                this.vmodfrete              = registro.modfrete;
                this.vidtransportadora      = registro.idtransportadora;
                this.vtipotransporte        = registro.tipotransporte;
                this.vveic_transp_placa     = registro.veic_transp_placa;
                this.vveic_transp_uf        = registro.veic_transp_uf;
                this.vveic_transp_rntc      = registro.veic_transp_rntc;
                this.vreboque_transp_placa  = registro.reboque_transp_placa;
                this.vreboque_transp_uf     = registro.reboque_transp_uf;
                this.vreboque_transp_rntc   = registro.reboque_transp_rntc;
                this.vtransp_vagao          = registro.transp_vagao;
                this.vtransp_balsa          = registro.transp_balsa;   
                
                this.vcnpjinter             = registro.cnpjinter;
                this.vnomeinter             = registro.nomeinter;


                //númeo da nf a verificar durante a alteração
                this.vidfilial_old          = registro.idfilial;
                this.vmodelo_old            = registro.modelo;             

                //totalizadores
                this.tbc 			        = registro.vbc;
                this.ticms 		            = registro.vicms;
                this.ticmsdeson 	        = registro.vicmsdeson;
                this.tfcp 			        = registro.vfcp;
                this.tbcst 		            = registro.vbcst;
                this.tst 			        = registro.vst;
                this.tfcpst 		        = registro.vfcpst;
                this.tfcpstret 	            = registro.vfcpstret;
                this.tprod 		            = registro.vprod;
                this.tfrete 		        = registro.vfrete;
                this.tseg 			        = registro.vseg;
                this.tdesc 		            = registro.vdesc;
                this.tii 			        = registro.vii;
                this.tipi 			        = registro.vipi;
                this.tipidevol 	            = registro.vipidevol;
                this.tpis 			        = registro.vpis;
                this.tcofins 		        = registro.vcofins;
                this.toutro 		        = registro.voutro;
                this.tnf 			        = registro.vnf;

                this.ttottrib               = registro.vtottrib;
                // this.ttottrib_calculado     = registro.vtottrib_calculado; 
                this.vcalctrib              = registro.calctrib;
    

                this.lstitensnf             = registro.itens;
                this.lstnotasref            = registro.notasref;
                this.lstcobranca            = registro.parcelas;
                this.lstformaspagamento     = registro.formas;
                this.lstvolumes             = registro.volumes; 

                this.totcbs                 = registro.vtotcbs;
                this.totibs                 = registro.vtotibs;
                this.totibsmun              = registro.vtotibsmun;
                this.totibsuf               = registro.vtotibsuf;
                this.totis                  = registro.vtotis;
               

                this.vencontingencia        = parseInt(registro.contigenciaoffline);


                this.lstcobranca = [];
                if (registro.parcelas.length > 0){
                    for (let i = 0; i < registro.parcelas.length; i++) {
                        let parcelatmp = {
                            ndup  : registro.parcelas[i].ndup,
                            dordem: new Date(util.formatardataDB(registro.parcelas[i].dvenc)),
                            dvenc : registro.parcelas[i].dvenc,
                            vdup  : parseFloat(registro.parcelas[i].vdup)
                        };
                        this.lstcobranca.push(parcelatmp);                                              
                    }
                }

                var deffilial  = new Option(registro.fantasiafil, this.vidfilial, true, true);
                $('#cbfilial').append(deffilial).trigger('change');

                this.vcrt                   = registro.crt;

                var defnatop  = new Option(registro.descnatop, this.vidnatop, true, true);
                $('#cbnatop').append(defnatop).trigger('change');

                var defdestinatario  = new Option(registro.nomedestinatario, this.viddestinatario, true, true);
                $('#cbdestinatario').append(defdestinatario).trigger('change');
                if (this.vidtransportadora !== null && parseInt(this.vidtransportadora) !== 0){
                    var deftransp  = new Option(registro.fantasiatransp, this.vidtransportadora, true, true);
                    $('#cbtransportadora').append(deftransp).trigger('change');                
                }else{
                    $('#cbtransportadora').val(null).trigger('change'); 
                }
                
                this.mtdtotalizaformaspagamento();
                this.mtdordenarparcelas();
            },
            mtdregistro(){
                let vself  = this;

                if(vself.vfinnfe == '5' && vself.vtpnfecredito == ''){
                    vself.$toastr.w('Tipo de crédito da NFe deve ser informado quando a finalidade for devolução!', 'Atenção!');    
                    $('#cbtpnfecredito').focus();
                    return;
                }
                if(vself.vfinnfe == '6' && vself.vtpnfedebito == ''){
                    vself.$toastr.w('Tipo de débito da NFe deve ser informado quando a finalidade for ajuste!', 'Atenção!');    
                    $('#cbtpnfedebito').focus();
                    return;
                }
                
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                    : this.vid,
                    'idfilial' 				: this.vidfilial,
                    'crt'                   : this.vcrt,
                    'modelo' 				: this.vmodelo,
                    'serie' 				: this.vserie,
                    'nnf' 					: this.vnnf,
                    'tpnf' 					: this.vtpnf,
                    'indpres' 	         	: this.vindpres,
                    'indfinal' 	         	: this.vindfinal,
                    'iddest' 	         	: this.viddest,
                    'tpdestinatario' 		: this.vtpdestinatario,
                    'cnpjinter' 	        : this.vcnpjinter.replace(/[^0-9]/g,''),
                    'nomeinter' 	        : this.vnomeinter,
                    'finnfe' 				: this.vfinnfe,
                    'tpnfecredito' 		    : this.vtpnfecredito,
                    'tpnfedebito'           : this.vtpnfedebito,
                    'iddestinatario' 		: this.viddestinatario,
                    'idnatop' 				: this.vidnatop,
                    'nomedestinatario' 		: $('#cbdestinatario').select2('data')[0]['text'],
                    'cpfcnpjconsumidor' 	: '',
                    'dthremissao'           : this.vdthremissao, 
                    'totalnota' 			: this.tnf,
                    'vtroco' 				: 0,
                    'vbc' 					: this.tbc,
                    'vicms' 				: this.ticms,
                    'vicmsdeson' 			: this.ticmsdeson,
                    'vfcp' 					: this.tfcp,
                    'vbcst' 				: this.tbcst,
                    'vst' 					: this.tst,
                    'vfcpst' 				: this.tfcpst,
                    'vfcpstret' 			: this.tfcpstret,
                    'vprod' 				: this.tprod,
                    'vfrete' 				: this.tfrete,
                    'vseg' 					: this.tseg,
                    'vdesc' 				: this.tdesc,
                    'vii' 					: this.tii,
                    'vipi' 					: this.tipi,
                    'vipidevol' 			: this.tipidevol,
                    'vpis' 					: this.tpis,
                    'vcofins' 				: this.tcofins,
                    'voutro' 				: this.toutro,
                    'vnf' 					: this.tnf,

                    'vtotcbs' 			    : this.totcbs,
                    'vtotibs' 			    : this.totibs,
                    'vtotibsmun' 		    : this.totibsmun,
                    'vtotibsuf' 			: this.totibsuf,
                    'vtotis' 			    : this.totis,

                    'vtottrib' 				: this.ttottrib,
                    // 'vtottrib_calculado' 	: this.ttottrib_calculado,
                    'calctrib' 	            : this.vcalctrib,  //variavel que controla se o ibpt deve ser calculado ou nao

                    'modfrete' 				: this.vmodfrete,
                    'idtransportadora' 		: this.vidtransportadora,
                    'tipotransporte' 		: this.vtipotransporte,
                    'veic_transp_placa' 	: this.vveic_transp_placa,
                    'veic_transp_uf' 		: this.vveic_transp_uf,
                    'veic_transp_rntc' 		: this.vveic_transp_rntc,
                    'reboque_transp_placa' 	: this.vreboque_transp_placa,
                    'reboque_transp_uf' 	: this.vreboque_transp_uf,
                    'reboque_transp_rntc' 	: this.vreboque_transp_rntc,
                    'transp_vagao' 			: this.vtransp_vagao,
                    'transp_balsa' 			: this.vtransp_balsa,
                    'infadfisco' 			: '',
                    'infcpl' 				: this.vinfcpl,
                    'imprimereferenciaitens': this.vimprimereferenciaitens === false ? 0 : 1,
                    'itens'                 : this.lstitensnf,
                    'notasref'              : this.lstnotasref,
                    'formas'                : this.lstformaspagamento,
                    'parcelas'              : this.lstcobranca,
                    'volumes'               : this.lstvolumes
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.009X.001Z' : parseInt(this.opcrud) === 2 ? '001Z.009X.002Z' : '001Z.009X.003Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.psituacaopesq = 99;
                        vself.pconteudo             = '';//parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas          = 1;
                        //vself.pnnf                  = response.data;
                        vself.mtdcancelaredicao();
                        vself.mtdcarreganotasfiscais(1, ' and nf.id='+response.data);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },			
			mtdlimparedicaoitem(){
                this.vcoddig             = '';
                this.vidproduto          = '';
                this.vdescproduto        = '';
                this.vund                = '';
                this.vqtditem            = 1;
                this.vvlunitario         = 0;
                this.vvldesconto         = 0;
                this.vvltotal            = 0;
                this.vvfrete             = 0;
                this.vvseg               = 0;
                this.vvoutro             = 0;
                this.vidncm              = null;
                this.vidcest             = null;
                this.vidcfop             = null;
                this.vorig               = '0';
                this.valiquotaibpt       = 0; 
                this.vregime             = '0';
                this.vcst                = '00'; 
                this.vcstpiscofins       = '1';
                this.vcstipi             = '9';                              
                this.vppis               = 0;
                this.vvpis               = 0;
                this.vppisst             = 0;
                this.vvpisst             = 0;
                this.vpcofins            = 0;
                this.vvcofins            = 0;
                this.vpcofinsst          = 0;
                this.vvcofinsst          = 0;
                this.vpipi               = 0;
                this.vvipi               = 0;
                this.vcenq               = '99';
                this.vinfadprod          = '';
                this.vxped               = '';
                this.vnitemped           = '';
                this.vutrib              = '',
                this.vqtrib              = 1,                
                this.lstcamposicms       = [];

                this.lstdeclaracaoimp    = [];

                /// partilha de icms 
                this.vbcufdest           = 0;   
                this.vpfcpufdedt         = 0; 
                this.vpicmsufdest        = 0;
                this.vpicmsinter         = 0;
                this.vpimsinterpart      = 0;
                this.vfcpufdest          = 0;
                this.vicmsufdest         = 0;
                this.vicmsufremet        = 0;
                
                //combustível
                this.vcprodanp           = null; 
                this.vufcons             = ''; 
                this.vpglp               = 0; 
                this.vpgnn               = 0; 
                this.vpgni               = 0; 
                this.vvpart              = 0;      
                
                
                //  Campos Reforma Tributária IBS/CBS

                this.vcClassTrib            = '';
                this.vCstIBSCBS             = '';
                this.vCstIBSCBSold          = '';
                this.lstCstsIBSCBS          = [];
                this.vcClassTribold         = '';
                this.lstcClassTribs         = [];

                // IBS
                this.vAliqIBSUF           = 0;
                this.vAliqRedIBSUF        = 0;
                this.vAliqDifIBSUF        = 0;
                this.swValPadroesIBSUF    = false;

                this.vAliqIBSMun          = 0;
                this.vAliqRedIBSMun       = 0;
                this.vAliqDifIBSMun       = 0;
                this.swValPadroesIBSMun   = false;

                // CBS
                this.vAliqCBS             = 0;
                this.vAliqRedCBS          = 0;
                this.vAliqDifCBS          = 0;
                this.swValPadroesCBS      = false;

                // Tributação Regular
                this.vCstIBSCBSReg        = '';
                this.vcClassTribReg       = '';
                this.lstcClassTribsReg    = [];
                this.pAliqEfetIBSUFReg    = 0;
                this.pAliqEfetIBSMunReg   = 0;
                this.pAliqEfetCBSReg      = 0;

                // Tributação Monofásica
                    // Normal
                this.vAliqAdRemIBS        = 0;
                this.vAliqAdRemCBS        = 0;
                    // Sujeita a retenção
                this.vAliqAdRemIBSReten   = 0;
                this.vAliqAdRemCBSReten   = 0;
                    // Retida anteriormente
                this.vAliqAdRemIBSRet     = 0;
                this.vAliqAdRemCBSRet     = 0;
                    // Diferimento
                this.vAliqDifIBSMono      = 0;
                this.vAliqDifCBSMono      = 0;

                // IBSCBS - Crédito presumido
                this.swCredPresumido      = false;
                this.vcCredPres           = '';
                this.vpCredPresIBS        = 0;
                this.vpCredPresCBS        = 0;

                // Transf Crédito
                this.vIBSTransfCred       = 0;
                this.vCBSTransfCred       = 0;
                
                // Compra Governamental
                this.swCompraGov          = false;
                this.vTpEnteGov           = '';
                this.vAliqRedutorGov      = 0;
                this.vTpOperGov           = '';
                this.vpAliqIBSUFGov       = 0;
                this.vpAliqIBSMunGov      = 0;
                this.vpAliqCBSGov         = 0;

                // ZFM 
                this.tpCredPresIBSZFM     = '';

                // IS
                this.vcstis               = '000';
                this.vpis                 = 0;
                this.vpisesp              = 0;


                this.CarregaListaCstClassTribIBSCBS();
                this.mtddeclaracaoimporta();
                $('#cbncm').val(null).trigger('change');
                $('#cbcest').val(null).trigger('change');
                $('#cbcfop').val(null).trigger('change');
                $('#cbanp').val(null).trigger('change');
                $('.nav-tabs a[href="#dvicms"]').tab('show');
			},
			mtdadcionaritem(){
                if (this.vidfilial === null){
					this.$toastr.w('Selecione uma filial antes de lançar os ítens na nota!', 'Atenção!');
					$('#cbfilial').focus();
					return;                    
                }
                this.mtdlimparedicaoitem();
				this.vopitem					= 1;
				$('#mdedicaoitem').modal('show');
			},
            mtdalteraregime(){
                this.atribuilistacst(this.mtdselecionarcamposgrupofiscal);
            },
            atribuilistacst(callback){
                if (parseInt(this.vregime) === 0){
                    this.lstcst = this.cstnormal;
                    this.vcst   = '00';
                }else{
                    this.lstcst = this.cstsimples;
                    this.vcst   = '101';
                }
                callback();
            },
            mtdselecionaclasstribcbs(idgrupo, resetaclasstrib = true){
                let ind = util.getArrayIndexForKey(this.lstcstcbs, 'codigo', idgrupo);
                this.lstclasstrib = this.lstcstcbs[ind].classtrib;
                if (resetaclasstrib){
                    this.vclasstrib    = this.lstclasstrib[0].codigo;
                }
            },
            mtdselecionarcamposgrupofiscalcbs(){
                var vself       = this;
                if (parseInt(vself.vopitem) === 1){
                    let loader      = this.$loading.show();
                    let parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'camposgrupofiscalcbs'},
                        {parametro: 'idgrupo',      valor : vself.vcstcbs}
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                    retorno.then(function (response) {           
                              
                        vself.lstcamposcbs = response.data;
                        vself.mtdselecionaclasstribcbs(vself.vcstcbs, true);  
                        loader.hide();           
                    }).catch(function (response) {
                        vself.lstcamposcbs = [];                    
                        loader.hide();
                    });                
                }else{
                    if (vself.vcstcbsold !== vself.vcstcbs){
                        let loader      = this.$loading.show();
                        let parametros  = [
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'op',           valor : 'camposgrupofiscalcbs'},
                            {parametro: 'idgrupo',      valor : vself.vcstcbs}
                        ];
                        let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                        retorno.then(function (response) {                    
                            vself.lstcamposcbs = response.data;
                            vself.mtdselecionaclasstribcbs(vself.vcstcbs);    
                            loader.hide();           
                        }).catch(function (response) {
                            vself.lstcamposcbs = [];                    
                            loader.hide();
                        });                
                    }else{
                        vself.lstcamposcbs = vself.lstcamposcbsold;
                    }
                }
            },
            mtdselecionarcamposgrupofiscal(){
                var vself       = this;
                if (parseInt(vself.vopitem) === 1){
                    let loader      = this.$loading.show();
                    let parametros  = [
                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'camposgrupofiscal'},
                        {parametro: 'idgrupo',      valor : vself.vcst}
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                    retorno.then(function (response) {                    
                        vself.lstcamposicms = response.data;
                        loader.hide();           
                    }).catch(function (response) {
                        vself.lstcamposicms = [];                    
                        loader.hide();
                    });                
                }else{
                    if (vself.vcstold !== vself.vcst){
                        let loader      = this.$loading.show();
                        let parametros  = [
                            {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'op',           valor : 'camposgrupofiscal'},
                            {parametro: 'idgrupo',      valor : vself.vcst}
                        ];
                        let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                        retorno.then(function (response) {                    
                            vself.lstcamposicms = response.data;
                            loader.hide();           
                        }).catch(function (response) {
                            vself.lstcamposicms = [];                    
                            loader.hide();
                        });                
                    }else{
                        vself.lstcamposicms = vself.lstcamposicmsold;
                    }
                }
            },
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
                        {parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
                        {parametro: 'offset',           valor : 0},
                        {parametro: 'idfilialclasse',   valor : vself.vidfilial}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
                            vself.mtdachouproduto(response, util.setfocus('#eddescproduto'));//callback para o foco
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.mtdlimparedicaoitem();
							$('#edidproduto').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
                    this.mtdlimparedicaoitem();
                    //this.mtdalteraregime();
				}
            },
            mtdachouproduto(response, callback){
                let vself = this;
                let produto = response.data[0];							
                vself.vidproduto			= produto.id;
                vself.vdescproduto 	        = produto.descricao;
                vself.vund      			= produto.und;
                vself.vvlunitario			= produto.tabelas[0].prtabela;
                vself.vidncm                = produto.idncm;
                vself.vidcest               = produto.idcest;
                vself.vorig                 = produto.origemproduto; 

                vself.vcprodanp             = produto.idanp;
                vself.vufcons               = '';
                vself.vpglp                 = produto.percglp;
                vself.vpgnn                 = produto.percgnn;
                vself.vpgni                 = produto.percgni;
                vself.vvpart                = produto.vlpartida;
                vself.vutrib                = produto.utrib;
                vself.vqtrib                = produto.qtrib;

                var defncm = new Option(produto.descncm, vself.vidncm, true, true);
                $('#cbncm').append(defncm).trigger('change'); 							

                if (vself.vidcest !== null && vself.vidcest !== ''){
                    var defcest = new Option(produto.desccest, vself.vidcest, true, true);
                    $('#cbcest').append(defcest).trigger('change');                
                }else{
                    $('#cbcest').val(null).trigger('change'); 
                }      
                
                if (vself.vcprodanp !== '' && vself.vcprodanp !== null){
                    var defanp = new Option(produto.descanp, vself.vcprodanp, true, true);
                    $('#cbanp').append(defanp).trigger('change');                
                }else{
                    $('#cbanp').val(null).trigger('change'); 
                }                
                vself.mtddefineclasse(produto.classenf[0]);                
            },
			mtdselecionarclasse(){
                let vself        = this;
                vself.lstclasses = [];
				if (this.vcoddig === ''){
					vself.$toastr.w('O item deve ser informado!', 'Informação!');
					$('#edidproduto').focus();
					return;
                }				
                let loader      = vself.$loading.show();
                let filtro      = '';
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 99999999999},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstclasses = response.data;
                    $('#mdselecionarclasse').modal('show');
                }).catch(function (response) {
                    loader.hide();
                });                				
            },
            mtddefineclasse(classe){
                console.log('definir classe');
                let vself = this;
                vself.lstcamposicms       = [];
                vself.vidcfop             = classe.idcfop;
                vself.vregime             = classe.regime;
                vself.mtdalteraregime();
                vself.vcst                = classe.cst; 
                vself.vcstpiscofins       = classe.cstpiscofins;
                vself.vcstipi             = classe.cstipi;                              
                vself.vppis               = classe.ppis;
                vself.vppisst             = classe.ppisst;
                vself.vpcofins            = classe.pcofins;
                vself.vpcofinsst          = classe.pcofinsst;
                vself.vpipi               = classe.pipi;
                vself.vcenq               = classe.cenq;
                ///partilha de icms
                //vself.vbcufdest           = classe.vbcufdest;


                if (parseFloat(classe.vpfcpufdedt) > 0 ||
                    parseFloat(classe.vpicmsufdest) > 0 ||
                    parseFloat(classe.vpicmsinter) > 0 ||
                    parseFloat(classe.vpimsinterpart) > 0) {
                    

                    vself.vbcufdest           = vself.vvltotal;
                    vself.vpfcpufdedt         = parseFloat(classe.vpfcpufdedt);  
                    vself.vpicmsufdest        = parseFloat(classe.vpicmsufdest);
                    vself.vpicmsinter         = classe.vpicmsinter;
                    vself.vpimsinterpart      = classe.vpimsinterpart;
                    vself.vfcpufdest          = classe.vfcpufdest;
                    vself.vicmsufdest         = classe.vicmsufdest;
                    vself.vicmsufremet        = classe.vicmsufremet;

                    vself.calcularICMSinter();

                }
                          

                // refoma tributária 2026
                vself.vcClassTrib         = classe.classtrib;
                vself.vCstIBSCBS            = classe.cstcbs;
                vself.vCstIBSCBSold         = classe.cstcbs;
                if(vself.vcClassTrib != ''){
                    vself.SelecionarcClassTribIBSCBS('cClassTrib', classe.cstcbs);
                }


                // Precisei fazer essa "gambiarra", pois na listagem vinda do cadprodutos, ele não trazia os campos da forma que eu esperava e não tenho tempo para ajustar isso agora.
                // Na próxima refatoração, ajustar isso na PAINEL DE produtos. Rodrigo 28-12-25 (Prazo 01-01-26)
                // IBS
                vself.vAliqIBSUF          = classe.gIBSUF_pIBSUF ?? parseFloat(classe.pIBSUF);
                vself.vAliqRedIBSUF       = classe.gIBSUF_pRed ?? parseFloat(classe.pRedIBSUF);
                vself.vAliqDifIBSUF       = classe.gIBSUF_pDif ?? parseFloat(classe.pDifIBSUF);
                vself.vAliqIBSMun         = classe.gIBSMun_pIBSMun ?? parseFloat(classe.pIBSMun);
                vself.vAliqRedIBSMun      = classe.gIBSMun_pRed ?? parseFloat(classe.pRedIBSMun);
                vself.vAliqDifIBSMun      = classe.gIBSMun_pDif ?? parseFloat(classe.pDifIBSMun);

                // CBS
                vself.vAliqCBS             = classe.gCBS_pCBS ?? parseFloat(classe.pCBS);
                vself.vAliqRedCBS          = classe.gCBS_pRed ?? parseFloat(classe.pRedCBS);
                vself.vAliqDifCBS          = classe.gCBS_pDif ?? parseFloat(classe.pDifCBS);

                // Tributação Regular 
                vself.vCstIBSCBSReg        = classe.cstreg; 
                vself.vcClassTribReg       = classe.classtribreg; 
                if( vself.vcClassTribReg !== ''){
                    vself.SelecionarcClassTribIBSCBSReg('cClassTrib', classe.classtribreg); 
                }   
                vself.pAliqEfetIBSUFReg    = parseFloat(classe.pAliqEfetIBSUFReg);
                vself.pAliqEfetIBSMunReg   = parseFloat(classe.pAliqEfetIBSMunReg);
                vself.pAliqEfetCBSReg      = parseFloat(classe.pAliqEfetCBSReg);

                // Tributação Monofásica
                    // Normal
                vself.vAliqAdRemIBS        = parseFloat(classe.pAdRemIBSMono);
                vself.vAliqAdRemCBS        = parseFloat(classe.pAdRemCBSMono);
                    // Sujeita a retenção
                vself.vAliqAdRemIBSReten   = parseFloat(classe.pAdRemIBSRetenMono);
                vself.vAliqAdRemCBSReten   = parseFloat(classe.pAdRemCBSRetenMono);
                    // Retida anteriormente
                vself.vAliqAdRemIBSRet     = parseFloat(classe.pAdRemIBSRetMono);
                vself.vAliqAdRemCBSRet     = parseFloat(classe.pAdRemCBSRetMono);
                    // Diferimento
                vself.vAliqDifIBSMono      = parseFloat(classe.pDifIBSMono);
                vself.vAliqDifCBSMono      = parseFloat(classe.pDifCBSMono);
                // Crédito Presumido
                vself.swCredPresumido      = (classe.credPresOper == 1) ? true : false;
                vself.vcCredPres           = classe.cCredPres;
                vself.vpCredPresIBS        = parseFloat(classe.pCredPresIBS);
                vself.vpCredPresCBS        = parseFloat(classe.pCredPresCBS);

                // Transf Crédito   
                vself.vIBSTransfCred       = 0;
                vself.vCBSTransfCred       = 0;

                // Compra Governamental
                vself.swCompraGov          = (classe.compraGov == 1) ? true : false; 
                vself.vTpEnteGov           = classe.tpEnteGov; 
                vself.vAliqRedutorGov      = parseFloat(classe.pRedutorGov); 
                vself.vTpOperGov           = classe.tpOperGov;
                vself.vpAliqIBSUFGov       = parseFloat(classe.pAliqIBSUFGov); 
                vself.vpAliqIBSMunGov      = parseFloat(classe.pAliqIBSMunGov); 
                vself.vpAliqCBSGov         = parseFloat(classe.pAliqCBSGov); 

                // A FAZER
                // ZFM 
                vself.tpCredPresIBSZFM     = classe.tpCredPresIBSZFM;

                // A FAZER
                // IS
                vself.vcstis               = classe.cstis;    
                vself.vpis                 = classe.pis;
                vself.vpisesp              = classe.pisesp;


                var defcfop = new Option(classe.desccfop, vself.vidcfop, true, true);
                $('#cbcfop').append(defcfop).trigger('change'); 

                vself.lstcamposcbs         = classe.camposibscbs ? classe.camposibscbs : (classe.lstcamposcbs ? classe.lstcamposcbs : []);

                setTimeout(function(){
                    vself.lstcamposicms       = classe.lstcampos;
                 
                    let qtd = vself.vqtditem;
                    vself.vqtditem = 0;
                    vself.vqtditem = qtd;
                    vself.mtdcalculatotalitem();
                }, 500);
                $('#mdselecionarclasse').modal('hide');
            },
            mtdgravaritem(){
                console.log('grava item');
                let vself = this;
				if (vself.vcoddig === ''){
					vself.$toastr.w('Código do produto deve ser informado!', 'Atenção!');
					$('#edidproduto').focus();
					return;
                }
				if (vself.vdescproduto === ''){
					vself.$toastr.w('Descrição do produto deve ser informada!', 'Atenção!');
					$('#eddescproduto').focus();
					return;
                }
				if (vself.vund === ''){
					vself.$toastr.w('Unidade do produto deve ser informada!', 'Atenção!');
					$('#edund').focus();
					return;
				}
				if (parseFloat(vself.vqtditem) < 0){
					vself.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditem').focus();
					return;
				}
				if (parseFloat(vself.vvlunitario) < 0){
					vself.$toastr.w('Valor do produto deve ser informado!', 'Atenção!');
					$('#edvlunitario').focus();
					return;
                }
                if (vself.vidncm === null || vself.vidncm === ''){
					vself.$toastr.w('NCM do produto deve ser informado!', 'Atenção!');
					$('#cbncm').select2('open');
					return;
                }
                if (vself.vidcfop === null || vself.vidcfop === ''){
					vself.$toastr.w('CFOP deve ser informado!', 'Atenção!');
					$('#cbcfop').select2('open');
					return;
				} 
                if (vself.vcst === null || vself.vcst === ''){
					vself.$toastr.w(parseInt(vself.vregime) === 0 ? 'Código da situação tributária deve ser informado!' : 'CSOSN deve ser informado!', 'Atenção!');
                    $('.nav-tabs a[href="#dvicms"]').tab('show');
					$('#cbcst').focus();
					return;
				}                          
                if (vself.vcstpiscofins === null || vself.vcstpiscofins === ''){
					vself.$toastr.w('CST do PIS/COFINS deve ser informado!', 'Atenção!');
                    $('.nav-tabs a[href="#dvpiscofins"]').tab('show');
					$('#cbcstpiscofins').focus();
					return;
				}   
                if (vself.vcstipi === null || vself.vcstipi === ''){
					vself.$toastr.w('CST do IPI deve ser informado!', 'Atenção!');
                    $('.nav-tabs a[href="#dvipi"]').tab('show');
					$('#cbcstipi').focus();
					return;
				}   
                if (vself.vcstipi === null || vself.vcstipi === ''){
					vself.$toastr.w('CST do IPI deve ser informado!', 'Atenção!');
                    $('.nav-tabs a[href="#dvipi"]').tab('show');
					$('#cbcstipi').focus();
					return;
				}   
                if (vself.vnrdeclaracao !== '' && vself.lstdeclaracaoimp.length === 0){
                   
                    vself.$toastr.w('Informações da importação devem ser informadas!', 'Atenção!');
                    $('.nav-tabs a[href="#dvimportacao"]').tab('show');
                    return;                        
                    
                }                                                                           
				if (parseInt(vself.vopitem) === 1){
					if (util.findValInArray(vself.lstitensnf, 'idproduto', vself.vidproduto)){
						// vself.$toastr.w('Item já lançado na nota!', 'Atenção!');
						// $('#edidproduto').focus();
                        // return;
                        $.confirm({
                            title: 'Confirmação!',
                            content: 'O ítem já está incluso na nota. Deseja continuar e adicioná-lo novamente?',
                            icon: 'fa fa-question-circle',
                            escapeKey: true,
                            backgroundDismiss: false,
                            escapeKey: 'nao',
                            type: 'dark',
                            typeAnimated: true,
                            buttons: {
                                sim: {
                                    text: '<u>S</u>im',
                                    keys: ['s', 'S'],
                                    btnClass: 'btn-blue',
                                    action: function () {  
                                        vself.vitem++; 
                                        let descncm = $('#cbncm').select2('data')[0]['text'];
                                        let desccfop= $('#cbcfop').select2('data')[0]['text'];
                                        let descanp = vself.vcprodanp !== null && vself.vcprodanp !== '' ? $('#cbanp').select2('data')[0]['text'] : '';
                                        let desccest= vself.vidcest !== null && vself.vidcest !== '' ? $('#cbcest').select2('data')[0]['text'] : ''                                        
                                        let itemtmp = {
                                            idproduto       : vself.vidproduto,
                                            item            : vself.vitem,
                                            coddig          : vself.vcoddig,
                                            descproduto     : vself.vdescproduto,
                                            und             : vself.vund,
                                            idncm           : vself.vidncm,
                                            descncm         : descncm,
                                            idcest          : vself.vidcest,
                                            desccest        : desccest,
                                            idcfop          : vself.vidcfop,
                                            desccfop        : desccfop,
                                            vlunitario      : vself.vvlunitario,
                                            qtditem         : vself.vqtditem,
                                            vldesconto      : vself.vvldesconto,
                                            vltotal         : vself.vvltotal,
                                            regime          : vself.vregime,
                                            orig            : vself.vorig,                        
                                            cst             : vself.vcst,
                                            cstpiscofins    : vself.vcstpiscofins,
                                            cstipi          : vself.vcstipi,
                                            ppis            : vself.vppis,
                                            vpis            : vself.vvpis,
                                            ppisst          : vself.vppisst,
                                            vpisst          : vself.vvpisst,
                                            pcofins         : vself.vpcofins,
                                            vcofins         : vself.vvcofins,
                                            pcofinsst       : vself.vpcofinsst,
                                            vcofinsst       : vself.vvcofinsst,
                                            pipi            : vself.vpipi,
                                            vipi            : vself.vvipi,
                                            cenq            : vself.vcenq,
                                            vtottrib        : util.arredondaValores(parseFloat(vself.valiquotaibpt) * parseFloat(vself.vvltotal) / 100, 2, 'round'),//verificar a possibilidade de geração do campo somente na geração do xml
                                            vfrete          : vself.vvfrete,
                                            vseg            : vself.vvseg,

                                            ///partilha de icms
                                            vbcufdest       : vself.vbcufdest,
                                            vpfcpufdedt     : vself.vpfcpufdedt,
                                            vpicmsufdest    : vself.vpicmsufdest,
                                            vpicmsinter     : vself.vpicmsinter,
                                            vpimsinterpart  : vself.vpimsinterpart,
                                            vfcpufdest      : vself.vfcpufdest,
                                            vicmsufdest     : vself.vicmsufdest,
                                            vicmsufremet    : vself.vicmsufremet,
                                            ////////////////////////////////////////////                                            

                                            voutro          : vself.vvoutro,
                                            infadprod       : vself.vinfadprod,
                                            xped            : vself.vxped,
                                            nitemped        : vself.vnitemped,
                                            utrib           : vself.vutrib,
                                            qtrib           : vself.vqtrib,
                                            //combustível
                                            cprodanp        : vself.vcprodanp === null ? '' : vself.vcprodanp, 
                                            descanp         : descanp,
                                            ufcons          : vself.vufcons, 
                                            pglp            : vself.vpglp, 
                                            pgnn            : vself.vpgnn, 
                                            pgni            : vself.vpgni, 
                                            vpart           : vself.vvpart,
                                            cuforig         : vself.vcuforig,
                                            indimport       : vself.vindimport,
                                            porig           : vself.vporig,

                                            declaracoesimport : vself.lstdeclaracaoimp,
                                            //////////
                                            campos              : vself.lstcamposicms,
                                            
                                            camposibscbs        : vself.lstcamposcbs,
                                            
                                            // Reforma Tributária 2026
                                            classtrib           : vself.vcClassTrib,
                                            cstcbs              : vself.vCstIBSCBS,
                                            cstcbsold           : vself.vCstIBSCBSold,

                                            // IBS
                                            gIBSUF_pIBSUF       : vself.vAliqIBSUF,
                                            gIBSUF_pRed         : vself.vAliqRedIBSUF,
                                            gIBSUF_pDif         : vself.vAliqDifIBSUF,
                                            gIBSMun_pIBSMun     : vself.vAliqIBSMun,
                                            gIBSMun_pRed        : vself.vAliqRedIBSMun,
                                            gIBSMun_pDif        : vself.vAliqDifIBSMun,

                                            // CBS
                                            gCBS_pCBS           : vself.vAliqCBS,
                                            gCBS_pRed           : vself.vAliqRedCBS,
                                            gCBS_pDif           : vself.vAliqDifCBS,

                                            // Tributação Regular
                                            cstreg              : vself.vCstIBSCBSReg,
                                            classtribreg        : vself.vcClassTribReg,
                                            pAliqEfetIBSUFReg   : vself.pAliqEfetIBSUFReg,
                                            pAliqEfetIBSMunReg  : vself.pAliqEfetIBSMunReg,
                                            pAliqEfetCBSReg     : vself.pAliqEfetCBSReg,

                                            // Tributação Monofásica
                                                // Normal
                                            pAdRemIBSMono       : vself.vAliqAdRemIBS,
                                            pAdRemCBSMono       : vself.vAliqAdRemCBS,
                                                // Sujeita a retenção
                                            pAdRemIBSRetenMono  : vself.vAliqAdRemIBSReten,
                                            pAdRemCBSRetenMono  : vself.vAliqAdRemCBSReten,
                                                // Retida anteriormente
                                            pAdRemIBSRetMono    : vself.vAliqAdRemIBSRet,
                                            pAdRemCBSRetMono    : vself.vAliqAdRemCBSRet,
                                                // Diferimento
                                            pDifIBSMono         : vself.vAliqDifIBSMono,
                                            pDifCBSMono         : vself.vAliqDifCBSMono,

                                            // Crédito Presumido
                                            credPresOper        : vself.swCredPresumido ? 1 : 0,
                                            cCredPres           : vself.vcCredPres,
                                            pCredPresIBS        : vself.vpCredPresIBS,
                                            pCredPresCBS        : vself.vpCredPresCBS,

                                            // Transf Crédito
                                            vIBSTransfCred      : vself.vIBSTransfCred,
                                            vCBSTransfCred      : vself.vCBSTransfCred,

                                            // Compra Governamental
                                            compraGov           : vself.swCompraGov ? 1 : 0,
                                            tpEnteGov           : vself.vTpEnteGov,
                                            pRedutorGov         : vself.vAliqRedutorGov,
                                            tpOperGov           : vself.vTpOperGov,
                                            pAliqIBSUFGov       : vself.vpAliqIBSUFGov,
                                            pAliqIBSMunGov      : vself.vpAliqIBSMunGov,
                                            pAliqCBSGov         : vself.vpAliqCBSGov,

                                            // ZFM
                                            tpCredPresIBSZFM    : vself.tpCredPresIBSZFM,

                                            // IS
                                            cstis               : vself.vcstis,
                                            pis                 : vself.vpis,
                                            vvis                : vself.vvis,
                                            pisesp              : vself.vpisesp,
                                        };
                                        vself.lstitensnf.push(itemtmp);
                                        vself.mtdlimparedicaoitem();
                                        vself.atribuilistacst(vself.mtdselecionarcamposgrupofiscal);
                                        $('#edidproduto').focus();
                                        vself.mtdtotalizarnota();                                                                        
                                    },
                                },
                                nao: {
                                    text: '<u>N</u>ão',
                                    keys: ['n', 'N'],
                                    action: function () {
                                        $('#edqtditem').focus();
                                    }
                                }
                            }
                        });                                
                    }else{
                        vself.vitem++; 
                        let descncm = $('#cbncm').select2('data')[0]['text'];
                        let desccfop= $('#cbcfop').select2('data')[0]['text'];
                        let descanp= vself.vcprodanp !== null && vself.vcprodanp !== '' ? $('#cbanp').select2('data')[0]['text'] : '';
                        let desccest= vself.vidcest !== null && vself.vidcest !== '' ? $('#cbcest').select2('data')[0]['text'] : ''
                        let itemtmp = {
                            idproduto       : vself.vidproduto,
                            item            : vself.vitem,
                            coddig          : vself.vcoddig,
                            descproduto     : vself.vdescproduto,
                            und             : vself.vund,
                            idncm           : vself.vidncm,
                            descncm         : descncm,
                            idcest          : vself.vidcest,
                            desccest        : desccest,
                            idcfop          : vself.vidcfop,
                            desccfop        : desccfop,
                            vlunitario      : vself.vvlunitario,
                            qtditem         : vself.vqtditem,
                            vldesconto      : vself.vvldesconto,
                            vltotal         : vself.vvltotal,
                            regime          : vself.vregime,
                            orig            : vself.vorig,                        
                            cst             : vself.vcst,
                            cstpiscofins    : vself.vcstpiscofins,
                            cstipi          : vself.vcstipi,
                            ppis            : vself.vppis,
                            vpis            : vself.vvpis,
                            ppisst          : vself.vppisst,
                            vpisst          : vself.vvpisst,
                            pcofins         : vself.vpcofins,
                            vcofins         : vself.vvcofins,
                            pcofinsst       : vself.vpcofinsst,
                            vcofinsst       : vself.vvcofinsst,
                            pipi            : vself.vpipi,
                            vipi            : vself.vvipi,
                            cenq            : vself.vcenq,
                            // vtottrib        : util.arredondaValores(parseFloat(vself.valiquotaibpt) * parseFloat(vself.vvltotal) / 100, 2, 'round'),//verificar a possibilidade de geração do campo somente na geração do xmlm
                            vtottrib_calculado: util.arredondaValores(parseFloat(vself.valiquotaibpt) * parseFloat(vself.vvltotal) / 100, 2, 'round'),

                            vtottrib        : (parseInt(vself.vcalctrib) === 1) ? util.arredondaValores(parseFloat(vself.valiquotaibpt) * parseFloat(vself.vvltotal) / 100, 2, 'round') : 0,
                            vfrete          : vself.vvfrete,
                            vseg            : vself.vvseg,
                            ///partilha de icms
                            vbcufdest       : vself.vbcufdest,
                            vpfcpufdedt     : vself.vpfcpufdedt,
                            vpicmsufdest    : vself.vpicmsufdest,
                            vpicmsinter     : vself.vpicmsinter,
                            vpimsinterpart  : vself.vpimsinterpart,
                            vfcpufdest      : vself.vfcpufdest,
                            vicmsufdest     : vself.vicmsufdest,
                            vicmsufremet    : vself.vicmsufremet,
                            ////////////////////////////////////////////
                            voutro          : vself.vvoutro,
                            infadprod       : vself.vinfadprod,
                            xped            : vself.vxped,
                            nitemped        : vself.vnitemped,
                            //combustível
                            cprodanp        : vself.vcprodanp === null ? '' : vself.vcprodanp, 
                            descanp         : descanp,
                            ufcons          : vself.vufcons, 
                            pglp            : vself.vpglp, 
                            pgnn            : vself.vpgnn, 
                            pgni            : vself.vpgni, 
                            vpart           : vself.vvpart,

                            cuforig         : vself.vcuforig,
                            indimport       : vself.vindimport,
                            porig           : vself.vporig,

                            utrib           : vself.vutrib,
                            qtrib           : vself.vqtrib,

                            declaracoesimport : vself.lstdeclaracaoimp,

                            campos          : vself.lstcamposicms,
                            
                            
                            camposibscbs        : vself.lstcamposcbs,
                                            
                            classtrib           : vself.vclasstrib,
                            cstcbs              : vself.vcstcbs,
                            cstcbsold           : vself.vcstcbsold,
                    

                            // campos tributação Regular
                            cstreg              : vself.vcstreg,
                            classtribreg        : vself.vclasstribreg,
                            pAliqEfetRegIBSUF   : vself.vpAliqEfetRegIBSUF,
                            vTribRegIBSUF       : vself.vTribRegIBSUF,
                            pAliqEfetRegIBSMun  : vself.vpAliqEfetRegIBSMun,
                            vTribRegIBSMun      : vself.vTribRegIBSMun, 
                            pAliqEfetRegCBS     : vself.vpAliqEfetRegCBS,
                            vTribRegCBS         : vself.vTribRegCBS,

                            // IBS
                            cstcredpresumidoIBS : vself.vcstcredpresumidoIBS,
                            pCredPresIBS        : vself.vpCredPresIBS,
                            vCredPresIBS        : vself.vvCredPresIBS,
                            CredPresCondSuspIBS : vself.vCredPresCondSuspIBS,

                            // CBS 
                            cstcredpresumidoCBS : vself.vcstcredpresumidoCBS,
                            pCredPresCBS        : vself.vpCredPresCBS,
                            vCredPresCBS        : vself.vvCredPresCBS,
                            CredPresCondSuspCBS : vself.vCredPresCondSuspCBS,

                            // Transf Crédito
                            vIBSTransfCred      : vself.vIBSTransfCred,
                            vCBSTransfCred      : vself.vCBSTransfCred,

                            // IS
                            cstis               : vself.vcstis,
                            pis                 : vself.vpis,
                            vvis                : vself.vvis,
                            pisesp              : vself.vpisesp,

                            // ZFM
                            tpCredPresIBSZFM    : vself.tpCredPresIBSZFM,

                            // Compra Governamental
                            pAliqIBSUFGov       : vself.vpAliqIBSUFGov,
                            vTribIBSUFGov       : vself.vTribIBSUFGov,
                            pAliqIBSMunGov      : vself.vpAliqIBSMunGov,
                            vTribIBSMunGov      : vself.vTribIBSMunGov,
                            pAliqCBS            : vself.vpAliqCBS,
                            vTribCBS            : vself.vTribCBS

                        };
                        vself.lstitensnf.push(itemtmp);                        
                        vself.mtdlimparedicaoitem();
                        vself.atribuilistacst(vself.mtdselecionarcamposgrupofiscal);
                        $('#edidproduto').focus();
                        vself.mtdtotalizarnota();
                    }                   
                }else{
                    let i 		    = util.getArrayIndexForKey(this.lstitensnf, 'item', vself.vitemalt);
                    this.lstitensnf[i].descproduto     = vself.vdescproduto;
                    this.lstitensnf[i].und             = vself.vund;
                    this.lstitensnf[i].idncm           = vself.vidncm;
                    this.lstitensnf[i].descncm         = $('#cbncm').select2('data')[0]['text'];
                    this.lstitensnf[i].idcest          = vself.vidcest;
                    this.lstitensnf[i].desccest        = vself.vidcest !== null ? $('#cbcest').select2('data')[0]['text'] : '';
                    this.lstitensnf[i].idcfop          = vself.vidcfop;
                    this.lstitensnf[i].desccfop        = $('#cbcfop').select2('data')[0]['text'];
                    this.lstitensnf[i].vlunitario      = vself.vvlunitario;
                    this.lstitensnf[i].qtditem         = vself.vqtditem;
                    this.lstitensnf[i].vldesconto      = vself.vvldesconto;
                    this.lstitensnf[i].vltotal         = vself.vvltotal;
                    this.lstitensnf[i].regime          = vself.vregime;
                    this.lstitensnf[i].orig            = vself.vorig;
                    this.lstitensnf[i].cst             = vself.vcst;
                    this.lstitensnf[i].cstpiscofins    = vself.vcstpiscofins;
                    this.lstitensnf[i].cstipi          = vself.vcstipi;
                    this.lstitensnf[i].ppis            = vself.vppis;
                    this.lstitensnf[i].vpis            = vself.vvpis;
                    this.lstitensnf[i].ppisst          = vself.vppisst;
                    this.lstitensnf[i].vpisst          = vself.vvpisst;
                    this.lstitensnf[i].pcofins         = vself.vpcofins;
                    this.lstitensnf[i].vcofins         = vself.vvcofins;
                    this.lstitensnf[i].pcofinsst       = vself.vpcofinsst;
                    this.lstitensnf[i].vcofinsst       = vself.vvcofinsst;
                    this.lstitensnf[i].pipi            = vself.vpipi;
                    this.lstitensnf[i].vipi            = vself.vvipi;
                    this.lstitensnf[i].cenq            = vself.vcenq;
                    ///partilha de icms
                    this.lstitensnf[i].vbcufdest       = vself.vbcufdest;
                    this.lstitensnf[i].vpfcpufdedt     = vself.vpfcpufdedt;
                    this.lstitensnf[i].vpicmsufdest    = vself.vpicmsufdest;
                    this.lstitensnf[i].vpicmsinter     = vself.vpicmsinter;
                    this.lstitensnf[i].vpimsinterpart  = vself.vpimsinterpart;
                    this.lstitensnf[i].vfcpufdest      = vself.vfcpufdest;
                    this.lstitensnf[i].vicmsufdest     = vself.vicmsufdest;
                    this.lstitensnf[i].vicmsufremet    = vself.vicmsufremet;
                    ////////////////////////

                    // this.lstitensnf[i].vtottrib        = util.arredondaValores(parseFloat(vself.valiquotaibpt) * parseFloat(vself.vvltotal) / 100, 2, 'round');//verificar a possibilidade de geração do campo somente na geração do xml
                    let vtottrib_calculado             = util.arredondaValores(parseFloat(vself.valiquotaibpt) * parseFloat(vself.vvltotal) / 100, 2, 'round');

                    this.lstitensnf[i].vtottrib_calculado = vtottrib_calculado;

                    if (parseInt(vself.vcalctrib) === 1) {
                        this.lstitensnf[i].vtottrib = vtottrib_calculado;
                    } else {
                        this.lstitensnf[i].vtottrib = 0;
                    }

                    this.lstitensnf[i].vfrete          = vself.vvfrete;
                    this.lstitensnf[i].vseg            = vself.vvseg;
                    this.lstitensnf[i].voutro          = vself.vvoutro;
                    this.lstitensnf[i].infadprod       = vself.vinfadprod;
                    this.lstitensnf[i].xped            = vself.vxped;
                    this.lstitensnf[i].nitemped        = vself.vnitemped;
                    this.lstitensnf[i].utrib           = vself.vutrib;
                    this.lstitensnf[i].qtrib           = vself.vqtrib;
                    //combustível
                    this.lstitensnf[i].cprodanp        = vself.vcprodanp === null ? '' : vself.vcprodanp; 
                    this.lstitensnf[i].descanp         = vself.vcprodanp !== null &&  vself.vcprodanp !== '' ? $('#cbanp').select2('data')[0]['text'] : '';
                    this.lstitensnf[i].ufcons          = vself.vufcons; 
                    this.lstitensnf[i].pglp            = vself.vpglp; 
                    this.lstitensnf[i].pgnn            = vself.vpgnn; 
                    this.lstitensnf[i].pgni            = vself.vpgni; 
                    this.lstitensnf[i].vpart           = vself.vvpart;

                    this.lstitensnf[i].cuforig         = vself.vcuforig;
                    this.lstitensnf[i].indimport       = vself.vindimport;
                    this.lstitensnf[i].porig           = vself.vporig;

                    this.lstitensnf[i].declaracoesimport = vself.lstdeclaracaoimp;
                    
                    //////////

                    this.lstitensnf[i].campos          = vself.lstcamposicms;       
                    
                    


                    this.lstitensnf[i].camposibscbs        = vself.lstcamposcbs;

                    // Reforma Tributária 2026
                    this.lstitensnf[i].classtrib           = vself.vcClassTrib;
                    this.lstitensnf[i].cstcbs              = vself.vCstIBSCBS;
                    this.lstitensnf[i].cstcbsold           = vself.vCstIBSCBSold;

                    // IBS
                    this.lstitensnf[i].gIBSUF_pIBSUF       = vself.vAliqIBSUF;
                    this.lstitensnf[i].gIBSUF_pRed         = vself.vAliqRedIBSUF;
                    this.lstitensnf[i].gIBSUF_pDif         = vself.vAliqDifIBSUF;
                    this.lstitensnf[i].gIBSMun_pIBSMun     = vself.vAliqIBSMun;
                    this.lstitensnf[i].gIBSMun_pRed        = vself.vAliqRedIBSMun;
                    this.lstitensnf[i].gIBSMun_pDif        = vself.vAliqDifIBSMun;

                    // CBS
                    this.lstitensnf[i].gCBS_pCBS           = vself.vAliqCBS;
                    this.lstitensnf[i].gCBS_pRed           = vself.vAliqRedCBS;
                    this.lstitensnf[i].gCBS_pDif           = vself.vAliqDifCBS;

                    // Tributação Regular
                    this.lstitensnf[i].cstreg              = vself.vCstIBSCBSReg;
                    this.lstitensnf[i].classtribreg        = vself.vcClassTribReg;
                    this.lstitensnf[i].pAliqEfetIBSUFReg   = vself.pAliqEfetIBSUFReg;
                    this.lstitensnf[i].pAliqEfetIBSMunReg  = vself.pAliqEfetIBSMunReg;
                    this.lstitensnf[i].pAliqEfetCBSReg     = vself.pAliqEfetCBSReg;

                    // Tributação Monofásica
                        // Normal
                    this.lstitensnf[i].pAdRemIBSMono       = vself.vAliqAdRemIBS;
                    this.lstitensnf[i].pAdRemCBSMono       = vself.vAliqAdRemCBS;
                        // Sujeita a retenção
                    this.lstitensnf[i].pAdRemIBSRetenMono  = vself.vAliqAdRemIBSReten;
                    this.lstitensnf[i].pAdRemCBSRetenMono  = vself.vAliqAdRemCBSReten;
                        // Retida anteriormente
                    this.lstitensnf[i].pAdRemIBSRetMono    = vself.vAliqAdRemIBSRet;
                    this.lstitensnf[i].pAdRemCBSRetMono    = vself.vAliqAdRemCBSRet;
                        // Diferimento
                    this.lstitensnf[i].pDifIBSMono         = vself.vAliqDifIBSMono;
                    this.lstitensnf[i].pDifCBSMono         = vself.vAliqDifCBSMono;

                    // Crédito Presumido
                    this.lstitensnf[i].credPresOper        = vself.swCredPresumido ? 1 : 0;
                    this.lstitensnf[i].cCredPres           = vself.vcCredPres;
                    this.lstitensnf[i].pCredPresIBS        = vself.vpCredPresIBS;
                    this.lstitensnf[i].pCredPresCBS        = vself.vpCredPresCBS;

                    // Transf Crédito
                    this.lstitensnf[i].vIBSTransfCred      = vself.vIBSTransfCred;
                    this.lstitensnf[i].vCBSTransfCred      = vself.vCBSTransfCred;

                    // Compra Governamental
                    this.lstitensnf[i].compraGov           = vself.swCompraGov ? 1 : 0;
                    this.lstitensnf[i].tpEnteGov           = vself.vTpEnteGov;
                    this.lstitensnf[i].pRedutorGov         = vself.vAliqRedutorGov;
                    this.lstitensnf[i].tpOperGov           = vself.vTpOperGov;
                    this.lstitensnf[i].pAliqIBSUFGov       = vself.vpAliqIBSUFGov;
                    this.lstitensnf[i].pAliqIBSMunGov      = vself.vpAliqIBSMunGov;
                    this.lstitensnf[i].pAliqCBSGov         = vself.vpAliqCBSGov;

                    // ZFM
                    this.lstitensnf[i].tpCredPresIBSZFM    = vself.tpCredPresIBSZFM;

                    // IS
                    this.lstitensnf[i].cstis               = vself.vcstis;
                    this.lstitensnf[i].pis                 = vself.vpis;
                    this.lstitensnf[i].vvis                = vself.vvis;
                    this.lstitensnf[i].pisesp              = vself.vpisesp;

                    // ZFM
                    this.lstitensnf[i].tpCredPresIBSZFM    = vself.tpCredPresIBSZFM;

                    $('#mdedicaoitem').modal('hide');                        
                    this.mtdtotalizarnota(); 
                }                
            },
            mtdalteraritem(item){                
                console.log(item);
                let vself = this;                  
                vself.vopitem             = 2;
                vself.vitemalt            = item.item;
                vself.vcoddig             = item.coddig;
                vself.vidproduto          = item.idproduto;
                vself.vdescproduto        = item.descproduto;
                vself.vund                = item.und;
                vself.vqtditem            = item.qtditem;
                vself.vvlunitario         = item.vlunitario;
                vself.vvldesconto         = item.vldesconto;
                vself.vvltotal            = item.vltotal;
                vself.vvfrete             = item.vfrete;
                vself.vvseg               = item.vseg;
                vself.vvoutro             = item.voutro;
                vself.vidncm              = item.idncm;
                vself.vidcest             = item.idcest;
                vself.vidcfop             = item.idcfop;
                vself.vorig               = item.orig;                  
                vself.vregime             = item.regime;
                //// partilha de icms 
                vself.vbcufdest           = item.vbcufdest;
                vself.vpfcpufdedt         = item.vpfcpufdedt;
                vself.vpicmsufdest        = item.vpicmsufdest;
                vself.vpicmsinter         = item.vpicmsinter;
                vself.vpimsinterpart      = item.vpimsinterpart;
                vself.vfcpufdest          = item.vfcpufdest;
                vself.vicmsufdest         = item.vicmsufdest;
                vself.vicmsufremet        = item.vicmsufremet;
                ///////////////////////////////////////////////

                if (parseInt(vself.vregime) === 0){
                    vself.lstcst = vself.cstnormal;
                }else{
                    vself.lstcst = vself.cstsimples;
                }                

                vself.vcst                = item.cst; 
                vself.vcstold             = item.cst;
                vself.vcstpiscofins       = item.cstpiscofins;
                vself.vcstipi             = item.cstipi;                              
                vself.vppis               = item.ppis;
                vself.vvpis               = item.vpis;
                vself.vppisst             = item.ppisst;
                vself.vvpisst             = item.vpisst;
                vself.vpcofins            = item.pcofins;
                vself.vvcofins            = item.vcofins;
                vself.vpcofinsst          = item.pcofinsst;
                vself.vvcofinsst          = item.vcofinsst;
                vself.vpipi               = item.pipi;
                vself.vvipi               = item.vipi;
                vself.vcenq               = item.cenq;
                vself.vinfadprod          = item.infadprod;
                vself.vxped               = item.xped;
                vself.vnitemped           = item.nitemped;     
                vself.vutrib              = item.utrib;
                vself.vqtrib              = item.qtrib;
                
                //combustível
                vself.vcprodanp           = item.cprodanp === '' && item.cprodanp === null ? null : item.cprodanp;
                vself.vufcons             = item.ufcons;
                vself.vpglp               = item.pglp;
                vself.vpgnn               = item.pgnn;
                vself.vpgni               = item.pgni;
                vself.vvpart              = item.vpart; 
                vself.vcuforig            = item.cuforig; 
                vself.vindimport          = item.indimport; 
                vself.vporig              = item.porig;   
                
                
                vself.lstdeclaracaoimp    = item.declaracoesimport;



                // Reforma Tributária 2026 - IBS/CBS - Refatorado Rodrigo 28-12-25
                vself.lstcamposcbs        = []
                vself.lstcamposcbsold     = []
                vself.lstcamposcbs        = JSON.parse(JSON.stringify(item.camposibscbs));
                vself.lstcamposcbsold     = JSON.parse(JSON.stringify(item.camposibscbs));

               
                vself.vCstIBSCBS            = item.cstcbs;
                vself.vCstIBSCBSold         = item.cstcbs;
                vself.vcClassTrib           = item.classtrib;
                if( vself.vcClassTrib !== ''){
                    vself.SelecionarcClassTribIBSCBS('cClassTrib', item.classtrib);
                }
             
                // IBS
                vself.vAliqIBSUF          = item.gIBSUF_pIBSUF;
                vself.vAliqRedIBSUF       = item.gIBSUF_pRed;
                vself.vAliqDifIBSUF       = item.gIBSUF_pDif;
                vself.vAliqIBSMun         = item.gIBSMun_pIBSMun;
                vself.vAliqRedIBSMun      = item.gIBSMun_pRed;
                vself.vAliqDifIBSMun      = item.gIBSMun_pDif;

                // CBS
                vself.vAliqCBS             = item.gCBS_pCBS;
                vself.vAliqRedCBS          = item.gCBS_pRed;
                vself.vAliqDifCBS          = item.gCBS_pDif;

                // Tributação Regular 
                vself.vCstIBSCBSReg        = item.cstreg; 
                vself.vcClassTribReg       = item.classtribreg; 
                if( vself.vcClassTribReg !== ''){
                    vself.SelecionarcClassTribIBSCBSReg('cClassTrib', item.classtribreg); 
                }
                vself.pAliqEfetIBSUFReg    = item.pAliqEfetIBSUFReg;
                vself.pAliqEfetIBSMunReg   = item.pAliqEfetIBSMunReg;
                vself.pAliqEfetCBSReg      = item.pAliqEfetCBSReg;

                // Tributação Monofásica
                        // Normal
                vself.vAliqAdRemIBS        = item.pAdRemIBSMono;
                vself.vAliqAdRemCBS        = item.pAdRemCBSMono;
                    // Sujeita a retenção
                vself.vAliqAdRemIBSReten   = item.pAdRemIBSRetenMono;
                vself.vAliqAdRemCBSReten   = item.pAdRemCBSRetenMono;
                    // Retida anteriormente
                vself.vAliqAdRemIBSRet     = item.pAdRemIBSRetMono;
                vself.vAliqAdRemCBSRet     = item.pAdRemCBSRetMono;
                    // Diferimento
                vself.vAliqDifIBSMono      = item.pDifIBSMono;
                vself.vAliqDifCBSMono      = item.pDifCBSMono;

                // Crédito Presumido
                vself.swCredPresumido      = (item.credPresOper == 1) ? true : false;
                vself.vcCredPres           = item.cCredPres;
                vself.vpCredPresIBS        = item.pCredPresIBS;
                vself.vpCredPresCBS        = item.pCredPresCBS;

                // Transf Crédito
                vself.vIBSTransfCred       = item.vIBSTransfCred;
                vself.vCBSTransfCred       = item.vCBSTransfCred;

                // Compra Governamental
                vself.swCompraGov          = (item.compraGov == 1) ? true : false; 
                vself.vTpEnteGov           = item.tpEnteGov; 
                vself.vAliqRedutorGov      = item.pRedutorGov; 
                vself.vTpOperGov           = item.tpOperGov;
                vself.vpAliqIBSUFGov       = item.pAliqIBSUFGov; 
                vself.vpAliqIBSMunGov      = item.pAliqIBSMunGov; 
                vself.vpAliqCBSGov         = item.pAliqCBSGov; 

                // FUTURAMENTE REFATORAR
                // IS
                vself.vcstis               = item.cstis;
                vself.vpis                 = item.pis;
                vself.vvis                 = item.vvis;
                vself.vpisesp              = item.pisesp;

                // ZFM
                vself.tpCredPresIBSZFM     = item.tpCredPresIBSZFM;

                


                                
                var defncm  = new Option(item.descncm, vself.vidncm, true, true);
                $('#cbncm').append(defncm).trigger('change');

                if (vself.vidcest !== null){
                    var defcest  = new Option(item.desccest, vself.vidcest, true, true);
                    $('#cbcest').append(defcest).trigger('change');                
                }else{
                    $('#cbcest').val(null).trigger('change');
                }             

                var defcfop  = new Option(item.desccfop, vself.vidcfop, true, true);
                $('#cbcfop').append(defcfop).trigger('change'); 

                if (vself.vcprodanp !== null && vself.vcprodanp !== ''){
                    var defanp  = new Option(item.descanp, vself.vcprodanp, true, true);
                    $('#cbanp').append(defanp).trigger('change');                 
                }else{
                    $('#cbanp').val(null).trigger('change');
                }
                                                

            
                this.lstcamposicms       = []
                this.lstcamposicmsold    = []
                this.lstcamposicms       = JSON.parse(JSON.stringify(item.campos));
                this.lstcamposicmsold    = JSON.parse(JSON.stringify(item.campos)); 
               
      

                $('.nav-tabs a[href="#dvicms"]').tab('show');

                $('#mdedicaoitem').modal('show');
            },
            mtdexcluiritem(item){
                if (parseInt(this.opcrud) < 3){  
                    let indiceitem 		= util.getArrayIndexForKey(this.lstitensnf, 'item', item.item);
                    this.lstitensnf.splice(indiceitem, 1); 
                    this.mtdtotalizarnota(); 
                }              
            },
            mtdadicionarinfcpl(){                
                var vself       = this;
                if (vself.vidinfcpl !== null){    
                    let loader      = vself.$loading.show();
                    let filtro      = ' and id='+vself.vidinfcpl;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadinformacoescomplementares.php');
                    retorno.then(function (response) {
                        loader.hide();                        
                        vself.vinfcpl = vself.vinfcpl === '' ? response.data[0].conteudo : vself.vinfcpl +'\n'+ response.data[0].conteudo;
                        $('#cbinfcpl').val(null).trigger('change');
                    }).catch(function (response) {
                        loader.hide();
                    });
                }             
            },
            mtdnotasref(){
                this.vtiponfref  = 0;
                this.vchavenfref = '';
                $('#mdnotaref').modal('show');
            },
            mtdadicionarnotaref(){                
                if (this.vchavenfref === ''){
                    this.$toastr.w('Chave de acesso deve ser informada!', 'Atenção!');
                    util.setfocus('#edchavenfref');
                    return;                    
                }

                this.vchavenfref = this.vchavenfref.replace(/[^\d]+/g,'');

                if (this.vchavenfref.length < 44){
                    this.$toastr.w('Chave de acesso deve ter 44 caracteres!', 'Atenção!');
                    util.setfocus('#edchavenfref');
                    return;                    
                }                
                if (util.findValInArray(this.lstnotasref, 'chave', this.vchavenfref)){
                    this.$toastr.w('Chave já lançada na nota!', 'Atenção!');
                    $('#edchavenfref').focus();
                    return;
                }                
                let nfreftmp = {
                    tipo : this.vtiponfref,
                    chave:  this.vchavenfref.replace(/[^\d]+/g,'')
                };
                this.lstnotasref.push(nfreftmp);
                $('#mdnotaref').modal('hide'); 
            },
            mtddeletarnotaref(index){
                this.lstnotasref.splice(index, 1);
            },
            mtdincluirparcelacobranca(){
                this.vdvenc  = util.DataAtual(true);
                this.vvdup   = 0;
                $('#mdcobranca').modal('show');
            },
            mtdgravarparcela(){
                if (this.vdvenc === null){
                    this.$toastr.w('Data de vencimento deve ser informada!', 'Atenção!');
                    util.setfocus('#eddvenc');
                    return;                    
                }
                if (parseFloat(this.vvdup) <= 0){
                    this.$toastr.w('Valor da parcela inválido!', 'Atenção!');
                    util.setfocus('#edvdup');
                    return;                    
                }
                let parcelatmp = {
                    ndup  : '',
                    dordem: new Date(util.formatardataDB (this.vdvenc)),
                    dvenc : this.vdvenc,
                    vdup  : this.vvdup
                };
                this.lstcobranca.push(parcelatmp);
                this.mtdordenarparcelas();
                $('#mdcobranca').modal('hide');
            },
            mtddeletarparcela(index){
                this.lstcobranca.splice(index, 1);
                this.mtdordenarparcelas();
            },            
            mtdordenarparcelas(){
                this.lstcobranca.sort(function(a,b) {
                    return a.dordem < b.dordem ? -1 : a.dordem > b.dordem ? 1 : 0;
                });
                this.vtotalcobranca     = 0;
                for (let i = 0; i < this.lstcobranca.length; i++) {
                    this.lstcobranca[i].ndup = i + 1;            
                    this.vtotalcobranca     = this.vtotalcobranca + parseFloat(this.lstcobranca[i].vdup);
                } 
            },
            mtdincluirformadepagamento(){
                this.vidforma       = null;
                this.vvpag          = 0;
                this.vcaut          = '';                
                $('#cbformapagamento').val(null).trigger('change');
                $('#mdformapagamento').modal('show');
            }, 
            mtdgravarformapagamento(){
                if (this.vidforma === null){
                    this.$toastr.w('Forma de pagamento deve ser informada!', 'Atenção!');
                    util.setfocus('#cbformapagamento');
                    return;                    
                }
                if (this.vvpag < 0){
                    this.$toastr.w('Valor informado é inválido!', 'Atenção!');
                    util.setfocus('#edvpag');
                    return;                    
                }                 
                if (util.findValInArray(this.lstformaspagamento, 'idforma', this.vidforma)){
                    this.$toastr.w('Forma de pagamento já lançada na nota!', 'Atenção!');
                    $('#cbformapagamento').focus();
                    return;
                }                                
                let formatmp = {
                    idforma     : this.vidforma,
                    descforma   : this.formaselecionada.descricao,
                    vpag        : this.vvpag,
                    indpag      : parseInt(this.formaselecionada.tipo) !== 1 ? 0 : 1,
                    tpag        : this.formaselecionada.indicefiscal,
                    tpintegra   : parseInt(this.formaselecionada.tef) === 0 ? 2 : 1,
                    tband       : this.formaselecionada.indicefiscalband === null ? '' : this.formaselecionada.indicefiscalband,
                    cnpj        : this.formaselecionada.cnpjband === null ? '' : this.formaselecionada.cnpjband,
                    caut        : parseInt(this.formaselecionada.tef) === 0 ? '' : this.vcaut
                };
                this.lstformaspagamento.push(formatmp);
                this.mtdtotalizaformaspagamento();
                this.mtdincluirformadepagamento();
                util.setfocus('#cbformapagamento');
            },
            mtdtotalizaformaspagamento(){
                this.vtotalformas     = 0;
                for (let i = 0; i < this.lstformaspagamento.length; i++) {
                    this.vtotalformas     = this.vtotalformas + parseFloat(this.lstformaspagamento[i].vpag);
                }                 
            },
            mtddeletarforma(index){
                let ftmp = JSON.parse(JSON.stringify(this.lstformaspagamento));

                ftmp.splice(index, 1);

                this.lstformaspagamento = JSON.parse(JSON.stringify(ftmp));

                this.mtdtotalizaformaspagamento();
            },
            mtdincluirvolumefrete(){
                this.vqvol      = 0;
                this.vesp       = '';
                this.vmarca     = '';
                this.vnvol      = '';
                this.vpesol     = 0;
                this.vpesob     = 0;
                this.lstlacres  = [];
                this.vnlacre    = '';
                $('#mdvolumefrete').modal('show');                
            },
            mtdgravarvolumefrete(){
                if (parseFloat(this.vqvol) <= 0){
                    this.$toastr.w('Quantidade de volumes deve ser informada!', 'Atenção!');
                    util.setfocus('#edqvol');
                    return;                    
                }
                if (this.vesp === ''){
                    this.$toastr.w('Espécie deve ser informada!', 'Atenção!');
                    util.setfocus('#edesp');
                    return;                    
                }
                if (this.vmarca === ''){
                    this.$toastr.w('Marca deve ser informada!', 'Atenção!');
                    util.setfocus('#edmarca');
                    return;                    
                }
                if (this.vnvol === ''){
                    this.$toastr.w('Numeração dos volumes deve ser informada!', 'Atenção!');
                    util.setfocus('#ednvol');
                    return;                    
                }                
                if (parseFloat(this.vpesol) <= 0){
                    this.$toastr.w('Peso líquido inválido!', 'Atenção!');
                    util.setfocus('#edpesol');
                    return;                    
                }
                if (parseFloat(this.vpesob) <= 0){
                    this.$toastr.w('Peso bruto inválido', 'Atenção!');
                    util.setfocus('#edpesob');
                    return;                    
                }                                
                if (this.lstlacres.length === 0){
                    this.$toastr.w('Ao menos um lacre deve ser informado!', 'Atenção!');
                    util.setfocus('#ednlacre');
                    return; 
                }                
                let volumetmp = {
                    item    : 1,
                    qvol    : this.vnvol,
                    esp     : this.vesp,
                    marca   : this.vmarca,
                    nvol    : this.vnvol,
                    pesol   : this.vpesol,
                    pesob   : this.vpesob,
                    lacres  : this.lstlacres
                };
                this.lstvolumes.push(volumetmp);
                this.mtdordenarvolumes();
                $('#mdvolumefrete').modal('hide');
            },
            mtddeletarvolume(index){
                this.lstvolumes.splice(index, 1);
                this.mtdordenarvolumes();
            },            
            mtdordenarvolumes(){
                this.lstvolumes.sort(function(a,b) {
                    return a.item < b.item ? -1 : a.item > b.item ? 1 : 0;
                });
                for (let i = 0; i < this.lstvolumes.length; i++) {
                    this.lstvolumes[i].item = i + 1;            
                } 
            },
            mtdincluirlacre(){
                if (this.vnlacre === ''){
                    this.$toastr.w('Número do lacre deve ser informado!', 'Atenção!');
                    util.setfocus('#ednlacre');
                    return;                    
                }
                if (util.findValInArray(this.lstlacres, 'nlacre', this.vnlacre)){
                    this.$toastr.w('Número do lacre já lançado para o volume!', 'Atenção!');
                    $('#ednlacre').focus();
                    return;
                }                                
                let lacretmp = {
                    nlacre     : this.vnlacre
                };
                this.lstlacres.push(lacretmp);
                this.vnlacre = '';
                $('#ednlacre').focus();
            },
            mtddeletarlacre(index){
                this.lstlacres.splice(index, 1);
            },
            mtdtotalizarnota(){
                this.tbc 			    = 0; this.ticms 		             = 0;
                this.ticmsdeson 	    = 0; this.tfcp 			             = 0;
                this.tbcst 		        = 0; this.tst 			             = 0;
                this.tfcpst 		    = 0; this.tfcpstret 	             = 0;
                this.tprod 		        = 0; this.tfrete 		             = 0;
                this.tseg 			    = 0; this.tdesc 		             = 0;
                this.tii 			    = 0; this.tipi 			             = 0;
                this.tipidevol 	        = 0; this.tpis 			             = 0;
                this.tcofins 		    = 0; this.toutro 		             = 0;
                this.tnf 			    = 0; this.ttottrib 		             = 0;    
                this.tnf 			    = 0;     
                this.totcbs             = 0; this.totibsmun                  = 0; 
                this.totibs             = 0; this.totis                      = 0;      
                this.totibsuf           = 0;       

                for (let i = 0; i < this.lstitensnf.length; i++) {
                    for (let campo of this.lstitensnf[i].campos) {
                        if (campo.idcampo === 'vBC'){
                            this.tbc = this.tbc + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vICMS'){
                            this.ticms = this.ticms + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vBCST'){
                            this.tbcst = this.tbcst + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vICMSST'){
                            this.tst = this.tst + parseFloat(campo.valor);
                        }
                        // if (campo.idcampo === 'vII'){ //parece que esse campo não é de ICMS mas tem uma tag propia tipo o IPI
                        //     this.tii = this.tii + parseFloat(campo.valor);
                        // }
                        if (campo.idcampo === 'vICMSDeson'){
                            this.ticmsdeson = this.ticmsdeson + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vFCP'){
                            this.tfcp = this.tfcp + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vFCPST'){
                            this.tfcpst = this.tfcpst + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vFCPSTRet'){
                            this.tfcpstret = this.tfcpstret + parseFloat(campo.valor);
                        }
                    }    
                    for (let index = 0; index < this.lstitensnf[i].declaracoesimport.length; index++) {
                        this.tii = this.tii + parseFloat(this.lstitensnf[i].declaracoesimport[index].vii);
                    }   
                    //ibs cbs
                    for (let campo of this.lstitensnf[i].camposibscbs){
                        if (campo.idcampo === 'gCBS_vCBS'){
                            this.totcbs = this.totcbs + parseFloat(campo.valor);
                        }

                        if (campo.idcampo === 'gIBSMun_vIBSMun'){
                            this.totibsmun = this.totibsmun + parseFloat(campo.valor);
                        }

                        if (campo.idcampo === 'gIBSUF_vIBSUF'){
                            this.totibsuf = this.totibsuf + parseFloat(campo.valor);
                        }
                    }
                        

                    this.tprod      = this.tprod    + this.lstitensnf[i].vltotal + this.lstitensnf[i].vldesconto;                                       
                    this.tipi       = this.tipi     + util.arredondaValores(parseFloat(this.lstitensnf[i].vipi), 2, 'round');
                    this.tpis       = this.tpis     + util.arredondaValores(parseFloat(this.lstitensnf[i].vpis), 2, 'round');
                    this.tcofins    = this.tcofins  + util.arredondaValores(parseFloat(this.lstitensnf[i].vcofins), 2, 'round');
                    this.toutro     = this.toutro   + util.arredondaValores(parseFloat(this.lstitensnf[i].voutro), 2, 'round');
                    this.tfrete     = this.tfrete   + util.arredondaValores(parseFloat(this.lstitensnf[i].vfrete), 2, 'round');
                    this.tseg       = this.tseg     + util.arredondaValores(parseFloat(this.lstitensnf[i].vseg), 2, 'round');
                    this.totis      = this.totis    + util.arredondaValores(parseFloat(this.lstitensnf[i].vvis), 2, 'round');

                    this.totibs     = this.totibsmun + this.totibsuf;

                    this.tdesc      = this.tdesc    + this.lstitensnf[i].vldesconto;

                    this.tnf        = this.tprod - this.tdesc + this.tst + this.tfrete + this.tseg + this.toutro + this.tii + this.tipi - this.ticmsdeson;
                        
                    this.ttottrib   = util.arredondaValores(parseFloat(this.ttottrib) + parseFloat(this.lstitensnf[i].vtottrib), 2, 'round');   
                }
            },

            mtdalteravalorcampoicms(campo, valor){
                for (let i = 0; i < this.lstcamposicms.length; i++) {
                    if (this.lstcamposicms[i].idcampo === campo){
                       this.lstcamposicms[i].valor = valor; 
                    }
                }
            },
            mtdpegavalorcampoicms(campo){
                let $vret = 0;
                for (let i = 0; i < this.lstcamposicms.length; i++) {
                    if (this.lstcamposicms[i].idcampo === campo){
                       $vret = this.lstcamposicms[i].valor;
                       break;
                    }
                }
                return $vret;
            },

            mtdalteravalorcampoibscbs(campo, valor){
                for (let i = 0; i < this.lstcamposcbs.length; i++) {
                    if (this.lstcamposcbs[i].idcampo === campo){
                       this.lstcamposcbs[i].valor = valor; 
                    }
                }
            },
            mtdpegavalorcampoibscbs(campo){
                let $vret = 0;
                for (let i = 0; i < this.lstcamposcbs.length; i++) {
                    if (this.lstcamposcbs[i].idcampo === campo){
                       $vret = this.lstcamposcbs[i].valor;
                       break;
                    }
                }
                return $vret;
            },


            mtdenviar(nf){
				$('#mdmenunf').modal('hide');
                //if (!util.opcaousuario('020Z.010Z.065Z', this.$store.state.perfilusuario)){
                //    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                //}else{
                    let vself  = this;
                    let loader = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'enviarnf'},
                        {parametro: 'idnf',     	valor : nf.id},
                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                        {parametro: 'codop',        valor : '020Z.010Z.065Z'}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if ($.isNumeric(response.data)){
                            vself.$toastr.s('Nota enviada com sucesso!', 'Informação!');
                        }else{
                            let tpret = response.data.substring(0,1);
                            switch (tpret) {
                                case 'I':
                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                    break;
                                case 'E': default:
                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                    break;
                            }
                        }
                        vself.psituacaopesq = 99;
                        vself.pnnf          = nf.nnf;
                        vself.pidfilial     = nf.idfilial;
                        var deffilial       = new Option(nf.fantasiafil, nf.idfilial, true, true);
                        $('#cbfilialpesq').append(deffilial).trigger('change');
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarreganotasfiscais(1, '');                            
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    });
                //}				
            },
            mtdconsultarnf(nf){
                $('#mdmenunf').modal('hide');
                if (parseInt(nf.situacaonota) === 4){
                    this.$toastr.i('Operação não permitida para NF denegada!', 'Informação!');
                    return;
                }                
                if (nf.chave === '' || nf.chave === null){
                    this.$toastr.w('Chave de acesso não disponível para consulta!', 'Informação!');
                    return;
                }
                //if (!util.opcaousuario('', this.$store.state.perfilusuario)){
                //    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                //}else{
                    let vself  = this;
                    let loader = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'consultarnf'},
                        {parametro: 'idnf',     	valor : nf.id},
                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                        {parametro: 'codop',        valor : ''}//verificar depois o perfil
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if ($.isNumeric(response.data)){
                            vself.$toastr.s('Consulta realizada com sucesso!', 'Informação!');
                        }else{
                            let tpret = response.data.substring(0,1);
                            switch (tpret) {
                                case 'I':
                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                    break;
                                case 'E': default:
                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                    break;
                            }
                        }
                        vself.psituacaopesq = 99;
                        vself.pnnf          = nf.nnf;
                        vself.pidfilial     = nf.idfilial;
                        var deffilial       = new Option(nf.fantasiafil, nf.idfilial, true, true);
                        $('#cbfilialpesq').append(deffilial).trigger('change');
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarreganotasfiscais(1, '');                            
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    });
                //}				
            },            
            mtdconfirmacaocancelamento(nf){
                let vself = this;
                if (vself.vjustcancelamento.length < 15){
                    vself.$toastr.w('Motivo do cancelamento de ter no mínimo 15 caracteres!', 'Informação!');
                    $('#txtcancelanf').focus();
                    return;
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma CANCELAMENTO da Nota Fiscal?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                setTimeout(function(){
                                    vself.mtdcancelarnf(nf);
                                }, 200);                                 
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {  
                                $('#txtcancelanf').focus();                              
                            }
                        }
                    }
                });             
            },
            mtdcancelarnf(nf){
				$('#mdmenunf').modal('hide');
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'cancelarnf'},
                    {parametro: 'idnf',     	valor : nf.id},
                    {parametro: 'xjust',     	valor : vself.vjustcancelamento},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.020Z.101Z'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Nota CANCELADA com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.psituacaopesq = 99;
                    vself.pnnf          = nf.nnf;
                    vself.pidfilial     = nf.idfilial;
                    var deffilial       = new Option(nf.fantasiafil, nf.idfilial, true, true);
                    $('#cbfilialpesq').append(deffilial).trigger('change');
                    vself.pqtd_paginas  = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarreganotasfiscais(1, '');                            
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });			
            },
            mtdimprimir(nf){
				$('#mdmenunf').modal('hide');
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirdocnfe.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idnf='+nf.id+'&docimp=danfe', '_blank');
            },
            mtdcartacorrecao(id){
                $('#mdmenunf').modal('hide');
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and nf.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
					if (parseInt(response.data.notas[0].situacaonota) !== 2){
						vself.$toastr.i('Para emissão de carta de correção a nota fiscal deve estar autorizada!', 'Informação!');
						return;
					}
                    vself.nfcartacorrecao = response.data.notas[0];
                    vself.lstcartas       = vself.nfcartacorrecao.cartascorrecao;
                    $('#mdcartacorrecao').modal('show');
                }).catch(function (response) {
                    loader.hide();
                });                              
            },
            mtdcancelaredicaocartacorrecao(){
                $('#dvedicaocarta').hide();
                $('#dvlistacartas').fadeIn(700);                                 
            },
            mtdincluircarta(){
                if (util.findValInArray(this.lstcartas, 'situacaocc', 0)){
                    this.$toastr.i('Existe uma carta de correção pendente de envio. Verifique antes de incluir outra!', 'Atenção!');
                    return;                    
                }
                if (this.lstcartas.length >= 20){
                    this.$toastr.i('A quantidade de cartas de correção para a NF selecionada, já atingiu o máximo permitido. Impossível incluir uma nova!', 'Atenção!');
                    return;
                }
                this.opcarta          = 1;  
                this.titcartacorrecao = 'INCLUSÃO DE CARTA DE CORREÇÃO';
                this.vdthremissaocarta= util.DataAtual(true);
                this.vnseqevento      = '';  
                this.vconteudocarta   = '';
                $('#dvlistacartas').hide();
                $('#dvedicaocarta').fadeIn(700);                                 
                util.setfocus('#txtconteudocarta');
            },
            mtdalterarcarta(carta){
                if (parseInt(carta.situacaocc) === 1){
                    this.$toastr.w('Carta já enviada para SEFAZ. Impossível alterar!', 'Atenção!');
                    return;
                }                 
                this.opcarta          = 2;  
                this.titcartacorrecao = 'ALTERAÇÃO DE CARTA DE CORREÇÃO';
                this.vdthremissaocarta= util.DataAtual(true);
                this.vnseqevento      = carta.nseqevento;  
                this.vconteudocarta   = carta.xcorrecao;
                $('#dvlistacartas').hide();
                $('#dvedicaocarta').fadeIn(700);                                 
                util.setfocus('#txtconteudocarta');                
            },
            mtdgravarcartacorrecao(){
                let vself = this;
                if (vself.vconteudocarta.length < 15){
                    vself.$toastr.w('O texto da carta de correção deve ter no mínimo 15 caracteres!', 'Atenção!');
                    util.setfocus('#txtconteudocarta');
                    return;
                }
                let loader  = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : parseInt(vself.opcarta) === 1 ? 'incluircc' : 'alterarcc'},
                    {parametro: 'idnotafiscal', valor : vself.nfcartacorrecao.id},
                    {parametro: 'nseqevento',   valor : vself.vnseqevento},                        
                    {parametro: 'xcorrecao', 	valor : vself.vconteudocarta},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(vself.opcarta) === 1 ? 'GERAR PERFIL INCLUSAO' : 'GERAR PERFIL ALTERACAO'},
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){
                        vself.lstcartas = response.data.cartascorrecao;
                        vself.$toastr.s('Carta processada com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
                vself.mtdcancelaredicaocartacorrecao();
            },
            mtddeletarcarta(carta){
                let vself = this;
                if (parseInt(carta.situacaocc) === 1){
                    vself.$toastr.w('Carta já enviada para SEFAZ. Impossível excluir!', 'Atenção!');
                    return;
                }                
                let loader  = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'excluircc'},
                    {parametro: 'idnotafiscal', valor : vself.nfcartacorrecao.id},
                    {parametro: 'nseqevento',   valor : carta.nseqevento},                        
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : 'GERAR PERFIL EXCLUSAO'},
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){
                        vself.lstcartas = response.data.cartascorrecao;
                        vself.$toastr.s('Carta excluída com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdenviarcarta(carta){
                let vself   = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma envio da carta de correção?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                setTimeout(function(){
                                    let loader  = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',           valor : 'enviarcc'},
                                        {parametro: 'idnotafiscal', valor : vself.nfcartacorrecao.id},
                                        {parametro: 'nseqevento',   valor : carta.nseqevento},                        
                                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',        valor : 'GERAR PERFIL ENVIO'},
                                    ];                    
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data.inf)){
                                            vself.lstcartas = response.data.cartascorrecao;
                                            vself.$toastr.s('Carta enviada com sucesso!', 'Informação!');
                                        }else{
                                            let tpret = response.data.inf.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });                                    
                                }, 200);                                
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdimprimircarta(carta){
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirdocnfe.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idnf='+this.nfcartacorrecao.id+'&sqe='+carta.nseqevento+'&docimp=cce', '_blank');
            },
            mtdinutilizacao(){
                this.iidfilial           = null;
                this.idthremissao        = util.DataAtual(true);
                this.inmodelo            = '55';
                this.inserie             = '';
                this.inini               = '';
                this.infim               = '';
                this.ixjust              = '';  
                $('#cbfilialinutilizacao').val(null).trigger('change');              
                $('#mdinutilizacao').modal('show');
            },
            mtdconfirmarinutilizacao(){
                let vself   = this;
                if (!util.opcaousuario('020Z.020Z.102Z', vself.$store.state.perfilusuario)){
                    vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    return;
                }
                if (vself.ixjust.length < 15){
                    vself.$toastr.w('O motivo da inutilização deve ter no mínimo 15 caracteres!', 'Atenção!');
                    util.setfocus('#txtmotivoinutilizacao');
                    return;
                }
                if (vself.iidfilial === null){
                    vself.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    util.setfocus('#cbfilialinutilizacao');
                    return;
                }                
                if (vself.inserie === ''){
                    vself.$toastr.w('Série deve ser informada!', 'Atenção!');
                    util.setfocus('#edserieinutilizacao');
                    return;
                }
                if (vself.inini === ''){
                    vself.$toastr.w('Número inicial deve ser informado!', 'Atenção!');
                    util.setfocus('#ednini');
                    return;
                }
                if (vself.infim === ''){
                    vself.$toastr.w('Número final deve ser informado!', 'Atenção!');
                    util.setfocus('#ednfim');
                    return;
                } 
                if (parseInt(vself.infim) - parseInt(vself.inini) > 10000){
                    vself.$toastr.w('Faixa de inutilização não pode ultrapassar 10.000!', 'Atenção!');
                    util.setfocus('#ednini');
                    return;
                }                                                              
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma inutilização da faixa informada?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                setTimeout(function(){
                                    let loader  = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',                   valor : 'inutilizar'},
                                        {parametro: 'iidfilial',            valor : vself.iidfilial},
                                        {parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'nmodelo',              valor : vself.inmodelo},
                                        {parametro: 'nserie',               valor : parseInt(vself.inserie)},
                                        {parametro: 'nini',                 valor : parseInt(vself.inini)},
                                        {parametro: 'nfim',                 valor : parseInt(vself.infim)},
                                        {parametro: 'xjust',                valor : vself.ixjust},
                                        {parametro: 'idfilial',             valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',            valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',                valor : '020Z.020Z.102Z'},
                                    ];                    
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                                    retorno.then(function (response) {
                                        loader.hide();                                        
                                        if ($.isNumeric(response.data.inf)){
                                            $('#mdinutilizacao').modal('hide');
                                            vself.$toastr.s('Inutilização enviada com sucesso!', 'Informação!');

                                            vself.psituacaopesq = 5;
                                            vself.pnnf          = '';
                                            vself.pdestinatario = '';
                                            vself.pmodelo       = 99;
                                            vself.pserie        = '';
                                            vself.pidfilial     = vself.iidfilial;
                                            vself.pfiltroperiodo= 1;
                                            vself.pdtini        = vself.idthremissao;
                                            vself.pdttim        = vself.idthremissao;
                                            var deffilial       = new Option($('#cbfilialinutilizacao').select2('data')[0]['text'], vself.pidfilial, true, true);
                                            $('#cbfilialpesq').append(deffilial).trigger('change');

                                            vself.pqtd_paginas  = 1;
                                            vself.mtdcarreganotasfiscais(1, '');                                            
                                        }else{
                                            let tpret = response.data.inf.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });                                    
                                }, 200);                                
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#cbfilialinutilizacao').focus();
                            }
                        }
                    }
                });                
            },
            mtdconsultarstatus(){
                let vself = this;
                let loader  = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor : 'consultarstatus'},
                    {parametro: 'idfilial',             valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente}
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();                                        
                    let tpret = response.data.substring(0,1);
                    switch (tpret) {
                        case 'I':
                            vself.$toastr.s(response.data.substring(4), 'Informação!');
                            break;
                        case 'E': default:
                            vself.$toastr.e(response.data.substring(4), 'Erro!');
                            break;
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdsalvarxmls(){
                let vself = this;
                let dtini = '';
                let dtfim = '';
                let filtrofil = '';
                let filtrofili = '';
                let op = '';
                let emaildestinatario = "";
                let nomeremtente = "";
                
                if (vself.venviaemail) {
                    if(vself.vemailxml == ''){
                        vself.$toastr.i('Atenção! o email deve ser informado');
                        return;
                    }
                    op = "enviarxmlsnew";
                    emaildestinatario = vself.vemailxml;
                }else{
                    op = "salvarxmlsnew";
                }


                if(this.vidfilialexport!==null){
                    filtrofil = ' and nf.idfilial= '+this.vidfilialexport+' ';
                    filtrofili = ' and i.idfilial= '+this.vidfilialexport+' ';
                }

                if(this.vespecificarperiodo){
                    dtini   = util.InverterData(vself.pdtinixml);
                    dtfim   = util.InverterData(vself.pdtfimxml);
                }else{
                   var database = new Date(parseInt(this.anoselect), parseInt(this.messelect), 10)
                   let retdatas =  util.pri_ult_diames(database, true);
                   dtini   = util.InverterData(retdatas.primeirodiames);
                   dtfim   = util.InverterData(retdatas.ultimodiames);
                }
                let periodo = ' and nf.situacaonota in (2,3,4,5) and nf.dthremissao between "' + dtini + ' 00:00:00" and "' + dtfim + ' 23:59:59" '+filtrofil;
                let periodoi = ' and i.dthremissao between "' + dtini + ' 00:00:00" and "' + dtfim + ' 23:59:59" '+filtrofili;
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Serão salvos apenas os xmls das notas em situação <span class="badge badge-primary bdg-autorizada">Autorizada</span>, '+
                                '<span class="badge badge-primary bdg-cancelada">Cancelada</span>, '+
                                '<span class="badge badge-primary bdg-denegada">Denegada</span> e as '+
                                '<span class="badge badge-primary bdg-inutilizada">Inutilizações</span>. '+
                                'Deseja mesmo continuar?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    setTimeout(function(){  
                                        let loader  = vself.$loading.show();
                                        let parametros = [];
                                        
                                        if (!vself.mtdvisualizainut()){
                                            parametros      = [
                                            {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                                            {parametro: 'op',                   valor : op},
                                            {parametro: 'filtro',               valor : periodo},
                                            {parametro: 'idfilialxml',          valor : vself.vidfilialexport == null ? '' : vself.vidfilialexport},
                                            {parametro: 'emailxml',             valor : emaildestinatario},
                                            {parametro: 'dtini',                valor : dtini},
                                            {parametro: 'dtfim',                valor : dtfim},
                                        ];
                                        }else{
                                            parametros      = [
                                            {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                                            {parametro: 'op',                   valor : op},
                                            {parametro: 'filtro',               valor : periodo},
                                            {parametro: 'filtroinutilizadas',   valor : periodoi},
                                            {parametro: 'idfilialxml',          valor : vself.vidfilialexport == null ? '' : vself.vidfilialexport},
                                            {parametro: 'emailxml',             valor : emaildestinatario},
                                            {parametro: 'dtini',                valor : dtini},
                                            {parametro: 'dtfim',                valor : dtfim},
                                        ];
                                        }
                                      
                                        
                                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                                        retorno.then(function (response) {
                                            loader.hide(); 
                                            if (response.data.inf == 1){
                                                //rotina para o download do arquivo
                                                window.open(vself.$store.state.configpaths.pathcontrole+response.data.pathdownload, '_blank');
                                                $('#mdexportxml').modal('hide');

                                            }else if(response.data.inf == 2){
                                                vself.$toastr.s("Email enviado com sucesso!");
                                                $('#mdexportxml').modal('hide');
                                            }else{      
                                                let tpret = response.data.inf.substring(0,1);
                                                switch (tpret) {
                                                    case 'I':
                                                        vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                                        break;
                                                    case 'E': 
                                                        vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                                        break;
                                                }                                                                             
                                            }
                                        }).catch(function (response) {
                                            loader.hide();
                                            vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                        });                               
                                    }, 200);                                
                                }
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                }
                            }
                        }
                    });
                            
            },
            mtdsalvarxmlindividual(idnota){
                let vself = this;
                $('#mdmenunf').modal('hide');                                
                let inutilizacoes = [];
                let notas = [];
                notas.push(idnota);                                
                if (notas.length > 0){
                    let loader  = vself.$loading.show();
                    let conteudogerar = {
                        'notas'         : notas,
                        'inutilizacoes' : inutilizacoes
                    }
                    let parametros      = [
                        {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',                   valor : 'salvarxmls'},
                        {parametro: 'conteudogerar',        valor : JSON.stringify(conteudogerar)},
                        {parametro: 'idfilial',             valor : vself.$store.state.filialpadrao.codfil}
                    ];                    
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                    retorno.then(function (response) {
                        loader.hide(); 
                        if ($.isNumeric(response.data.inf)){
                            //rotina para o download do arquivo
                            window.open(vself.$store.state.configpaths.pathcontrole+response.data.pathdownload, '_blank');
                        }else{                                                                                   
                            vself.$toastr.e(response.data.inf, 'Erro!');
                        }
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    });                               
                }                
            },
            mtdcfopparatodos(){
                if (this.lstitensnf.length > 0){
                    $('#cbcfoptodos').val(null).trigger('change');
                    $('#mdatribuircfop').modal('show');
                }
            },
            mtdatribuircfop(){
                let vself = this;
                if (vself.vidcfoptodos === null){
                   vself.$toastr.w('Informe o CFOP para atribuição!', 'Atenção!');
                   $('#cbcfoptodos').select2('open'); 
                   return;
                }
                for (let i = 0; i < vself.lstitensnf.length; i++) {
                    vself.lstitensnf[i].idcfop   = vself.vidcfoptodos;
                    vself.lstitensnf[i].desccfop = $('#cbcfoptodos').select2('data')[0]['text'];                                        
                }
                vself.$toastr.s('CFOP atribuido com sucesso!', 'Informação!');
                $('#mdatribuircfop').modal('hide');
            },
            mtdverificamudancamodelo(){
                let vself = this;
                if (parseInt(vself.opcrud) === 2){
                    if (parseInt(vself.vmodelo) !== vself.vmodelo_old){
                        vself.mtdcarregaultnf();
                    }
                }                
            },
            mtdinfemailcliente(nf){ 
                $('#mdmenunf').modal('hide');
                this.idnfemailenviar = nf.id;
                this.emailenviar     = nf.email;
                $('#mdinfemailcliente').modal('show');
            },
            mtdenviardocsnfcliente(idnf){
                let vself = this;
                if (vself.emailenviar === ''){
                    vself.$toastr.w('E-mail deve ser informado!', 'Atenção!');
                    $('#edinfemailcliente').focus();
                    return;
                }
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor : 'enviardocsnfcliente'},
                    {parametro: 'idnf',                 valor : vself.idnfemailenviar},
                    {parametro: 'emailenviar',          valor : vself.emailenviar},
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide(); 
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('E-mail enviado com sucesso!', 'Informação!');
                        $('#mdinfemailcliente').modal('hide');
                    }else{                                                                                   
                        vself.$toastr.e(response.data, 'Erro!');
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdcalculatotalitem(){    
               // return;            
                this.vvltotal   = this.vqtditem * this.vvlunitario - this.vvldesconto;                

                this.vvpis      = this.vvltotal * this.vppis / 100;

                this.vvpisst    = this.vvltotal * this.vppisst / 100;

                this.vvcofins   = this.vvltotal * this.vpcofins / 100;

                this.vvcofinsst = this.vvltotal * this.vpcofinsst / 100;

                this.vvipi      = this.vvltotal * this.vpipi / 100;


               //reforma tributaria



                // this.vtottrib   = util.arredondaValores(parseFloat(this.vvltotal) * parseFloat(this.valiquotaibpt) / 100, 2, 'round');
                let valor = util.arredondaValores(parseFloat(this.vvltotal) * parseFloat(this.valiquotaibpt) / 100, 2, 'round');

                this.vtottrib_calculado = valor;

                if (parseInt(this.vcalctrib) === 1) {
                    this.vtottrib = valor;
                } else {
                    this.vtottrib = 0;
                }

               


                let vlmvast = 0;
                let vbcst   = 0;
                let vlbcicmsst = 0;
                let pmvast  = 0;
                let vlicms	= 0; 
                let vlicmsst= 0;
                let icmsst 	= 0;
                
                let picmsst = 0;

                if (this.vutrib !== ''){
                    this.vqtrib = this.vqtditem;//atualiza a quantidade tributável igualando a qtditem                    
                }else{
                    this.vqtrib = 1;
                }

                ////icms

                if(!this.vanulacalcicms){// se na filial estiver marcado para não calcular automaticamente, ele  não fará os calculos abaixo - guga - 07/03/2025
                     for (let i = 0; i < this.lstcamposicms.length; i++) {
                        //descomentei para viabilizar o cálculo da substituição tribuitária
                        if (this.lstcamposicms[i].idcampo === 'pICMS'){
                            if (parseFloat(this.lstcamposicms[i].valor) > 0){
                                if (parseFloat(this.mtdpegavalorcampoicms('pRedBC')) === 0){//adicionei para separar o calculo da substituição
                                    this.mtdalteravalorcampoicms('vBC', this.vvltotal);
                                }
                            }
                        }
                        ////////////////////////////////////////////////////////////////////


                        // if (this.lstcamposicms[i].idcampo === 'vICMS'){
                        //     vlicms   	= parseFloat(this.mtdpegavalorcampoicms('pICMS')) * parseFloat(this.mtdpegavalorcampoicms('vBC')) / 100;
                        //     this.lstcamposicms[i].valor = vlicms;
                        // }

                        if (this.lstcamposicms[i].idcampo === 'vICMS'){
                            if (parseFloat(this.vqtditem) > 0){
                                vlicms   	= parseFloat(this.mtdpegavalorcampoicms('pICMS')) * parseFloat(this.mtdpegavalorcampoicms('vBC')) / 100;
                                this.lstcamposicms[i].valor = vlicms;
                            }
                        }                    

                        if (this.lstcamposicms[i].idcampo === 'pRedBC'){
                            if(parseFloat(this.mtdpegavalorcampoicms('pRedBC')) != 0 ){ // adicionei para resolver a redução do bcicms - by guga
                                    var predbc =  parseFloat(this.mtdpegavalorcampoicms('pRedBC')) /100
                                    var bcicms =  parseFloat(this.mtdpegavalorcampoicms('vBC'))
                                    var vlred  =  bcicms * predbc
                                    var vlbase = parseFloat(this.mtdpegavalorcampoicms('vBC')) - vlred
                                    this.mtdalteravalorcampoicms('vBC', vlbase); // guga
                            }
                        }

                        if (this.lstcamposicms[i].idcampo === 'pMVAST'){                        
                            if (parseFloat(this.lstcamposicms[i].valor) > 0){
                                pmvast 		= parseFloat(this.lstcamposicms[i].valor);
                                vlmvast  	= (parseFloat(this.vvltotal) + parseFloat(this.vvipi)) * parseFloat(pmvast) / 100;
                                picmsst     = parseFloat(this.mtdpegavalorcampoicms('pICMSST'));                            
                                vlbcicmsst  = parseFloat(this.vvltotal)   + parseFloat(this.vvipi) + vlmvast;                            
                                this.mtdalteravalorcampoicms('vBCST', vlbcicmsst);                            
                                icmsst 	    = vlbcicmsst * picmsst / 100;
                                vlicmsst	= icmsst - vlicms;
                            }
                        }

                        // if (this.lstcamposicms[i].idcampo === 'vICMSST'){
                        //     this.lstcamposicms[i].valor = parseFloat(vlicmsst);
                        // }

                        if (this.lstcamposicms[i].idcampo === 'pFCP'){
                            if (parseFloat(this.lstcamposicms[i].valor) > 0){
                                this.mtdalteravalorcampoicms('vBCFCP', this.vvltotal);
                            }
                        }
                        if (this.lstcamposicms[i].idcampo === 'vFCP'){
                            this.lstcamposicms[i].valor = parseFloat(this.mtdpegavalorcampoicms('pFCP')) * parseFloat(this.mtdpegavalorcampoicms('vBCFCP')) / 100;
                        }
                        if (this.lstcamposicms[i].idcampo === 'pFCPST'){
                            if (parseFloat(this.lstcamposicms[i].valor) > 0){
                                this.mtdalteravalorcampoicms('vBCFCPST', this.vvltotal);
                            }
                        }
                        if (this.lstcamposicms[i].idcampo === 'vFCPST'){
                            this.lstcamposicms[i].valor = parseFloat(this.mtdpegavalorcampoicms('pFCPST')) * parseFloat(this.mtdpegavalorcampoicms('vBCFCPST')) / 100;
                        }
                        if (this.lstcamposicms[i].idcampo === 'pFCPSTRet'){
                            if (parseFloat(this.lstcamposicms[i].valor) > 0){
                                this.mtdalteravalorcampoicms('vBCFCPSTRet', this.vvltotal);
                            }
                        }
                        if (this.lstcamposicms[i].idcampo === 'vFCPSTRet'){
                            this.lstcamposicms[i].valor = parseFloat(this.mtdpegavalorcampoicms('vBCFCPSTRet')) * parseFloat(this.mtdpegavalorcampoicms('vBCFCPST')) / 100;
                        }                                                                                                                        
                    } 
                }
                
                //reforma tributária
                for (let j = 0; j < this.lstcamposcbs.length; j++) {   
                    
                    if (this.lstcamposcbs[j].idcampo === 'gCBS_pCBS'){ //CBS
                        if (parseFloat(this.lstcamposcbs[j].valor) > 0){
                            
                            this.mtdalteravalorcampoibscbs('vBC', this.vvltotal);

                            let vcbs   	= parseFloat(this.mtdpegavalorcampoibscbs('gCBS_pCBS')) * parseFloat(this.mtdpegavalorcampoibscbs('vBC')) / 100;
                            this.mtdalteravalorcampoibscbs('gCBS_vCBS', vcbs);
                        }
                    }

                    if (this.lstcamposcbs[j].idcampo === 'gIBSMun_pIBSMun'){ //IBS municipal
                        if (parseFloat(this.lstcamposcbs[j].valor) > 0){
                            
                            this.mtdalteravalorcampoibscbs('vBC', this.vvltotal);

                            let vibs_mun   	= parseFloat(this.mtdpegavalorcampoibscbs('gIBSMun_pIBSMun')) * parseFloat(this.mtdpegavalorcampoibscbs('vBC')) / 100;
                            this.mtdalteravalorcampoibscbs('gIBSMun_vIBSMun', vibs_mun);
                            
                        }
                    }

                    if (this.lstcamposcbs[j].idcampo === 'gIBSUF_pIBSUF'){ //IBS estadual
                        if (parseFloat(this.lstcamposcbs[j].valor) > 0){
                            
                            this.mtdalteravalorcampoibscbs('vBC', this.vvltotal);

                            let vibs_uf   	= parseFloat(this.mtdpegavalorcampoibscbs('gIBSUF_pIBSUF')) * parseFloat(this.mtdpegavalorcampoibscbs('vBC')) / 100;
                            this.mtdalteravalorcampoibscbs('gIBSUF_vIBSUF', vibs_uf);
                            
                        }
                    }
                }
            
          
            },
            mtdrotinacorrecaonf(nf){
                let vself = this;
                $('#mdmenunf').modal('hide'); 
                if (!util.opcaousuario('020Z.020Z.100Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                     
                    let loader  = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',                   valor : 'pegalayoutxml'},
                        {parametro: 'idfilial',             valor : vself.$store.state.filialpadrao.codfil},
                        {parametro: 'idnf',                 valor : nf.id}
                    ];                    
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                    retorno.then(function (response) {
                        loader.hide();                          
                        let ret = response.data;                                      
                        console.log(ret);
                        vself.cnfcorrecao = nf;
                        vself.cchavenf    = '';
                        vself.clayoutxml  = ret.layoutxml;
                        $('#mdcorrecaonf').modal('show');
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    });                                                      
                }
            },
            mtdconfirmacorrecaonf(){
                let vself = this;
                if (vself.cchavenf === ''){
                    vself.$toastr.w('Chave deve ser informada!', 'Atenção!');    
                    $('#edcchavenf').focus();
                    return;
                }
                if (vself.clayoutxml === ''){
                    vself.$toastr.w('Layout do xml deve ser informado!', 'Atenção!');    
                    $('#txclayoutxml').focus();
                    return;
                }                    
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma correção da NF?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                setTimeout(function(){                                
                                    vself.mtdgravarcorrecaonf();
                                }, 200); 
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });                
            },
            mtdgravarcorrecaonf(){
                let vself  = this;
                $('#mdcorrecaonf').modal('hide');
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'correcaonf'},
                    {parametro: 'idnf',     	valor : vself.cnfcorrecao.id},
                    {parametro: 'nnf',     	    valor : vself.cnfcorrecao.nnf},
                    {parametro: 'filialnf',     valor : vself.cnfcorrecao.idfilial},
                    {parametro: 'serie',     	valor : vself.cnfcorrecao.serie},
                    {parametro: 'modelo',     	valor : vself.cnfcorrecao.modelo},
                    {parametro: 'chave',     	valor : vself.cchavenf},
                    {parametro: 'layoutxml',    valor : vself.clayoutxml},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.020Z.100Z'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Correção realizada com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.psituacaopesq = 99;
                    vself.pnnf          = vself.cnfcorrecao.nnf;
                    vself.pidfilial     = vself.cnfcorrecao.idfilial;
                    var deffilial       = new Option(vself.cnfcorrecao.fantasiafil, vself.cnfcorrecao.idfilial, true, true);
                    $('#cbfilialpesq').append(deffilial).trigger('change');
                    vself.pqtd_paginas  = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarreganotasfiscais(1, '');                            
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdmarcartodos(){
                if (this.lstpedidosagrupar.length > 0){
                    util.marcartodas(this.lstpedidosagrupar, 'selecionado');
                }
            },
            mtdhabilita(index){
                if (this.lstpedidosagrupar.length > 0){
                    util.habilita(this.lstpedidosagrupar, 'selecionado', index);
                }
            },            
            mtdagruparpedidosnf(){
                if (!util.opcaousuario('020Z.020Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    $('#mdagruparpedidos').modal('show');
                }
            },
            mtdconfirmaagrupamento(){
                let vself = this;

                if (vself.aidfilialnf === null){
                    vself.$toastr.w('Filial para geração da NF deve ser informada!', 'Atenção!');
                    $('#cbfilialnf').select2('open');
                    return;                    
                }

                let temselecionado = false;
                for (let i = 0; i < vself.lstpedidosagrupar.length; i++) {
                    if (parseInt(vself.lstpedidosagrupar[i].selecionado) === 1){
                        temselecionado = true;
                        break;
                    }
                }
                if (!temselecionado){
                    vself.$toastr.w('Selecione ao menos um pedido para geração da NF!', 'Atenção!');
                    return;
                }                

                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma inclusão da NF dos pedidos agrupados?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdgerarnfagrupada();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });                                
            },
            mtdgerarnfagrupada(){
                let vself   = this;
                let loader  = vself.$loading.show();

                let pedidos = '';
                for (let i = 0; i < vself.lstpedidosagrupar.length; i++) {
                    if (parseInt(vself.lstpedidosagrupar[i].selecionado) === 1){
                        pedidos = pedidos+', '+vself.lstpedidosagrupar[i].id;
                    }
                }

                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'gerarnfagrupada'},
                    {parametro: 'pedidos',     	valor : pedidos.substring(2)},
                    {parametro: 'modelo',     	valor : vself.amodelo},
                    {parametro: 'idfilialnf',   valor : vself.aidfilialnf},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.020Z.040Z'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Nota gerada com sucesso!', 'Informação!');
                        vself.psituacaopesq = 99;
                        vself.pconteudo             = '';
                        vself.pqtd_paginas          = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarreganotasfiscais(1, ' and nf.id='+response.data);                        
                        $('#mdagruparpedidos').modal('hide');
                    }else{
                        $('#mdagruparpedidos').modal('hide');
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                                
            },
			mtddetalhespedido(idpedido){
                this.vidpedidodet = 0;
                this.vidpedidodet = idpedido;
                $('#mddetalhespedido').modal('show');
			},       
            mtdfiltropesquisapedgr(){
                let rfiltro = '';
                //Filtra somente os faturados
                rfiltro = rfiltro + ' and p.stpedido=1 and p.idnotafiscal=0  and p.tipo <> 3 ';

				if (this.aidfilial !== ''){
					rfiltro = rfiltro + ' and p.idfilial='+this.aidfilial;
				}
				if (this.aidcliente !== null){
					rfiltro = rfiltro + ' and p.idcliente='+this.aidcliente;
				}

                if (this.adtpor == '0'){
                    rfiltro = rfiltro + ' and p.dtemissao between "' + util.InverterData(this.adtini) + '" and "' + util.InverterData(this.adtfim) + '"';
                } else {
                    rfiltro = rfiltro + ' and p.dtfatura between "' + util.InverterData(this.adtini) + ' 00:00:00" and "' + util.InverterData(this.adtfim) + ' 23:59:59"';
                }

                return rfiltro;
            },            
            mtdpesquisarpedidosagr(){
                let vself = this;
                if (vself.aidfilial === null){
                    vself.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    $('#cbfilialagr').select2('open');
                    return;
                }                
                if (vself.aidcliente === null){
                    vself.$toastr.w('Cliente deve ser informado!', 'Atenção!');
                    $('#cbclienteagr').select2('open');
                    return;
                }
                let loader      = this.$loading.show();
				let filtro          = vself.mtdfiltropesquisapedgr();
                let parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : '99999999999'},
                        {parametro: 'offset',       valor : '0'}
                    ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    vself.lstpedidosagrupar = [];
                    let lstmp = JSON.parse(JSON.stringify(response.data.pedidos));                    
                    for (let i = 0; i < lstmp.length; i++) {
                        lstmp[i].selecionado = 0;                        
                    }
                    vself.lstpedidosagrupar = JSON.parse(JSON.stringify(lstmp));
                    loader.hide();											
                }).catch(function (response) {
                    vself.lstpedidosagrupar = [];
                    loader.hide();
                });
            },
            DefineValoresPadroesIBSCBS(vswitch, imposto) {
                // se for false, retorna e não busca o valor padrão
                if (!vswitch) { return; }
                if (this.vcClassTrib === '' || this.vCstIBSCBS === '') {
                    this.$toastr.w('Para importar os valores padrão, é necessário selecionar a Classe Tributária e o CST!', 'Atenção!');
                    
                    switch (imposto) {
                        case 'IBSUF':
                            this.swValPadroesIBSUF = false;
                            break;
                        case 'IBSMUN':
                            this.swValPadroesIBSMun = false;
                            break;
                        case 'CBS':
                            this.swValPadroesCBS = false;
                            break;
                    }
                    return;
                }

                let vself = this;
                vself.loader = vself.$loading.show();
                //carrega os grupos de tributação do CBS
                let parametros  = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'carregavalorespadroesibscbs'},
                    {parametro: 'cst',          valor : vself.vCstIBSCBS},
                    {parametro: 'cclasstrib',   valor : vself.vcClassTrib}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                retorno.then(function (response) {
                    if (response.data.inf == 1) {
                        switch (imposto) {
                            case 'IBSUF':
                                // IBS Estadual
                                vself.vAliqIBSUF           = response.data.campos.gIBSUF_pIBSUF;
                                vself.vAliqRedIBSUF        = response.data.campos.gIBSUF_pRed;
                                vself.vAliqDifIBSUF        = 0;
                                break;
                            case 'IBSMUN':
                                // IBS Municipal
                                vself.vAliqIBSMun          = response.data.campos.gIBSMun_pIBSMun;
                                vself.vAliqRedIBSMun       = response.data.campos.gIBSMun_pRed;
                                vself.vAliqDifIBSMun       = 0;
                                break;
                            case 'CBS':
                                // CBS
                                vself.vAliqCBS             = response.data.campos.gCBS_pCBS;
                                vself.vAliqRedCBS          = response.data.campos.gCBS_pRed;
                                vself.vAliqDifCBS          = 0;
                                break;
                        }
                        vself.$toastr.s('Valores padrão carregados com sucesso!', 'Informação!');
                    } else {
                        switch (imposto) {
                            case 'IBSUF':
                                // IBS Estadual
                                vself.vAliqIBSUF           = 0;
                                vself.vAliqRedIBSUF        = 0;
                                vself.vAliqDifIBSUF        = 0;
                                vself.swValPadroesIBSUF    = false;
                                break;
                            case 'IBSMUN':
                                // IBS Municipal
                                vself.vAliqIBSMun          = 0;
                                vself.vAliqRedIBSMun       = 0;
                                vself.vAliqDifIBSMun       = 0;
                                vself.swValPadroesIBSMun   = false;
                                break;
                            case 'CBS':
                                // CBS
                                vself.vAliqCBS             = 0;
                                vself.vAliqRedCBS          = 0;
                                vself.vAliqDifCBS          = 0;
                                vself.swValPadroesCBS      = false;
                                break;
                        }
                        vself.$toastr.i('Não foi possível carregar os valores padrão!', 'Informação!');
                    }

                    vself.loader.hide();
                }).catch(function () {
                    switch (imposto) {
                        case 'IBSUF':
                            // IBS Estadual
                            vself.vAliqIBSUF           = 0;
                            vself.vAliqRedIBSUF        = 0;
                            vself.vAliqDifIBSUF        = 0;
                            vself.swValPadroesIBSUF    = false;
                            break;
                        case 'IBSMUN':
                            // IBS Municipal
                            vself.vAliqIBSMun          = 0;
                            vself.vAliqRedIBSMun       = 0;
                            vself.vAliqDifIBSMun       = 0;
                            vself.swValPadroesIBSMun   = false;
                            break;
                        case 'CBS':
                            // CBS
                            vself.vAliqCBS             = 0;
                            vself.vAliqRedCBS          = 0;
                            vself.vAliqDifCBS          = 0;
                            vself.swValPadroesCBS      = false;
                            break;
                    }

                    vself.$toastr.s('Falha ao importar valores padrão!', 'Informação!');
                    vself.loader.hide();
                });
            },
            CarregaListaCstClassTribIBSCBS(resetaLstCst = true){
                // Carrega a lista de CST e Classe Tributária do IBS e CBS
                // O parametro resetaLstCst indica se deve resetar a lista de CST, para evitar onchanges desnecessários - Rodrigo 20-12-25

                let vself = this;
                //carrega os grupos de tributação do CBS
                let parametros  = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'carregacstcbs'}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                retorno.then(function (response) {
                    if (resetaLstCst){
                        vself.lstCstsIBSCBS = response.data.csts;
                    }
                    // Carrega lista de classes tributárias do IBS e CBS
                    vself.lstcClassTribs = response.data.classtribs;
                    vself.lstcClassTribCompleta = response.data.classtribs;

                    // Carrega lista de classes tributárias regular do IBS e CBS
                    vself.lstcClassTribsReg = response.data.classtribs;
                    vself.lstcClassTribsRegCompleta = response.data.classtribs;
                }).catch(function () {
                    vself.lstCstsIBSCBS = [];
                    vself.lstcClassTribs = [];
                    vself.lstcClassTribCompleta = [];
                    vself.lstcClassTribsReg = [];
                    vself.lstcClassTribsRegCompleta = [];
                });
            },
            SelecionarCamposGrupoFiscalIBSCBS(tptrib, idgrupo){
                let vself       = this;
                // Retira a opção de valores padrões
                vself.swValPadroesIBSUF   = false;
                vself.swValPadroesIBSMun  = false;
                vself.swValPadroesCBS     = false;

                if (tptrib === 'cClassTrib') {
                    vself.SelecionarcClassTribIBSCBS(idgrupo);
                } else {
                    vself.SelecionarCstIBSCBS(idgrupo);
                }    
            },
            SelecionarCstIBSCBS(idgrupo){
                // Faz um laço na lista lstcClassTribs, e traz todos os itens que tenham o idgrupo igual ao passado - Rodrigo 20-12-25
                this.lstcClassTribs  = this.lstcClassTribCompleta.filter(function(item){
                    return item.idgrupo === idgrupo;
                });
                if (this.vCstIBSCBS == ''){
                    this.lstcClassTribs = this.lstcClassTribCompleta;
                    this.vcClassTrib = '';
                }

                if (this.vcClassTrib){
                    this.vcClassTrib    = this.lstcClassTribs[0].codigo;
                    this.vcClassTrib = '';
                }
            },
            SelecionarcClassTribIBSCBS(idgrupo){
                // faz um laço na lista lstcClassTribs, e traz todos os itens que tenham o idgrupo igual ao passado
                // encontra o indice do cst para o classtrib selecionado
                let ind = util.getArrayIndexForKey(this.lstcClassTribs, 'codigo', idgrupo);
                if (ind >= 0) {
                    let ind2 = util.getArrayIndexForKey(this.lstCstsIBSCBS, 'codigo', this.lstcClassTribs[ind].idgrupo);
                    this.vCstIBSCBS  = this.lstCstsIBSCBS[ind2].codigo;
                }
            },
            SelecionarCamposGrupoFiscalIBSCBSReg(tptrib, idgrupo){
                let vself       = this;
                // Zera campos trib regular

                if (tptrib === 'cClassTrib') {
                    vself.SelecionarcClassTribIBSCBSReg(idgrupo);
                } else {
                    vself.SelecionarCstIBSCBSReg(idgrupo);
                }        
            },
            SelecionarcClassTribIBSCBSReg(idgrupo){
                // faz um laço na lista lstcClassTribs, e traz todos os itens que tenham o idgrupo igual ao passado
                // encontra o indice do cst para o classtrib selecionado
                let ind = util.getArrayIndexForKey(this.lstcClassTribsReg, 'codigo', idgrupo);
                if (ind >= 0) {
                    let ind2 = util.getArrayIndexForKey(this.lstCstsIBSCBS, 'codigo', this.lstcClassTribsReg[ind].idgrupo);
                    this.vCstIBSCBSReg  = this.lstCstsIBSCBS[ind2].codigo;
                }
            },
            SelecionarCstIBSCBSReg(idgrupo){
                // Faz um laço na lista lstcClassTribs, e traz todos os itens que tenham o idgrupo igual ao passado - Rodrigo 20-12-25
                this.lstcClassTribsReg  = this.lstcClassTribsRegCompleta.filter(function(item){
                    return item.idgrupo === idgrupo;
                });
                if (this.vCstIBSCBSReg == ''){
                    this.lstcClassTribsReg = this.lstcClassTribsRegCompleta;
                    this.vcClassTribReg = '';
                }

                if (this.vcClassTribReg){
                    this.vcClassTribReg = this.lstcClassTribsReg[0].codigo;
                    this.vcClassTribReg = '';
                }
            },
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself           = this;
                vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
                let loader          = vself.$loading.show();
                let parametros = [
                    {parametro: 'op',           valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario',    valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.alterafilialnf			= util.opcaousuario('020Z.010Z.068Z', vself.$store.state.perfilusuario);
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                                            position: 'bottom-end',
                                            //icon: 'success',
                                            title: 'Atenção!',
                                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                            showConfirmButton: false,
                                            showCloseButton: true,
                                            backdrop: false                                                
                                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }                     
	                    if (util.opcaousuario('020Z.020Z', vself.$store.state.perfilusuario)) {
	                        $('#pnlista').fadeIn(700);
	                        vself.mtdselect2_def();
                        
	                        if(parseInt(vself.$route.params.pendentes) === 1){
	                            vself.psituacaopesq  = 6;
	                            vself.pfiltroperiodo = 0;
	                            vself.pidfilial      = null;
	                            $('#cbfilialpesq').val(null).trigger('change');
                            vself.ptpemis        = 2;
                        }
	                       // console.log(vself.$route.params);
	                        vself.mtdexecutapesquisa();
	                        setTimeout(function(){
	                            util.transformartabssanfona(vself);
	                        }, 180);
	                        
	                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });

                // rotinas exportxmls - guga
                
                let dataAtual = new Date();
                let mesatual  = dataAtual.getMonth();
                this.anoAtual = dataAtual.getFullYear();
                
                this.anoselect = parseInt(this.anoAtual);
                this.messelect = parseInt(mesatual);

 
                for (let index = 0; index < 20; index++) {// cria uma lista de anos a partir da data atual - guga
                    if(index===0){
                        this.anoslista[index] = parseInt(this.anoAtual)
                    }else{
                        this.anoslista[index] = this.anoslista[index - 1] - 1;
                    }
                }



            }
        },
        computed:{
            validou() {
                return this.vidfilial === null || this.viddestinatario === null || this.vnatope === '' || this.lstitensnf.length === 0 || this.vidnatop === null;
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
			selecionaperiodo: function () {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            },
            
            verificalibera() {
                if (this.opcrud !== 2) {
                    if(util.opcaousuario('020Z.020Z', this.$store.state.perfilusuario)){
                        return true;
                    }
                }
                    return false;
            },
            camposCstIBSCBS() {
                if (this.vCstIBSCBS == '') {
                    return {}
                }
                let cstSelecionado = this.lstCstsIBSCBS.find(cst => cst.codigo === this.vCstIBSCBS);
                if (!cstSelecionado) {
                    this.$toastr.w('Erro ao habilitar os campos necessários para o CST selecionado.', 'Atenção!');
                    return {}
                }
                return cstSelecionado            
            },
            camposcClassTribIBSCBS() {
                if (this.vcClassTrib == '') {
                    return {}
                }
                let classTribSelecionado = this.lstcClassTribCompleta.find(classtrib => classtrib.codigo === this.vcClassTrib);
                if (!classTribSelecionado) {
                    this.$toastr.w('Erro ao habilitar os campos necessários para a Classe Tributária selecionada.', 'Atenção!');
                    return {}
                }
                return classTribSelecionado            
            },
        },
        watch:{
            vregimedi(val){
                if (parseInt(val) === 3){
                    this.lstcstdi = this.cstnormal;
                    this.vcstdi   = '00';
                }else{
                    this.lstcstdi = this.cstsimples;
                    this.vcstdi   = '101';
                }

            },
            valoresselecionados(newValues) {
                // // Verifica se apenas os valores 0 e 1 estão selecionados
                // const onlyZeroAndOneSelected = newValues.length === 2 && 
                //                                 newValues.includes('0') && 
                //                                 newValues.includes('1');

                // console.log(onlyZeroAndOneSelected);                              

                // if(onlyZeroAndOneSelected){
                //     //ativa o checkbox
                //     this.config.checkbox_rows = true;
                // }else{
                //     this.config.checkbox_rows = false;
                // }
            },
            pagina_atual(val){
                this.mtdcarreganotasfiscais(val, '');
            },
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddig = val;
					this.mtdlocalizarproduto(this.vcoddig);					
                }
			},  
			vvisualizarqtrib(val){
				this.columnsitensnf[11].visibility = val;
                this.columnsitensnf[12].visibility = val;
			},
            ativadesativa(val){
                if (val){
                    this.ativadesativaibsuf = true;
                    this.ativadesativaibsmun = true;
                    this.ativadesativalcbs = true;
                }
            },
            swValPadroesIBSUF(val){
                this.ativadesativaibsuf = val;
            },
            swValPadroesIBSMun(val){
                this.ativadesativaibsmun = val;
            },
            swValPadroesCBS(val){
                this.ativadesativacbs = val;
            },
            vcalctrib(novo) {

                for (let i = 0; i < this.lstitensnf.length; i++) {

                if (this.lstitensnf[i].vtottrib_calculado == null) {
                    this.lstitensnf[i].vtottrib_calculado = this.lstitensnf[i].vtottrib;
                }

                if (parseInt(novo) === 1) {
                    this.lstitensnf[i].vtottrib = this.lstitensnf[i].vtottrib_calculado;
                } else {
                    this.lstitensnf[i].vtottrib = 0;
                }

                }

                this.mtdtotalizarnota();
            }
        }
    }
</script>
<style>    
	.def-col-opcoes-nf{
		width: 70px !important;
	}   
    .def-col-nnf, .def-col-modelo, .def-col-serie{
        width: 80px !important;
    }
    .def-col-nnf{
        font-weight: bold;
        color: #6c757d!important;
    }
    .def-col-valor{
        font-weight: bold !important;
        color: #6c757d!important;
        width: 100px !important;
    }
    .def-col-dthremissao{
        width: 150px !important;
    }
    .def-col-situacaonota{
        width: 100px !important;
    }
    .def-col-xmotivo{
       width: 300px !important; 
    }
    .def-col-chave{
        width: 300px !important; 
    }
    .bdg-digitacao{
        background: #6BA2D0!important;        
    }
    .bdg-enviada{
        background: #EEA435!important;
        color: white;
    }
    .bdg-autorizada{
        background: #5A956A!important;
    }
    .bdg-cancelada{
        background: #cc330d!important;
    }
    .bdg-denegada{
        background: #7a240e!important;
    }
    .bdg-inutilizada{
        background: #6c757d!important;
    }
    .lbllacre{
        font-size: 10px;
    }
    .lstdettot{
        color: #666666!important;
        font-weight: bold;
        padding: 5px!important;
    }
    .bdg-totais{
        position: relative!important;
        float: right!important;
        font-size: 12px!important;
        width: 100px!important;
        text-align: right!important;
    }
    #tittotalizadores{        
        font-weight: bold;
        margin-bottom: 0px;
        font-size: 14px;        
    }
    #pcondusucarta{
        background: #f7f7f7;
        text-indent: 1.5em;
        padding: 15px;
        border: 1px solid #ced4da;
        border-radius: 5px;        
    }
    #tblistainut .thead-dark th {
        color: #cccccc!important;
    }
</style>
